const totalDamage = [
  {
    "1001": 26788100,
    "1003": 54686000,
    "1005": 2594000,
    "1007": 16973750,
    "1009": 33177500,
    "1011": 5939000,
    "1013": 5315500,
    "1015": 131719500,
    "1017": 8849000,
    "1019": 23633000,
    "1021": 4145000,
    "1023": 20430750,
    "1025": 7482500,
    "1027": 2806000,
    "1029": 4431100,
    "1031": 373185250,
    "1033": 17061150,
    "1035": 5201500,
    "1037": 1748100,
    "1039": 34407500,
    "1041": 5874000,
    "1043": 37100600,
    "1045": 266176750,
    "1047": 32366000,
    "1049": 23262200,
    "1051": 65393900,
    "1053": 11303500,
    "1055": 25560500,
    "1057": 17027000,
    "1059": 54256700,
    "1061": 44734720,
    "1063": 23199300,
    "1065": 30709500,
    "1067": 34671430,
    "1069": 189400260,
    "1071": 9802900,
    "1073": 1984904100,
    "1075": 9417000,
    "1077": 11417300,
    "1079": 47926800,
    "1081": 14864500,
    "1083": 1013028000,
    "1085": 9067000,
    "1087": 2813500,
    "1089": 24999400,
    "1091": 53616500,
    "1093": 189216750,
    "1095": 24002000,
    "1097": 49063500,
    "1099": 4680000,
    "1101": 32500500,
    "1103": 15119100,
    "1105": 12801000,
    "1107": 14659000,
    "1109": 7675750,
    "1111": 5395000,
    "1113": 2959250,
    "1115": 208779500,
    "1117": 19294750,
    "1119": 31258000,
    "1121": 10927000,
    "1123": 119709800,
    "1125": 1562836000,
    "1127": 145010500,
    "1129": 13653500,
    "1131": 2639500,
    "1133": 19814000,
    "2013": 434600,
    "2016": 26154000,
    "2020": 34318233.333333336,
    "2050": 6591583.333333333,
    "2060": 427333.3333333333,
    "2068": 5223183.333333333,
    "2070": 427333.3333333333,
    "2090": 8722433.333333334,
    "2100": 704000,
    "2110": 3811000,
    "2122": 32917716.666666664,
    "2130": 2602000,
    "2150": 3426733.3333333335,
    "2164": 3831333.3333333335,
    "2170": 7172083.333333333,
    "2180": 89425386.66666667,
    "2185": 31951466.666666668,
    "2188": 1327300.0000000002,
    "2201": 0,
    "2220": 14782800,
    "2232": 0,
    "2240": 2336833.3333333335,
    "2261": 8243066.666666666,
    "2270": 0,
    "2280": 0,
    "2282": 4630000,
    "2290": 15250999.999999998,
    "4001": 58540833.333333336,
    "4003": 28215916.666666664,
    "4005": 109544633.33333333,
    "4007": 7833000,
    "4009": 9658583.333333334,
    "4011": 765500,
    "4012": 13438000,
    "4013": 3268770000,
    "4015": 32715100,
    "4017": 108922333.33333334,
    "4019": 200343133.33333334,
    "4021": 22824433.333333332,
    "4023": 30285383.333333332,
    "4025": 40548500,
    "4027": 15006500,
    "5001": 89897000,
    "5003": 26792300,
    "5005": 136710000,
    "5007": 95521800,
    "5009": 113509000,
    "5011": 10249000,
    "5013": 11698000,
    "5015": 37475600,
    "5017": 27936300,
    "5019": 139870350,
    "5021": 31465570,
    "5023": 103537000,
    "5025": 10469000,
    "5027": 215012000,
    "5029": 62696000,
    "5031": 18305990,
    "5033": 159710200,
    "5035": 14392680,
    "5037": 12808170,
    "5039": 14000000,
    "5041": 54869000,
    "5043": 10344000,
    "5045": 313691500,
    "5047": 12221500,
    "5049": 115985100,
    "5051": 79840350,
    "5053": 16097000,
    "5055": 47816860,
    "5057": 85747000,
    "5059": 25168000,
    "5061": 88783500,
    "5063": 143337000,
    "5065": 144209000,
    "5067": 124789000,
    "5069": 25119500,
    "5071": 78690300,
    "5073": 83860000,
    "5075": 26583610,
    "5077": 1061780,
    "5079": 8822000,
    "5081": 83910000,
    "5083": 52271200,
    "5085": 63169200,
    "5087": 37118300,
    "5089": 131974000,
    "5091": 174130100,
    "5093": 6601820,
    "5095": 46246000,
    "5097": 23657250,
    "5099": 83996600,
    "5101": 15660900,
    "5103": 16334100,
    "5105": 38567000,
    "5107": 4511650,
    "5109": 8838500,
    "5111": 10425800,
    "5113": 155108500,
    "5115": 85910150,
    "5117": 47533100,
    "5119": 560152300,
    "5121": 36685630,
    "5123": 9806370,
    "5125": 115860500,
    "5127": 42814000,
    "5129": 113970700,
    "5131": 177555300,
    "5133": 417513100,
    "5135": 169886000,
    "5137": 150053100,
    "5139": 90085500,
    "5141": 106160000,
    "5143": 165533100,
    "5145": 73254450,
    "5147": 37376600,
    "5149": 39218700,
    "6001": 42960843.33333334,
    "6003": 253173411.11111113,
    "6005": 8895368.253968254,
    "6007": 11899220266.666668,
    "6009": 11015235.396825396,
    "6011": 49275133.333333336,
    "6013": 62283833.333333336,
    "6015": 24013800,
    "6017": 286980268.2539681,
    "6019": 22186500,
    "6021": 25448133.333333332,
    "6023": 40781100,
    "6025": 6724000,
    "6027": 79860000,
    "6029": 61844700,
    "6031": 1665690,
    "6033": 47721800,
    "6035": 7277333.333333335,
    "6037": 259910000,
    "6039": 8598500,
    "6041": 245920899.99999997,
    "6043": 17718800,
    "6045": 111734000,
    "6047": 24128500,
    "6049": 666596400,
    "6051": 12074400,
    "6053": 121035560,
    "6055": 135798300,
    "6057": 262247458.73015875,
    "6059": 200859266.6666667,
    "6061": 266212268.2539683,
    "6063": 28291433.333333336,
    "6065": 281542666.6666666,
    "6067": 18934839.523809522,
    "6069": 96000,
    "6071": 1916667700,
    "6073": 2957749066.6666665,
    "6075": 57714060,
    "6077": 9990066.666666668,
    "6079": 13290000,
    "6081": 35730020,
    "6083": 80682000,
    "6085": 31405843.333333332,
    "6087": 119647010.00000001,
    "6089": 12925726733.333334,
    "6091": 11558844.444444446,
    "6093": 184400000,
    "6095": 23952809.523809522,
    "6097": 240404699.99999997,
    "6099": 4918010,
    "6101": 8603476.190476192,
    "6103": 13435298733.333334,
    "6105": 9550000,
    "6107": 98714030,
    "6109": 55806225.396825396,
    "6111": 25700000,
    "6113": 5897142.857142857,
    "6115": 28119158.730158735,
    "8001": 449798400,
    "8003": 4988857.142857143,
    "8005": 1089889066.6666667,
    "8007": 3828121.428571429,
    "8009": 2863500,
    "8011": 8016000,
    "8013": 561254000,
    "8014": 23710400.000000004,
    "8015": 5002857.142857144,
    "8017": 2998600,
    "8019": 21986000,
    "8021": 15423333.333333334,
    "8023": 44939523.809523806,
    "8025": 10041000,
    "8027": 12791857.142857142,
    "8029": 4271566.666666666,
    "8031": 167358400,
    "8033": 493821.4285714285,
    "8035": 59020066.66666667,
    "8037": 14573900,
    "8039": 11471666.666666668,
    "8041": 2681282966.666667,
    "8043": 28128523.80952381,
    "8045": 24463133.333333336,
    "8047": 22230000,
    "8049": 205000,
    "8051": 455499.9999999999,
    "8053": 229371.42857142855,
    "8055": 36967523.809523806,
    "8057": 5000,
    "8059": 2838508000.0000005,
    "8061": 358000,
    "8063": 3810450,
    "8065": 15000,
    "8067": 20121271.42857143,
    "8069": 566582000,
    "8071": 26980666.666666664,
    "8073": 5165000,
    "8075": 23766500,
    "8077": 4946383.333333334,
    "8079": 136666.6666666667,
    "8081": 417033.3333333334,
    "8083": 2667071.428571428,
    "8085": 818150.0000000001,
    "8087": 37185000,
    "8089": 778000,
    "8091": 2287900,
    "8093": 21797000,
    "8095": 3358000,
    "8097": 13676200,
    "8099": 11010000,
    "8101": 142936000,
    "8103": 1690549.9999999993,
    "8105": 22581666.666666668,
    "8107": 1215533.3333333335,
    "8109": 5325190.476190477,
    "8111": 62571.42857142857,
    "8113": 1121221.4285714289,
    "8115": 1742000,
    "8117": 225000,
    "8119": 13995666.666666666,
    "8121": 15935000,
    "8123": 411611000,
    "8125": 7730500,
    "9001": 37094000,
    "9003": 125132300,
    "9005": 10420500,
    "9007": 2155250,
    "9009": 18219800,
    "9011": 12214300,
    "9013": 59193900,
    "9015": 47408500,
    "10001": 31425540,
    "10003": 67899610,
    "10005": 149075890,
    "11001": 295961200,
    "12001": 1863610,
    "12003": 5656000,
    "12005": 13962776250,
    "12007": 12266700,
    "12009": 1516551650,
    "12011": 618644200,
    "12013": 1220163700,
    "12015": 85549000,
    "12017": 224504000,
    "12019": 3558300,
    "12021": 481936190,
    "12023": 4763900,
    "12027": 783929000,
    "12029": 198639500,
    "12031": 26422320,
    "12033": 184525000,
    "12035": 155771300,
    "12037": 672088250,
    "12039": 608437000,
    "12041": 12311410,
    "12043": 15163000,
    "12045": 933445000,
    "12047": 1982500,
    "12049": 387647500,
    "12051": 7926500,
    "12053": 28868000,
    "12055": 1829298000,
    "12057": 72677950,
    "12059": 27696250,
    "12061": 2108009500,
    "12063": 1175555750,
    "12065": 10609750,
    "12067": 9414950,
    "12069": 210105900,
    "12071": 1176053500,
    "12073": 401959750,
    "12075": 7435000,
    "12077": 906016000,
    "12079": 12844500,
    "12081": 69763500,
    "12083": 4128350,
    "12085": 2051323700,
    "12086": 1678126000,
    "12087": 883241000,
    "12089": 29960400,
    "12091": 16576500,
    "12093": 350427700,
    "12095": 2122300300,
    "12097": 1037265000,
    "12099": 22523390500,
    "12101": 144362500,
    "12103": 1420564250,
    "12105": 2231577500,
    "12107": 8897100,
    "12109": 4011525320,
    "12111": 5193178000,
    "12113": 26333500,
    "12115": 53628000,
    "12117": 1297615000,
    "12119": 131392000,
    "12121": 14443550,
    "12123": 40442330,
    "12125": 2826400,
    "12127": 2894701000,
    "12129": 671817800,
    "12131": 335583230,
    "12133": 560388250,
    "13001": 4428400,
    "13003": 328500,
    "13005": 3935000,
    "13007": 113015100,
    "13009": 9848700,
    "13011": 6029280,
    "13013": 13504530,
    "13015": 95944230,
    "13017": 3315500,
    "13019": 4186250,
    "13021": 19894300,
    "13023": 1897250,
    "13025": 282000,
    "13027": 5684500,
    "13029": 4167500,
    "13031": 3144850,
    "13033": 4761870,
    "13035": 4374780,
    "13037": 107449000,
    "13039": 6304000,
    "13043": 1118500,
    "13045": 72798830,
    "13047": 31672980,
    "13049": 448000,
    "13051": 56688200,
    "13053": 1493000,
    "13055": 18814130,
    "13057": 175991180,
    "13059": 8221830,
    "13061": 4299700,
    "13063": 47815630,
    "13065": 570650,
    "13067": 116777530,
    "13069": 4041400,
    "13071": 16138800,
    "13073": 3896660,
    "13075": 5828920,
    "13077": 28628180,
    "13079": 3580750,
    "13081": 5082950,
    "13083": 30362030,
    "13085": 8985230,
    "13087": 657513700,
    "13089": 88479780,
    "13091": 5774500,
    "13093": 13092200,
    "13095": 1162141500,
    "13097": 53086130,
    "13099": 309698000,
    "13101": 120200,
    "13103": 7313350,
    "13105": 2067500,
    "13107": 3845250,
    "13109": 144000,
    "13111": 41763240,
    "13113": 35091780,
    "13115": 45318580,
    "13117": 43119350,
    "13119": 2560000,
    "13121": 207567760,
    "13123": 18703830,
    "13125": 1229250,
    "13127": 961200,
    "13129": 36922130,
    "13131": 135833700,
    "13133": 6631130,
    "13135": 151628630,
    "13137": 5627500,
    "13139": 39123280,
    "13141": 2314080,
    "13143": 10013830,
    "13145": 12129300,
    "13147": 1663500,
    "13149": 7210830,
    "13151": 107816580,
    "13153": 8027000,
    "13155": 4414500,
    "13157": 9707330,
    "13159": 2547980,
    "13161": 245000,
    "13163": 8728250,
    "13165": 1570500,
    "13167": 26074750,
    "13169": 2804980,
    "13171": 11712730,
    "13173": 4849000,
    "13175": 15782250,
    "13177": 16702700,
    "13179": 58984950,
    "13181": 1221010,
    "13183": 4736050,
    "13185": 33125000,
    "13187": 7600530,
    "13189": 3153000,
    "13191": 18741550,
    "13193": 1866650,
    "13195": 8041530,
    "13197": 970620,
    "13199": 14760580,
    "13201": 512704750,
    "13205": 133648000,
    "13207": 11136580,
    "13209": 1115200,
    "13211": 15282080,
    "13213": 5366230,
    "13215": 40967450,
    "13217": 12411980,
    "13219": 5085880,
    "13221": 4313630,
    "13223": 25368030,
    "13225": 5866000,
    "13227": 22810680,
    "13229": 460900,
    "13231": 4015780,
    "13233": 18645280,
    "13235": 2860000,
    "13237": 4827300,
    "13239": 1295750,
    "13241": 19673500,
    "13243": 4312050,
    "13245": 8625600,
    "13247": 17893930,
    "13249": 1369950,
    "13251": 1461500,
    "13253": 620845750,
    "13255": 32677530,
    "13257": 6138500,
    "13259": 1030500,
    "13261": 115596000,
    "13263": 1549200,
    "13265": 2645430,
    "13267": 2479250,
    "13269": 3632850,
    "13271": 1587600,
    "13273": 34223000,
    "13275": 27632450,
    "13277": 7908000,
    "13279": 2775250,
    "13281": 6106590,
    "13283": 1637800,
    "13285": 34093780,
    "13287": 13529500,
    "13289": 7284300,
    "13291": 5308430,
    "13293": 7330330,
    "13295": 20935090,
    "13297": 9693030,
    "13299": 2790200,
    "13301": 2607080,
    "13303": 1725850,
    "13305": 541100,
    "13307": 1594750,
    "13309": 1039900,
    "13311": 21502790,
    "13313": 8612570,
    "13315": 3047200,
    "13317": 6757430,
    "13319": 1736050,
    "13321": 41258500,
    "15001": 107941000,
    "15003": 85445400,
    "15005": 0,
    "15007": 54820000,
    "15009": 3656000,
    "16001": 7924333.333333334,
    "16003": 160000,
    "16005": 6770400,
    "16007": 1150900,
    "16009": 6077950,
    "16011": 8591566.666666666,
    "16013": 16151500,
    "16015": 207666.6666666667,
    "16017": 22552566.666666664,
    "16019": 30582266.666666664,
    "16021": 15365566.666666666,
    "16023": 561000,
    "16025": 6666.666666666667,
    "16027": 42090000,
    "16029": 774666.6666666667,
    "16031": 5924000,
    "16033": 785000,
    "16035": 21041300,
    "16037": 5270000,
    "16039": 4040000,
    "16041": 1849600,
    "16043": 816300,
    "16045": 41011000,
    "16047": 35295333.33333333,
    "16049": 17440000,
    "16051": 3361000,
    "16053": 36193333.33333333,
    "16055": 31792666.66666666,
    "16057": 7312600,
    "16059": 89977000,
    "16061": 5913000,
    "16063": 3245000,
    "16065": 2535000,
    "16067": 7170500,
    "16069": 13075500,
    "16071": 406500,
    "16073": 43841333.333333336,
    "16075": 41012000,
    "16077": 1102000,
    "16079": 4586050,
    "16081": 165000,
    "16083": 36238333.33333333,
    "16085": 25000,
    "16087": 42232000,
    "17001": 768000,
    "17003": 48464000,
    "17005": 376000,
    "17007": 3529500,
    "17009": 56000,
    "17011": 6281500,
    "17013": 437000,
    "17015": 17064900,
    "17017": 8883800,
    "17019": 128839000,
    "17021": 136197000,
    "17023": 4955800,
    "17025": 15450500,
    "17027": 849000,
    "17029": 22226500,
    "17031": 564366600,
    "17033": 6645500,
    "17035": 3278200,
    "17037": 15417000,
    "17039": 17568500,
    "17041": 107318000,
    "17043": 36304000,
    "17045": 4872500,
    "17047": 3501000,
    "17049": 4303400,
    "17051": 1838000,
    "17053": 2806000,
    "17055": 25694000,
    "17057": 27254500,
    "17059": 11485000,
    "17061": 1150000,
    "17063": 69192500,
    "17065": 5296000,
    "17067": 26852750,
    "17069": 23396000,
    "17071": 22411250,
    "17073": 90428820,
    "17075": 8941000,
    "17077": 122769000,
    "17079": 3434000,
    "17081": 20686000,
    "17083": 212000,
    "17085": 19841700,
    "17087": 18123000,
    "17089": 29555500,
    "17091": 9381500,
    "17093": 4182500,
    "17095": 48422000,
    "17097": 34904500,
    "17099": 96857000,
    "17101": 3861000,
    "17103": 2520500,
    "17105": 6618000,
    "17107": 23669500,
    "17109": 3972550,
    "17111": 9415500,
    "17113": 15023000,
    "17115": 38543000,
    "17117": 10379000,
    "17119": 11640500,
    "17121": 7623000,
    "17123": 20163500,
    "17125": 7640500,
    "17127": 59234000,
    "17129": 14912000,
    "17131": 35800600,
    "17133": 2075000,
    "17135": 186000,
    "17137": 159132500,
    "17139": 11118200,
    "17141": 12186000,
    "17143": 258769000,
    "17145": 7508000,
    "17147": 8525500,
    "17149": 1335000,
    "17151": 31599000,
    "17153": 40656000,
    "17155": 14049020,
    "17157": 131500,
    "17159": 1659000,
    "17161": 8591870,
    "17163": 1197400,
    "17165": 36878500,
    "17167": 79322500,
    "17169": 5860800,
    "17171": 1565500,
    "17173": 11965000,
    "17175": 15183000,
    "17177": 21140250,
    "17179": 1032056500,
    "17181": 15341000,
    "17183": 37812700,
    "17185": 9351000,
    "17187": 6932950,
    "17189": 1229000,
    "17191": 9463000,
    "17193": 15289000,
    "17195": 6971480,
    "17197": 43520500,
    "17199": 185151000,
    "17201": 42450500,
    "17203": 67012400,
    "18001": 11794000,
    "18003": 32241000,
    "18005": 254775550,
    "18007": 1169000,
    "18009": 615000,
    "18011": 6865700,
    "18013": 1060200,
    "18015": 25682900,
    "18017": 4155500,
    "18019": 99310000,
    "18021": 46077000,
    "18023": 19869500,
    "18025": 13944500,
    "18027": 39290520,
    "18029": 20792000,
    "18031": 4573950,
    "18033": 3365750,
    "18035": 39639600,
    "18037": 2345500,
    "18039": 17849200,
    "18041": 6600500,
    "18043": 41201500,
    "18045": 10963000,
    "18047": 8214000,
    "18049": 1353000,
    "18051": 26851000,
    "18053": 4643000,
    "18055": 26897450,
    "18057": 92200270,
    "18059": 8679000,
    "18061": 21941500,
    "18063": 6571690,
    "18065": 9288850,
    "18067": 103787200,
    "18069": 9925900,
    "18071": 42768250,
    "18073": 4495500,
    "18075": 3243500,
    "18077": 16583000,
    "18079": 3563950,
    "18081": 150364050,
    "18083": 34479200,
    "18085": 15506500,
    "18087": 6011500,
    "18089": 53571000,
    "18091": 5947000,
    "18093": 21043000,
    "18095": 43811700,
    "18097": 135243370,
    "18099": 3838000,
    "18101": 12245750,
    "18103": 9241000,
    "18105": 18517050,
    "18107": 6130000,
    "18109": 113719500,
    "18111": 3098000,
    "18113": 6947000,
    "18115": 4290000,
    "18117": 2951000,
    "18119": 63398050,
    "18121": 6920000,
    "18123": 5387000,
    "18125": 13585000,
    "18127": 24654500,
    "18129": 27228000,
    "18131": 1216000,
    "18133": 3916900,
    "18135": 2690000,
    "18137": 11018500,
    "18139": 2689350,
    "18141": 16456000,
    "18143": 1468000,
    "18145": 13567750,
    "18147": 23744000,
    "18149": 2349000,
    "18151": 11869000,
    "18153": 20086500,
    "18155": 7295200,
    "18157": 29552900,
    "18159": 5574100,
    "18161": 2759500,
    "18163": 117923000,
    "18165": 10316000,
    "18167": 59070550,
    "18169": 9047000,
    "18171": 5679500,
    "18173": 124089000,
    "18175": 10526500,
    "18177": 18749250,
    "18179": 10441600,
    "18181": 4150000,
    "18183": 2535500,
    "19001": 48601120,
    "19003": 37438720,
    "19005": 23609600,
    "19007": 37172860,
    "19009": 41119840,
    "19011": 22906620,
    "19013": 99114910.9090909,
    "19015": 42494720,
    "19017": 39254910.90909091,
    "19019": 22924000,
    "19021": 4528100,
    "19023": 125943910.9090909,
    "19025": 43035780,
    "19027": 47571580,
    "19029": 51865120,
    "19031": 22767600,
    "19033": 44644010.90909091,
    "19035": 3602100,
    "19037": 5772650,
    "19039": 36990960,
    "19041": 26461100,
    "19043": 39186150,
    "19045": 12039100,
    "19047": 53706340,
    "19049": 67772720,
    "19051": 51378860,
    "19053": 35635080,
    "19055": 74094300,
    "19057": 29092500,
    "19059": 23800100,
    "19061": 45675800,
    "19063": 40008710.90909091,
    "19065": 30126550,
    "19067": 8558100,
    "19069": 63953410.90909091,
    "19071": 16268000,
    "19073": 38362680,
    "19075": 38209810.90909091,
    "19077": 45861840,
    "19079": 50926920,
    "19081": 35889310.90909091,
    "19083": 61687720,
    "19085": 44127000,
    "19087": 10253800,
    "19089": 7151750,
    "19091": 41478080,
    "19093": 1562100,
    "19095": 17181000,
    "19097": 46896200,
    "19099": 44482220,
    "19101": 2460000,
    "19103": 330705300,
    "19105": 43465570,
    "19107": 6581700,
    "19109": 45407930.90909091,
    "19111": 41314200,
    "19113": 775318750,
    "19115": 40738200,
    "19117": 39283080,
    "19119": 17812100,
    "19121": 39257860,
    "19123": 49037940,
    "19125": 165771940,
    "19127": 243555220,
    "19129": 10012000,
    "19131": 13657150,
    "19133": 9829000,
    "19135": 38787580,
    "19137": 2859000,
    "19139": 33666700,
    "19141": 25083100,
    "19143": 25440100,
    "19145": 3983000,
    "19147": 35429130.90909091,
    "19149": 2889100,
    "19151": 50548980,
    "19153": 202367220,
    "19155": 39374000,
    "19157": 44165920,
    "19159": 49962580,
    "19161": 47761180,
    "19163": 17941600,
    "19165": 5477000,
    "19167": 28201100,
    "19169": 108468720,
    "19171": 42365720,
    "19173": 50507720,
    "19175": 45019460,
    "19177": 8688200,
    "19179": 46366860,
    "19181": 55220680,
    "19183": 39842500,
    "19185": 40199800,
    "19187": 50262720,
    "19189": 37313670.90909091,
    "19191": 18943400,
    "19193": 30868100,
    "19195": 36767080,
    "19197": 38451920,
    "20001": 11032550,
    "20003": 27911500,
    "20005": 1366500,
    "20007": 61270500,
    "20009": 130451250,
    "20011": 37636000,
    "20013": 3438100,
    "20015": 93251000,
    "20017": 8995700,
    "20019": 1669100,
    "20021": 41854200,
    "20023": 13993400,
    "20025": 8289800,
    "20027": 2057500,
    "20029": 2542000,
    "20031": 6629900,
    "20033": 61974500,
    "20035": 31843750,
    "20037": 23997250,
    "20039": 9150850,
    "20041": 24895100,
    "20043": 1195000,
    "20045": 28762000,
    "20047": 6954500,
    "20049": 28434750,
    "20051": 5408250,
    "20053": 28007700,
    "20055": 59692340,
    "20057": 11700340,
    "20059": 15009000,
    "20061": 2799700,
    "20063": 41391150,
    "20065": 49226200,
    "20067": 2023700,
    "20069": 7209600,
    "20071": 4070750,
    "20073": 78863400,
    "20075": 113000,
    "20077": 13556200,
    "20079": 14522900,
    "20081": 4914000,
    "20083": 3609400,
    "20085": 3145500,
    "20087": 9905500,
    "20089": 22507000,
    "20091": 23667200,
    "20093": 4057500,
    "20095": 35135400,
    "20097": 254665700,
    "20099": 79569800,
    "20101": 2494000,
    "20103": 25776400,
    "20105": 21797300,
    "20107": 7990200,
    "20109": 8446450,
    "20111": 11625100,
    "20113": 30966150,
    "20115": 75700550,
    "20117": 4873500,
    "20119": 3327000,
    "20121": 16491600,
    "20123": 11644000,
    "20125": 93761050,
    "20127": 1861500,
    "20129": 796600,
    "20131": 5194500,
    "20133": 21550900,
    "20135": 3383500,
    "20137": 62656400,
    "20139": 9901000,
    "20141": 9352000,
    "20143": 1618500,
    "20145": 4649100,
    "20147": 9642000,
    "20149": 2511800,
    "20151": 26981500,
    "20153": 1911550,
    "20155": 127805100,
    "20157": 10143000,
    "20159": 25573050,
    "20161": 97879950,
    "20163": 9776000,
    "20165": 5038500,
    "20167": 86419200,
    "20169": 40714000,
    "20171": 3147600,
    "20173": 917636150,
    "20175": 26989600,
    "20177": 30353900,
    "20179": 29557600,
    "20181": 16014500,
    "20183": 10826000,
    "20185": 877500,
    "20187": 200500,
    "20189": 1131500,
    "20191": 40324650,
    "20193": 12176200,
    "20195": 7907500,
    "20197": 1067400,
    "20199": 2162200,
    "20201": 8398000,
    "20203": 4256700,
    "20205": 24805900,
    "20207": 3921450,
    "20209": 28498500,
    "21001": 9514000,
    "21003": 1951000,
    "21005": 6789000,
    "21007": 85345000,
    "21009": 18025500,
    "21011": 30511400,
    "21013": 57585510,
    "21015": 30177750,
    "21017": 10163000,
    "21019": 17827800,
    "21021": 2689000,
    "21023": 4938000,
    "21025": 14544400,
    "21027": 4712000,
    "21029": 132716000,
    "21031": 2921000,
    "21033": 35721000,
    "21035": 47299000,
    "21037": 22846000,
    "21039": 29510000,
    "21041": 5424000,
    "21043": 37523000,
    "21045": 7215000,
    "21047": 135244000,
    "21049": 3072000,
    "21051": 4494610,
    "21053": 974500,
    "21055": 41516000,
    "21057": 726000,
    "21059": 174023000,
    "21061": 2888000,
    "21063": 1838100,
    "21065": 10517500,
    "21067": 54925000,
    "21069": 11741500,
    "21071": 26784300,
    "21073": 18216000,
    "21075": 32619000,
    "21077": 3555500,
    "21079": 2133000,
    "21081": 8369250,
    "21083": 72475000,
    "21085": 52212000,
    "21087": 2514000,
    "21089": 24902200,
    "21091": 924000,
    "21093": 38607500,
    "21095": 4612350,
    "21097": 11961500,
    "21099": 8915000,
    "21101": 88943000,
    "21103": 10372000,
    "21105": 26898000,
    "21107": 110148000,
    "21109": 1118000,
    "21111": 487410500,
    "21113": 2258500,
    "21115": 27166900,
    "21117": 60422100,
    "21119": 2070200,
    "21121": 9447000,
    "21123": 6135000,
    "21125": 53815810,
    "21127": 11287700,
    "21129": 7592000,
    "21131": 2189700,
    "21133": 2553200,
    "21135": 20521250,
    "21137": 3906000,
    "21139": 40445000,
    "21141": 4297000,
    "21143": 33388000,
    "21145": 117923000,
    "21147": 4245100,
    "21149": 47913000,
    "21151": 15283000,
    "21153": 36568000,
    "21155": 1600000,
    "21157": 79933000,
    "21159": 16674500,
    "21161": 8360500,
    "21163": 5819000,
    "21165": 9219200,
    "21167": 19306500,
    "21169": 9056000,
    "21171": 4632000,
    "21173": 6151420,
    "21175": 84683400,
    "21177": 78862000,
    "21179": 4915000,
    "21181": 1650000,
    "21183": 2465500,
    "21185": 5078000,
    "21187": 6217000,
    "21189": 4937000,
    "21191": 87352500,
    "21193": 4000880,
    "21195": 35778510,
    "21197": 23433060,
    "21199": 9641800,
    "21201": 1739000,
    "21203": 5057100,
    "21205": 2229000,
    "21207": 1885050,
    "21209": 5393000,
    "21211": 2487000,
    "21213": 1795000,
    "21215": 3832000,
    "21217": 4613000,
    "21219": 26469000,
    "21221": 25426000,
    "21223": 3278000,
    "21225": 34063000,
    "21227": 520056250,
    "21229": 2496000,
    "21231": 1895600,
    "21233": 59892000,
    "21235": 9955800,
    "21237": 3742100,
    "21239": 7168000,
    "22001": 545768000,
    "22003": 28968000,
    "22005": 1612656850,
    "22007": 76896300,
    "22009": 88757000,
    "22011": 87440000,
    "22013": 7373000,
    "22015": 46632800,
    "22017": 353852500,
    "22019": 2513260000,
    "22021": 9547000,
    "22023": 28805000,
    "22025": 21017750,
    "22027": 16620000,
    "22029": 51871700,
    "22031": 20739000,
    "22033": 2581528600,
    "22035": 726100500,
    "22037": 39491250,
    "22039": 183649000,
    "22041": 55845200,
    "22043": 4592000,
    "22045": 590108000,
    "22047": 46494750,
    "22049": 3608000,
    "22051": 4467745000,
    "22053": 148039000,
    "22055": 1692930000,
    "22057": 895354200,
    "22059": 11360000,
    "22061": 18682500,
    "22063": 2161619150,
    "22065": 48702500,
    "22067": 24285100,
    "22069": 27836500,
    "22071": 43215641550,
    "22073": 61330000,
    "22075": 14387642500,
    "22077": 63199850,
    "22079": 340585500,
    "22081": 9498000,
    "22083": 31482000,
    "22085": 15304500,
    "22087": 19345135900,
    "22089": 401598900,
    "22091": 60199350,
    "22093": 68903950,
    "22095": 626165700,
    "22097": 340410000,
    "22099": 388349000,
    "22101": 564151000,
    "22103": 11329677700,
    "22105": 1116330200,
    "22107": 32697000,
    "22109": 877354400,
    "22111": 14315500,
    "22113": 625879000,
    "22115": 62989000,
    "22117": 3753586050,
    "22119": 6440500,
    "22121": 31815750,
    "22123": 17107750,
    "22125": 35541500,
    "22127": 6230000,
    "23001": 70602400,
    "23003": 21830000,
    "23005": 161465500,
    "23007": 24148500,
    "23009": 30145500,
    "23011": 107187000,
    "23013": 13959000,
    "23015": 17088500,
    "23017": 79503900,
    "23019": 92051000,
    "23021": 5838500,
    "23023": 18462500,
    "23025": 30302400,
    "23027": 60837500,
    "23029": 36104500,
    "23031": 149799500,
    "24001": 17798080,
    "24003": 38012650,
    "24005": 680639333.3333335,
    "24009": 44992460,
    "24011": 12542600,
    "24013": 11448130,
    "24015": 17823800,
    "24017": 137028180,
    "24019": 9838000,
    "24021": 90233650,
    "24023": 7958000,
    "24025": 6408000,
    "24027": 36501250,
    "24029": 25043460,
    "24031": 19371600,
    "24033": 128896800,
    "24035": 85078270,
    "24037": 194291200,
    "24039": 14795000,
    "24041": 11603430,
    "24043": 43813840,
    "24045": 14894000,
    "24047": 27368000,
    "24510": 180274316.66666666,
    "25001": 34631740,
    "25003": 9721900,
    "25005": 69397060,
    "25007": 23178140,
    "25009": 93936150,
    "25011": 89995580,
    "25013": 276345060,
    "25015": 34369560,
    "25017": 106723530,
    "25019": 3154780,
    "25021": 130947230,
    "25023": 76126790,
    "25025": 70965080,
    "25027": 104419780,
    "26001": 605000,
    "26003": 643500,
    "26005": 48822500,
    "26007": 1009000,
    "26009": 1765000,
    "26011": 756000,
    "26013": 4943900,
    "26015": 41144500,
    "26017": 59242750,
    "26019": 1418000,
    "26021": 19082500,
    "26023": 1446000,
    "26025": 69796500,
    "26027": 8291500,
    "26029": 260000,
    "26031": 981500,
    "26033": 435300,
    "26035": 18423520,
    "26037": 35497700,
    "26039": 5407000,
    "26041": 3230200,
    "26043": 8946500,
    "26045": 95594500,
    "26047": 1206000,
    "26049": 114397000,
    "26051": 1056500,
    "26053": 45025500,
    "26055": 16741500,
    "26057": 30709500,
    "26059": 3087000,
    "26061": 104640500,
    "26063": 29343200,
    "26065": 71909500,
    "26067": 40414500,
    "26069": 600000,
    "26071": 6755500,
    "26073": 103650000,
    "26075": 33647000,
    "26077": 184290000,
    "26079": 2733000,
    "26081": 113434500,
    "26083": 1036000,
    "26085": 21933000,
    "26087": 54647500,
    "26089": 25754000,
    "26091": 57764500,
    "26093": 96355000,
    "26095": 25482000,
    "26097": 280000,
    "26099": 780592000,
    "26101": 2986500,
    "26103": 109549500,
    "26105": 21752000,
    "26107": 35401110,
    "26109": 3259500,
    "26111": 153877000,
    "26113": 1067000,
    "26115": 133679000,
    "26117": 42992500,
    "26119": 812000,
    "26121": 68733200,
    "26123": 35262250,
    "26125": 798989000,
    "26127": 31407000,
    "26129": 33663530,
    "26131": 1557000,
    "26133": 22984500,
    "26135": 4486000,
    "26137": 3238500,
    "26139": 120721000,
    "26141": 4149000,
    "26143": 767500,
    "26145": 88060800,
    "26147": 98484000,
    "26149": 2687450,
    "26151": 34242500,
    "26153": 1084000,
    "26155": 38130500,
    "26157": 42666950,
    "26159": 78270000,
    "26161": 126969500,
    "26163": 1397802000,
    "26165": 2291000,
    "27001": 1361000,
    "27003": 520050600,
    "27005": 3854200,
    "27007": 1647300,
    "27009": 8781000,
    "27011": 1550000,
    "27013": 28875750,
    "27015": 56230000,
    "27017": 78439300,
    "27019": 42271000,
    "27021": 499800,
    "27023": 1315000,
    "27025": 6026600,
    "27027": 91144900,
    "27029": 2606200,
    "27031": 1122000,
    "27033": 59048720,
    "27035": 3924500,
    "27037": 336497500,
    "27039": 15416350,
    "27041": 859000,
    "27043": 15431000,
    "27045": 62446500,
    "27047": 28899000,
    "27049": 11560200,
    "27051": 7879000,
    "27053": 902037700,
    "27055": 67803850,
    "27057": 9478900,
    "27059": 605200,
    "27061": 210900,
    "27063": 36288000,
    "27065": 427700,
    "27067": 18090000,
    "27069": 29610000,
    "27071": 3062000,
    "27073": 2863500,
    "27075": 3256000,
    "27077": 2730200,
    "27079": 63913500,
    "27081": 4207720,
    "27083": 5068720,
    "27085": 2252700,
    "27087": 2295700,
    "27089": 41834300,
    "27091": 5572000,
    "27093": 13360500,
    "27095": 688050,
    "27097": 19142500,
    "27099": 19947750,
    "27101": 27076720,
    "27103": 128862000,
    "27105": 61622720,
    "27107": 89342500,
    "27109": 71888950,
    "27111": 24939100,
    "27113": 4128000,
    "27115": 3862000,
    "27117": 6006220,
    "27119": 1228342900,
    "27121": 3551000,
    "27123": 188062200,
    "27125": 6287200,
    "27127": 6342000,
    "27129": 26227000,
    "27131": 84401100,
    "27133": 29735720,
    "27135": 427642200,
    "27137": 97389800,
    "27139": 210348000,
    "27141": 30694000,
    "27143": 5885400,
    "27145": 23643900,
    "27147": 48465200,
    "27149": 421500,
    "27151": 14185000,
    "27153": 2213200,
    "27155": 5000000,
    "27157": 44258350,
    "27159": 8084600,
    "27161": 5510000,
    "27163": 64634600,
    "27165": 23160000,
    "27167": 91000600,
    "27169": 58541500,
    "27171": 84677000,
    "27173": 26125000,
    "28001": 251493400,
    "28003": 7165550,
    "28005": 151838400,
    "28007": 176424250,
    "28009": 4362220,
    "28011": 32843700,
    "28013": 2210520,
    "28015": 15332100,
    "28017": 4286850,
    "28019": 201410500,
    "28021": 48684500,
    "28023": 213004500,
    "28025": 9948070,
    "28027": 7780360,
    "28029": 176943000,
    "28031": 415550100,
    "28033": 61124880,
    "28035": 1566277310,
    "28037": 11318400,
    "28039": 62179000,
    "28041": 45910000,
    "28043": 18705000,
    "28045": 9779406350,
    "28047": 17614273650,
    "28049": 1450195750,
    "28051": 88544000,
    "28053": 13751500,
    "28055": 6632000,
    "28057": 5228400,
    "28059": 7482129000,
    "28061": 321195550,
    "28063": 50185000,
    "28065": 239583500,
    "28067": 1553952620,
    "28069": 222670000,
    "28071": 40200650,
    "28073": 842995000,
    "28075": 977494710,
    "28077": 709952000,
    "28079": 231101650,
    "28081": 24547390,
    "28083": 25411860,
    "28085": 226812910,
    "28087": 315382760,
    "28089": 590618060,
    "28091": 659813100,
    "28093": 7074470,
    "28095": 10298800,
    "28097": 33772800,
    "28099": 216008110,
    "28101": 249406000,
    "28103": 30848100,
    "28105": 228497700,
    "28107": 6916720,
    "28109": 2238262200,
    "28111": 5584000,
    "28113": 594603000,
    "28115": 31304450,
    "28117": 3581910,
    "28119": 8096520,
    "28121": 921679650,
    "28123": 280592960,
    "28125": 8895100,
    "28127": 220023000,
    "28129": 229573360,
    "28131": 551296500,
    "28133": 22773900,
    "28135": 3358490,
    "28137": 2039250,
    "28139": 6011350,
    "28141": 4332300,
    "28143": 1004000060,
    "28145": 3969270,
    "28147": 741131900,
    "28149": 395280960,
    "28151": 36418360,
    "28153": 5764750,
    "28155": 14401300,
    "28157": 38573800,
    "28159": 241877500,
    "28161": 1023470,
    "28163": 218125460,
    "29001": 6818500,
    "29003": 2628000,
    "29005": 5873000,
    "29007": 45000,
    "29009": 45996500,
    "29011": 54650500,
    "29013": 15613800,
    "29015": 3006000,
    "29017": 29267000,
    "29019": 9933000,
    "29021": 2249000,
    "29023": 109375000,
    "29025": 616000,
    "29027": 3337000,
    "29029": 263944000,
    "29031": 39643000,
    "29033": 1368000,
    "29035": 35675000,
    "29037": 16198500,
    "29039": 53156000,
    "29041": 1061000,
    "29043": 82137750,
    "29045": 8944000,
    "29047": 119283500,
    "29049": 572750,
    "29051": 2593000,
    "29053": 2962000,
    "29055": 2420000,
    "29057": 10270500,
    "29059": 229814500,
    "29061": 1401250,
    "29063": 1110050,
    "29065": 5621000,
    "29067": 15740500,
    "29069": 57630150,
    "29071": 103829000,
    "29073": 1632000,
    "29075": 18879450,
    "29077": 313565600,
    "29079": 6376600,
    "29081": 790500,
    "29083": 1201600,
    "29085": 35259000,
    "29087": 2686000,
    "29089": 2813000,
    "29091": 79801000,
    "29093": 6348100,
    "29095": 78240750,
    "29097": 2864188000,
    "29099": 7055000,
    "29101": 6199750,
    "29103": 704000,
    "29105": 127096000,
    "29107": 2542250,
    "29109": 65229900,
    "29111": 8329000,
    "29113": 5588000,
    "29115": 2044000,
    "29117": 3193550,
    "29119": 20314000,
    "29121": 2390250,
    "29123": 6264000,
    "29125": 15621000,
    "29127": 8600200,
    "29129": 1112500,
    "29131": 140806000,
    "29133": 206069000,
    "29135": 963000,
    "29137": 173000,
    "29139": 1195500,
    "29141": 5096400,
    "29143": 132689000,
    "29145": 140654000,
    "29147": 2902200,
    "29149": 9883000,
    "29151": 1229000,
    "29153": 15872000,
    "29155": 112309050,
    "29157": 82356000,
    "29159": 10299250,
    "29161": 23601000,
    "29163": 644000,
    "29165": 51112000,
    "29167": 30911000,
    "29169": 124493500,
    "29171": 1318000,
    "29173": 319000,
    "29175": 6633700,
    "29177": 1667000,
    "29179": 1575000,
    "29181": 51103000,
    "29183": 306748000,
    "29185": 5548500,
    "29186": 1473000,
    "29187": 3045000,
    "29189": 1444024000,
    "29195": 4685000,
    "29197": 4600000,
    "29199": 5264200,
    "29201": 68958000,
    "29203": 10742000,
    "29205": 170000,
    "29207": 72325000,
    "29209": 37159000,
    "29211": 1793900,
    "29213": 53282000,
    "29215": 19616500,
    "29217": 5421000,
    "29219": 214500,
    "29221": 632000,
    "29223": 47400000,
    "29225": 51487350,
    "29227": 835500,
    "29229": 12968000,
    "29510": 106578000,
    "30001": 52000,
    "30003": 6522000,
    "30005": 185500,
    "30007": 0,
    "30009": 2140000,
    "30011": 9403000,
    "30013": 1102600,
    "30015": 680000,
    "30017": 2420000,
    "30019": 610500,
    "30021": 5993000,
    "30023": 1251825,
    "30025": 2878000,
    "30027": 4322000,
    "30029": 18461800,
    "30031": 62602600,
    "30033": 5085500,
    "30035": 2987000,
    "30037": 50000,
    "30039": 625325,
    "30041": 1091000,
    "30043": 100000,
    "30045": 55000,
    "30047": 10559566.666666668,
    "30049": 7790000,
    "30051": 4000,
    "30053": 2119133.3333333335,
    "30055": 3583800,
    "30057": 72000,
    "30059": 175000,
    "30061": 1027333.3333333334,
    "30063": 8639233.333333334,
    "30065": 6239000,
    "30067": 33161600,
    "30069": 1205200,
    "30071": 1625000,
    "30073": 2205000,
    "30075": 482500,
    "30077": 677825,
    "30079": 766000,
    "30081": 6622000,
    "30083": 3370000,
    "30085": 14196500,
    "30087": 997000,
    "30089": 6212533.333333334,
    "30091": 11590000,
    "30093": 595825,
    "30095": 3120000,
    "30097": 6000000,
    "30099": 1756000,
    "30101": 41000,
    "30103": 300000,
    "30105": 17265500,
    "30107": 60000,
    "30109": 436900,
    "30111": 47047000,
    "31001": 131401360,
    "31003": 14653000,
    "31005": 400500,
    "31007": 11019000,
    "31009": 2689000,
    "31011": 16596000,
    "31013": 2044900,
    "31015": 61552400,
    "31017": 65423500,
    "31019": 134857160,
    "31021": 2004000,
    "31023": 6527000,
    "31025": 10825000,
    "31027": 8956000,
    "31029": 25270500,
    "31031": 47485850,
    "31033": 9869000,
    "31035": 50526160,
    "31037": 7276000,
    "31039": 3515000,
    "31041": 72593500,
    "31043": 9381000,
    "31045": 1367500,
    "31047": 33415160,
    "31049": 1125700,
    "31051": 3649000,
    "31053": 15901000,
    "31055": 620182000,
    "31057": 1386500,
    "31059": 38259160,
    "31061": 15326160,
    "31063": 14476300,
    "31065": 17843160,
    "31067": 46084500,
    "31069": 25225500,
    "31071": 3181400,
    "31073": 11248160,
    "31075": 2385000,
    "31077": 13509160,
    "31079": 61037160,
    "31081": 30318160,
    "31083": 11665160,
    "31085": 7572500,
    "31087": 5895250,
    "31089": 125128000,
    "31091": 3892500,
    "31093": 19890160,
    "31095": 14116500,
    "31097": 2068000,
    "31099": 58394160,
    "31101": 9089500,
    "31103": 4424200,
    "31105": 7930400,
    "31107": 10194500,
    "31109": 242718400,
    "31111": 109886150,
    "31113": 4738000,
    "31115": 3830000,
    "31117": 2506000,
    "31119": 6586000,
    "31121": 20823160,
    "31123": 5017500,
    "31125": 10544160,
    "31127": 2178000,
    "31129": 15129660,
    "31131": 31798000,
    "31133": 728000,
    "31135": 7742750,
    "31137": 32824160,
    "31139": 2014000,
    "31141": 19433200,
    "31143": 17678160,
    "31145": 4287950,
    "31147": 6154000,
    "31149": 5149850,
    "31151": 131378000,
    "31153": 19944500,
    "31155": 8239500,
    "31157": 106803250,
    "31159": 8741000,
    "31161": 38001200,
    "31163": 11513160,
    "31165": 85000,
    "31167": 16573500,
    "31169": 38265660,
    "31171": 2496000,
    "31173": 451000,
    "31175": 16561160,
    "31177": 20219000,
    "31179": 11330000,
    "31181": 13827160,
    "31183": 4416200,
    "31185": 28031160,
    "32001": 1166050,
    "32003": 251945600,
    "32005": 24833160,
    "32007": 21281900,
    "32009": 903000,
    "32011": 389000,
    "32013": 6332100,
    "32015": 120500,
    "32017": 43510000,
    "32019": 670834010,
    "32021": 641145700,
    "32023": 7069500,
    "32027": 1269550,
    "32029": 21264760,
    "32031": 38679210,
    "32033": 132000,
    "32510": 24990160,
    "33001": 18955720,
    "33003": 32596000,
    "33005": 43677800,
    "33007": 16163000,
    "33009": 50755450,
    "33011": 84650400,
    "33013": 25416500,
    "33015": 59717000,
    "33017": 13217520,
    "33019": 19067000,
    "34001": 1575477040,
    "34003": 79463450,
    "34005": 376041330,
    "34007": 68491420,
    "34009": 1389481050,
    "34011": 111686600,
    "34013": 26832500,
    "34015": 75421220,
    "34017": 8541000,
    "34019": 228651700,
    "34021": 371435350,
    "34023": 1375660600,
    "34025": 23632339310,
    "34027": 323493380,
    "34029": 22285186020,
    "34031": 32946750,
    "34033": 73433900,
    "34035": 720858910,
    "34037": 412398500,
    "34039": 17207500,
    "34041": 138079570,
    "35001": 24559750,
    "35003": 8337000,
    "35005": 402839250,
    "35006": 1997833.3333333333,
    "35007": 8484500,
    "35009": 224133250,
    "35011": 867500,
    "35013": 26481000,
    "35015": 21099700,
    "35017": 1736250,
    "35019": 2293500,
    "35021": 32000,
    "35023": 85500,
    "35025": 40184500,
    "35027": 99325000,
    "35028": 1521208666.6666665,
    "35029": 899000,
    "35031": 1785333.3333333333,
    "35033": 904400,
    "35035": 6668760,
    "35037": 5240600,
    "35039": 19688383.333333332,
    "35041": 214302750,
    "35043": 35919850.00000001,
    "35045": 9116000,
    "35047": 6500883.333333333,
    "35049": 10205716.666666668,
    "35051": 4122000,
    "35053": 49926333.333333336,
    "35055": 2388216.6666666665,
    "35057": 8447250,
    "35059": 4807000,
    "35061": 19081083.333333336,
    "36001": 18333800,
    "36003": 31268000,
    "36005": 7047250,
    "36007": 823147680,
    "36009": 120031500,
    "36011": 50715000,
    "36013": 91782500,
    "36015": 39105660,
    "36017": 141223520,
    "36019": 90383000,
    "36021": 24195400,
    "36023": 47837160,
    "36025": 376917520,
    "36027": 34428100,
    "36029": 440662500,
    "36031": 91664000,
    "36033": 34892000,
    "36035": 5885600,
    "36037": 32833000,
    "36039": 35023240,
    "36041": 1401000,
    "36043": 15504300,
    "36045": 251189500,
    "36047": 14337500,
    "36049": 31502000,
    "36051": 26838000,
    "36053": 46342660,
    "36055": 83240500,
    "36057": 19756600,
    "36059": 26141250,
    "36061": 48001000,
    "36063": 35953000,
    "36065": 107248040,
    "36067": 148080500,
    "36069": 34140500,
    "36071": 51622750,
    "36073": 23970000,
    "36075": 39892500,
    "36077": 126050520,
    "36079": 3295000,
    "36081": 34358000,
    "36083": 34564700,
    "36085": 4538500,
    "36087": 5078250,
    "36089": 30472000,
    "36091": 89368600,
    "36093": 27336900,
    "36095": 30149240,
    "36097": 19571520,
    "36099": 8767660,
    "36101": 41453660,
    "36103": 309776400,
    "36105": 193986520,
    "36107": 603847000,
    "36109": 28174660,
    "36111": 44779900,
    "36113": 31493600,
    "36115": 13364400,
    "36117": 41930500,
    "36119": 26442250,
    "36121": 31084500,
    "36123": 28309660,
    "37001": 6007925650,
    "37003": 22758800,
    "37005": 2286500,
    "37007": 7219800,
    "37009": 3085200,
    "37011": 140651500,
    "37013": 161623000,
    "37015": 45347000,
    "37017": 71584700,
    "37019": 9512650,
    "37021": 209547080,
    "37023": 18505300,
    "37025": 41049000,
    "37027": 5283000,
    "37029": 7186000,
    "37031": 10243500,
    "37033": 7280550,
    "37035": 46850500,
    "37037": 11656000,
    "37039": 4726000,
    "37041": 23079000,
    "37043": 1643000,
    "37045": 22189500,
    "37047": 267795450,
    "37049": 6559500,
    "37051": 212609500,
    "37053": 24548000,
    "37055": 22084000,
    "37057": 43675200,
    "37059": 21698500,
    "37061": 337051500,
    "37063": 18152650,
    "37065": 74327500,
    "37067": 58622950,
    "37069": 20620400,
    "37071": 54200000,
    "37073": 3631000,
    "37075": 1522000,
    "37077": 4822400,
    "37079": 98454800,
    "37081": 123078150,
    "37083": 81605500,
    "37085": 38152500,
    "37087": 56771080,
    "37089": 22281500,
    "37091": 13229000,
    "37093": 8698000,
    "37095": 119169400,
    "37097": 31742080,
    "37099": 14933160,
    "37101": 57061110,
    "37103": 97950000,
    "37105": 66251500,
    "37107": 440103000,
    "37109": 26926500,
    "37111": 6631000,
    "37113": 15282000,
    "37115": 28175000,
    "37117": 7024800,
    "37119": 121155500,
    "37121": 11212500,
    "37123": 4076200,
    "37125": 16249500,
    "37127": 219665250,
    "37129": 2019389950,
    "37131": 9930000,
    "37133": 16238900,
    "37135": 49317750,
    "37137": 295906000,
    "37139": 20330000,
    "37141": 615845450,
    "37143": 11436000,
    "37145": 7236000,
    "37147": 430961200,
    "37149": 3641500,
    "37151": 31407000,
    "37153": 24579000,
    "37155": 72177400,
    "37157": 52484650,
    "37159": 24885500,
    "37161": 9891500,
    "37163": 32795500,
    "37165": 17117500,
    "37167": 11327150,
    "37169": 25308050,
    "37171": 11455100,
    "37173": 12991500,
    "37175": 24156000,
    "37177": 63445000,
    "37179": 26699500,
    "37181": 4955650,
    "37183": 219767250,
    "37185": 3581000,
    "37187": 27796000,
    "37189": 32661000,
    "37191": 153163700,
    "37193": 10668100,
    "37195": 46949500,
    "37197": 12619100,
    "37199": 7233080,
    "38001": 30980000,
    "38003": 34294500,
    "38005": 152539000,
    "38007": 9534500,
    "38009": 14029000,
    "38011": 10979000,
    "38013": 7211000,
    "38015": 303127200,
    "38017": 805007700,
    "38019": 31454700,
    "38021": 18584000,
    "38023": 5425000,
    "38025": 36159000,
    "38027": 26480500,
    "38029": 15858000,
    "38031": 24105500,
    "38033": 7795000,
    "38035": 6143578800,
    "38037": 47310000,
    "38039": 38838200,
    "38041": 17320000,
    "38043": 19436000,
    "38045": 20016000,
    "38047": 14389000,
    "38049": 12054000,
    "38051": 18166600,
    "38053": 21446000,
    "38055": 20224000,
    "38057": 15862000,
    "38059": 184037500,
    "38061": 8385000,
    "38063": 50819400,
    "38065": 10562600,
    "38067": 74009800,
    "38069": 8323000,
    "38071": 272315700,
    "38073": 33522900,
    "38075": 13124000,
    "38077": 177139500,
    "38079": 7811500,
    "38081": 28402500,
    "38083": 7480000,
    "38085": 30720000,
    "38087": 11156000,
    "38089": 38380500,
    "38091": 30839300,
    "38093": 40510500,
    "38095": 25832700,
    "38097": 49679000,
    "38099": 55781700,
    "38101": 118622000,
    "38103": 12293000,
    "38105": 10419000,
    "39001": 35718000,
    "39003": 3414500,
    "39005": 73896000,
    "39007": 121226500,
    "39009": 36787000,
    "39011": 15408500,
    "39013": 57629000,
    "39015": 24723000,
    "39017": 91267500,
    "39019": 6442100,
    "39021": 11934500,
    "39023": 36788500,
    "39025": 69874000,
    "39027": 14336300,
    "39029": 13209750,
    "39031": 9222250,
    "39033": 116871000,
    "39035": 353053800,
    "39037": 15977250,
    "39039": 1525000,
    "39041": 106251600,
    "39043": 71103000,
    "39045": 36931000,
    "39047": 9242500,
    "39049": 498859350,
    "39051": 2210000,
    "39053": 20546000,
    "39055": 78685000,
    "39057": 55141500,
    "39059": 10111000,
    "39061": 315982700,
    "39063": 286921000,
    "39065": 8725000,
    "39067": 4727500,
    "39069": 940500,
    "39071": 13999000,
    "39073": 13080000,
    "39075": 59889500,
    "39077": 70320500,
    "39079": 19088000,
    "39081": 17401500,
    "39083": 1561510000,
    "39085": 457499000,
    "39087": 36377000,
    "39089": 143260500,
    "39091": 13568500,
    "39093": 155816000,
    "39095": 119292500,
    "39097": 12384000,
    "39099": 85843000,
    "39101": 66316000,
    "39103": 89028000,
    "39105": 30092000,
    "39107": 34615500,
    "39109": 28568750,
    "39111": 10620000,
    "39113": 204126950,
    "39115": 13024500,
    "39117": 38756000,
    "39119": 15601000,
    "39121": 13027200,
    "39123": 87060500,
    "39125": 4259500,
    "39127": 13624000,
    "39129": 20100500,
    "39131": 11009500,
    "39133": 78076500,
    "39135": 14104000,
    "39137": 4898700,
    "39139": 186920000,
    "39141": 22824750,
    "39143": 49959200,
    "39145": 34923500,
    "39147": 64178800,
    "39149": 13590500,
    "39151": 267894000,
    "39153": 602479000,
    "39155": 168980000,
    "39157": 27067750,
    "39159": 15762500,
    "39161": 34753500,
    "39163": 6766500,
    "39165": 72722500,
    "39167": 58111500,
    "39169": 114653200,
    "39171": 3640500,
    "39173": 169866000,
    "39175": 40080000,
    "40001": 10621700,
    "40003": 55754920,
    "40005": 2704090,
    "40007": 94764150,
    "40009": 91160740,
    "40011": 60104010,
    "40013": 2459660,
    "40015": 74374860,
    "40017": 34926060,
    "40019": 16625160,
    "40021": 46553500,
    "40023": 8291800,
    "40025": 9380500,
    "40027": 2765268460,
    "40029": 2687790,
    "40031": 31424050,
    "40033": 3055610,
    "40035": 106835900,
    "40037": 267238200,
    "40039": 55488130,
    "40041": 145625900,
    "40043": 53008250,
    "40045": 53347280,
    "40047": 57436840,
    "40049": 40926560,
    "40051": 136400060,
    "40053": 53406320,
    "40055": 1301520,
    "40057": 1827470,
    "40059": 106959030,
    "40061": 12613100,
    "40063": 26615590,
    "40065": 773181930,
    "40067": 3901350,
    "40069": 11373560,
    "40071": 53236340,
    "40073": 60807560,
    "40075": 8321620,
    "40077": 3154900,
    "40079": 11068500,
    "40081": 103453810,
    "40083": 48176390,
    "40085": 2358630,
    "40087": 24439140,
    "40089": 20979300,
    "40091": 40060100,
    "40093": 52088510,
    "40095": 12774420,
    "40097": 106644600,
    "40099": 10868530,
    "40101": 59621800,
    "40103": 4554780,
    "40105": 47318800,
    "40107": 23695200,
    "40109": 1433196730,
    "40111": 105623700,
    "40113": 48912200,
    "40115": 146662600,
    "40117": 44142700,
    "40119": 1653770,
    "40121": 19189300,
    "40123": 10477570,
    "40125": 20919330,
    "40127": 4333020,
    "40129": 8849630,
    "40131": 148288500,
    "40133": 6129740,
    "40135": 5568900,
    "40137": 14160050,
    "40139": 33221000,
    "40141": 6375310,
    "40143": 373144500,
    "40145": 152884900,
    "40147": 49708100,
    "40149": 102908830,
    "40151": 5323160,
    "40153": 11257060,
    "41001": 260000,
    "41003": 248527249.99999997,
    "41005": 43423800,
    "41007": 120309000,
    "41009": 84435000,
    "41011": 6651666.666666666,
    "41013": 20103100,
    "41015": 28414866.666666664,
    "41017": 11100266.666666666,
    "41019": 6672666.666666666,
    "41021": 156333.33333333334,
    "41023": 759200,
    "41025": 235000,
    "41027": 39600600,
    "41029": 21678000,
    "41031": 7785966.666666667,
    "41033": 5648200,
    "41035": 1711000,
    "41037": 505000,
    "41039": 260861249.99999997,
    "41041": 216352750,
    "41043": 47890599.99999999,
    "41045": 200010800,
    "41047": 13998800,
    "41049": 2850033.333333333,
    "41051": 25468100,
    "41053": 211816250,
    "41055": 136000,
    "41057": 168659000,
    "41059": 2624166.666666667,
    "41061": 4216016.666666667,
    "41063": 1811166.6666666667,
    "41065": 193866.6666666667,
    "41067": 47387900,
    "41069": 25533.333333333336,
    "41071": 48650000,
    "42001": 824400,
    "42003": 190825550,
    "42005": 20656500,
    "42007": 77394250,
    "42009": 1277980,
    "42011": 64662680,
    "42013": 917980,
    "42015": 131446000,
    "42017": 82830440,
    "42019": 23087850,
    "42021": 1137680,
    "42023": 411900,
    "42025": 27679360,
    "42027": 9921960,
    "42029": 24305150,
    "42031": 83895000,
    "42033": 4293400,
    "42035": 6089300,
    "42037": 16899800,
    "42039": 137112000,
    "42041": 2273900,
    "42043": 154094400,
    "42045": 68866580,
    "42047": 834400,
    "42049": 224108500,
    "42051": 17010250,
    "42053": 1291750,
    "42055": 2205480,
    "42057": 233480,
    "42059": 15757500,
    "42061": 753480,
    "42063": 10194000,
    "42065": 109047000,
    "42067": 1335480,
    "42069": 109454000,
    "42071": 35003900,
    "42073": 6780750,
    "42075": 21873900,
    "42077": 43333170,
    "42079": 312607000,
    "42081": 41043100,
    "42083": 72506400,
    "42085": 11159500,
    "42087": 570980,
    "42089": 203037720,
    "42091": 110804340,
    "42093": 792800,
    "42095": 123974690,
    "42097": 1376800,
    "42099": 671900,
    "42101": 60466990,
    "42103": 66398000,
    "42105": 1497900,
    "42107": 4993900,
    "42109": 625800,
    "42111": 5144980,
    "42113": 11243300,
    "42115": 130680000,
    "42117": 3592800,
    "42119": 26561800,
    "42121": 58105500,
    "42123": 102298500,
    "42125": 28492500,
    "42127": 108858000,
    "42129": 30713250,
    "42131": 155683000,
    "42133": 15031400,
    "44001": 7352000,
    "44003": 31692800,
    "44005": 11392200,
    "44007": 63861400,
    "44009": 44275300,
    "45001": 15002880,
    "45003": 8172730,
    "45005": 39181750,
    "45007": 42362880,
    "45009": 3142000,
    "45011": 659900,
    "45013": 8446900,
    "45015": 14647690,
    "45017": 9092300,
    "45019": 64244850,
    "45021": 25601380,
    "45023": 14884000,
    "45025": 3363120,
    "45027": 14025100,
    "45029": 3913410,
    "45031": 19276000,
    "45033": 42614950,
    "45035": 8705700,
    "45037": 2912600,
    "45039": 1689700,
    "45041": 59075000,
    "45043": 142790000,
    "45045": 44864760,
    "45047": 17974380,
    "45049": 597850,
    "45051": 172764550,
    "45053": 975750,
    "45055": 3401200,
    "45057": 2851510,
    "45059": 20761380,
    "45061": 1912500,
    "45063": 25015800,
    "45065": 656310,
    "45067": 17001250,
    "45069": 13569250,
    "45071": 1474530,
    "45073": 26573060,
    "45075": 26218900,
    "45077": 38016260,
    "45079": 41950260,
    "45081": 2749300,
    "45083": 66100380,
    "45085": 8739420,
    "45087": 21112380,
    "45089": 30513750,
    "45091": 28300300,
    "46003": 3629000,
    "46005": 27279660,
    "46007": 103689000,
    "46009": 5246660,
    "46011": 13345340,
    "46013": 7358200,
    "46015": 4196660,
    "46017": 25000,
    "46019": 27303000,
    "46021": 34000,
    "46023": 6142660,
    "46025": 1261000,
    "46027": 1782660,
    "46029": 3114000,
    "46031": 290000,
    "46033": 9754000,
    "46035": 19374660,
    "46037": 5605000,
    "46039": 5715000,
    "46041": 1131000,
    "46043": 25577660,
    "46045": 158000,
    "46047": 6507250,
    "46049": 56000,
    "46051": 4613000,
    "46053": 7022660,
    "46055": 14819700,
    "46057": 1629000,
    "46059": 170000,
    "46061": 5930000,
    "46063": 17841500,
    "46065": 330000,
    "46067": 32935000,
    "46069": 5000,
    "46071": 11127500,
    "46073": 9640000,
    "46075": 25000,
    "46077": 11335000,
    "46079": 5389200,
    "46081": 27496000,
    "46083": 42537000,
    "46085": 5000,
    "46087": 40733000,
    "46089": 634000,
    "46091": 2114000,
    "46093": 29995000,
    "46095": 1642500,
    "46097": 3289000,
    "46099": 96133660,
    "46101": 3951000,
    "46103": 88459100,
    "46105": 16940700,
    "46107": 14000,
    "46109": 4385000,
    "46111": 5192000,
    "46113": 662000,
    "46115": 770000,
    "46117": 338000,
    "46119": 321000,
    "46121": 3041500,
    "46123": 2293500,
    "46125": 37134000,
    "46127": 3239660,
    "46129": 3000000,
    "46135": 14227000,
    "46137": 18215200,
    "47001": 1926500,
    "47003": 3740200,
    "47005": 14424100,
    "47007": 30023500,
    "47009": 16478000,
    "47011": 48244000,
    "47013": 2162000,
    "47015": 2739900,
    "47017": 20091050,
    "47019": 24251750,
    "47021": 17138300,
    "47023": 1657620,
    "47025": 5574000,
    "47027": 1369600,
    "47029": 2260000,
    "47031": 11613850,
    "47033": 19254280,
    "47035": 48563600,
    "47037": 1729711050,
    "47039": 8736540,
    "47041": 2841600,
    "47043": 10893400,
    "47045": 94852120,
    "47047": 3988240,
    "47049": 36886100,
    "47051": 1387700,
    "47053": 559085670,
    "47055": 3691700,
    "47057": 2307000,
    "47059": 17707000,
    "47061": 5558000,
    "47063": 987000,
    "47065": 156962500,
    "47067": 1276000,
    "47069": 2850180,
    "47071": 26014430,
    "47073": 1289000,
    "47075": 7174000,
    "47077": 20936530,
    "47079": 20039420,
    "47081": 8954700,
    "47083": 7845500,
    "47085": 5437300,
    "47087": 13596100,
    "47089": 4296500,
    "47091": 2894000,
    "47093": 24966000,
    "47095": 5249120,
    "47097": 17513490,
    "47099": 19494100,
    "47101": 3118500,
    "47103": 2603710,
    "47105": 5673500,
    "47107": 23051500,
    "47109": 12714610,
    "47111": 33352100,
    "47113": 200180560,
    "47115": 27798500,
    "47117": 1946500,
    "47119": 14493900,
    "47121": 10848000,
    "47123": 20596500,
    "47125": 93595700,
    "47127": 436000,
    "47129": 2853000,
    "47131": 14104510,
    "47133": 27295000,
    "47135": 5293100,
    "47137": 11063000,
    "47139": 7339000,
    "47141": 50932500,
    "47143": 20029000,
    "47145": 8395000,
    "47147": 10826900,
    "47149": 133442700,
    "47151": 3652000,
    "47153": 7596000,
    "47155": 5519250,
    "47157": 2297504160,
    "47159": 7223500,
    "47161": 14807600,
    "47163": 4760000,
    "47165": 96335000,
    "47167": 31205720,
    "47169": 2811000,
    "47171": 1005000,
    "47173": 2881000,
    "47175": 10491700,
    "47177": 10685200,
    "47179": 12817000,
    "47181": 17928650,
    "47183": 8469390,
    "47185": 11478500,
    "47187": 28232600,
    "47189": 52002600,
    "48001": 41523800,
    "48003": 36426800,
    "48005": 22876000,
    "48007": 3904711000,
    "48009": 2149660,
    "48011": 2267650,
    "48013": 8440500,
    "48015": 6776500,
    "48017": 19723800,
    "48019": 6943000,
    "48021": 526383500,
    "48023": 3300050,
    "48025": 7300000,
    "48027": 214544900,
    "48029": 1564075500,
    "48031": 22268000,
    "48033": 25507900,
    "48035": 7159000,
    "48037": 261736300,
    "48039": 5524915000,
    "48041": 58198300,
    "48043": 15162200,
    "48045": 2736000,
    "48047": 11492600,
    "48049": 55075500,
    "48051": 50041000,
    "48053": 180583500,
    "48055": 210229000,
    "48057": 565368000,
    "48059": 132434000,
    "48061": 1746608700,
    "48063": 1552000,
    "48065": 63552700,
    "48067": 15688000,
    "48069": 16287000,
    "48071": 624584750,
    "48073": 4441500,
    "48075": 38091900,
    "48077": 4162660,
    "48079": 7177000,
    "48081": 619000,
    "48083": 10797100,
    "48085": 917239100,
    "48087": 2316200,
    "48089": 7349000,
    "48091": 482322000,
    "48093": 3084500,
    "48095": 3367000,
    "48097": 44953000,
    "48099": 3985200,
    "48101": 3861100,
    "48103": 717000,
    "48105": 1247500,
    "48107": 9960750,
    "48109": 2215700,
    "48111": 4558400,
    "48113": 1729426700,
    "48115": 2501400,
    "48117": 3344300,
    "48119": 1919800,
    "48121": 754369400,
    "48123": 73472000,
    "48125": 2463000,
    "48127": 27089000,
    "48129": 19757000,
    "48131": 7119000,
    "48133": 20375750,
    "48135": 303554750,
    "48137": 1923000,
    "48139": 26393000,
    "48141": 669862000,
    "48143": 6812500,
    "48145": 1642000,
    "48147": 10623000,
    "48149": 53767000,
    "48151": 7638000,
    "48153": 6645000,
    "48155": 230760,
    "48157": 8850455500,
    "48159": 3638100,
    "48161": 5706300,
    "48163": 1889500,
    "48165": 21910350,
    "48167": 20537372500,
    "48169": 9722800,
    "48171": 5543000,
    "48173": 1305000,
    "48175": 2701000,
    "48177": 34439000,
    "48179": 44924000,
    "48181": 59297500,
    "48183": 44055200,
    "48185": 143896500,
    "48187": 88135500,
    "48189": 314477200,
    "48191": 14150900,
    "48193": 10541250,
    "48195": 9353000,
    "48197": 860610,
    "48199": 850811000,
    "48201": 30511977270,
    "48203": 26731700,
    "48205": 2041600,
    "48207": 6318000,
    "48209": 354541700,
    "48211": 9669000,
    "48213": 15228600,
    "48215": 797159500,
    "48217": 10988110,
    "48219": 45806800,
    "48221": 166667700,
    "48223": 11095200,
    "48225": 209660500,
    "48227": 33010600,
    "48229": 2222500,
    "48231": 10986100,
    "48233": 27250800,
    "48235": 12760000,
    "48237": 5259500,
    "48239": 1004992500,
    "48241": 108438000,
    "48243": 403000,
    "48245": 6843105000,
    "48247": 2043000,
    "48249": 9029000,
    "48251": 172224700,
    "48253": 36625000,
    "48255": 11387000,
    "48257": 110423100,
    "48259": 7608000,
    "48261": 6500,
    "48263": 3354000,
    "48265": 1931000,
    "48267": 26339700,
    "48269": 3519000,
    "48271": 1705000,
    "48273": 7627000,
    "48275": 1107780,
    "48277": 46117900,
    "48279": 17737000,
    "48281": 2785000,
    "48283": 610000,
    "48285": 9174000,
    "48287": 3214000,
    "48289": 8064350,
    "48291": 2485808000,
    "48293": 5533300,
    "48295": 7574100,
    "48297": 4050500,
    "48299": 245388500,
    "48301": 547800,
    "48303": 2680169150,
    "48305": 8237000,
    "48307": 1681000,
    "48309": 12889350,
    "48311": 257000,
    "48313": 178908000,
    "48315": 4780000,
    "48317": 431050,
    "48319": 12633000,
    "48321": 1092329100,
    "48323": 84741500,
    "48325": 63553000,
    "48327": 1014500,
    "48329": 184746900,
    "48331": 5938500,
    "48333": 5661000,
    "48335": 7045200,
    "48337": 226691700,
    "48339": 8068326000,
    "48341": 4979400,
    "48343": 1685000,
    "48345": 2816600,
    "48347": 10865200,
    "48349": 1029432500,
    "48351": 139447000,
    "48353": 18627000,
    "48355": 2729319000,
    "48357": 65545800,
    "48359": 4657250,
    "48361": 3709355000,
    "48363": 86242000,
    "48365": 3527000,
    "48367": 22357350,
    "48369": 25062000,
    "48371": 7991470,
    "48373": 572066000,
    "48375": 498619000,
    "48377": 2643300,
    "48379": 2473600,
    "48381": 342300000,
    "48383": 595700,
    "48385": 3358000,
    "48387": 311523500,
    "48389": 5176900,
    "48391": 1000966500,
    "48393": 1714500,
    "48395": 3400600,
    "48397": 98148600,
    "48399": 15984500,
    "48401": 15908500,
    "48403": 19434000,
    "48405": 25128800,
    "48407": 444962000,
    "48409": 1024457000,
    "48411": 3238500,
    "48413": 6625000,
    "48415": 22053200,
    "48417": 4894000,
    "48419": 10052200,
    "48421": 1605000,
    "48423": 11072500,
    "48425": 2942000,
    "48427": 64701500,
    "48429": 203607400,
    "48431": 82000,
    "48433": 5488500,
    "48435": 16299000,
    "48437": 12691000,
    "48439": 1205802200,
    "48441": 454697400,
    "48443": 2449500,
    "48445": 6775000,
    "48447": 2100500,
    "48449": 3614000,
    "48451": 52313000,
    "48453": 517062500,
    "48455": 78626500,
    "48457": 186893000,
    "48459": 9475000,
    "48461": 735700,
    "48463": 18444000,
    "48465": 160847000,
    "48467": 49274600,
    "48469": 303052500,
    "48471": 649628000,
    "48473": 732843000,
    "48475": 740500,
    "48477": 314139000,
    "48479": 67041000,
    "48481": 416692000,
    "48483": 7972000,
    "48485": 32395600,
    "48487": 2111470,
    "48489": 160370000,
    "48491": 130906200,
    "48493": 141878000,
    "48495": 352700,
    "48497": 27037600,
    "48499": 4431000,
    "48501": 7202000,
    "48503": 4861100,
    "48505": 2814500,
    "48507": 11660000,
    "49001": 6388238.095238097,
    "49003": 79939695.83333333,
    "49005": 10597762.5,
    "49007": 25982700,
    "49009": 397000,
    "49011": 75701895.83333331,
    "49013": 18925899.999999996,
    "49015": 17977200,
    "49017": 6333738.095238095,
    "49019": 8118200,
    "49021": 8963238.095238095,
    "49023": 5751833.333333334,
    "49025": 6696738.095238095,
    "49027": 665500,
    "49029": 1006162.5,
    "49031": 4798571.428571428,
    "49033": 400762.5,
    "49035": 260436295.83333328,
    "49037": 2200666.666666667,
    "49039": 24215333.333333336,
    "49041": 1592500,
    "49043": 9516395.833333332,
    "49045": 68810500,
    "49047": 3117100,
    "49049": 37919733.33333333,
    "49051": 21911833.333333332,
    "49053": 653866238.095238,
    "49055": 13452471.428571431,
    "49057": 79183495.83333331,
    "50001": 48545500,
    "50003": 6250100,
    "50005": 20264500,
    "50007": 60902000,
    "50009": 7792500,
    "50011": 530853000,
    "50013": 17536000,
    "50015": 20415000,
    "50017": 54291000,
    "50019": 514591000,
    "50021": 88493000,
    "50023": 106642000,
    "50025": 6411500,
    "50027": 142912000,
    "51001": 41227000,
    "51003": 1940300,
    "51005": 15151000,
    "51007": 10992000,
    "51009": 7136400,
    "51011": 13583600,
    "51013": 12625066.666666666,
    "51015": 8065000,
    "51017": 12549200,
    "51019": 11866300,
    "51021": 1700500,
    "51023": 6076130,
    "51025": 1704000,
    "51027": 35635500,
    "51029": 3613000,
    "51031": 14138750,
    "51033": 1127000,
    "51035": 6591250,
    "51036": 390000,
    "51037": 5842360,
    "51041": 6919000,
    "51043": 7297200,
    "51045": 1258550,
    "51047": 11721200,
    "51049": 271000,
    "51051": 11097000,
    "51053": 17234000,
    "51057": 4958000,
    "51059": 67173350,
    "51061": 7530550,
    "51063": 4821700,
    "51065": 1183000,
    "51067": 6774500,
    "51069": 12098300,
    "51071": 7508700,
    "51073": 35314600,
    "51075": 328000,
    "51077": 1999590,
    "51079": 10798700,
    "51081": 2747000,
    "51083": 30338180,
    "51085": 4391000,
    "51087": 5091000,
    "51089": 73442430,
    "51091": 1252500,
    "51093": 17819000,
    "51095": 83535333.33333331,
    "51097": 1415000,
    "51099": 10621200,
    "51101": 1667000,
    "51103": 9246000,
    "51105": 4747500,
    "51107": 15876150,
    "51109": 1245000,
    "51111": 789000,
    "51113": 3991200,
    "51115": 62000000,
    "51117": 9193000,
    "51119": 67234400,
    "51121": 6766900,
    "51125": 2338300,
    "51127": 2246000,
    "51131": 15554000,
    "51133": 72977000,
    "51135": 571000,
    "51137": 4982200,
    "51139": 16825700,
    "51141": 15931320,
    "51143": 18995250,
    "51145": 8474000,
    "51147": 520000,
    "51149": 7718666.666666667,
    "51153": 16600700,
    "51155": 7274270,
    "51157": 2178200,
    "51159": 8207000,
    "51161": 9510666.666666668,
    "51163": 7697749.999999999,
    "51165": 27775100,
    "51167": 2666000,
    "51169": 1412000,
    "51171": 80904250,
    "51173": 6216050,
    "51175": 2534000,
    "51177": 8740100,
    "51179": 42370800,
    "51181": 14927000,
    "51183": 7645000,
    "51185": 39258000,
    "51187": 95291700,
    "51191": 5482000,
    "51193": 3137000,
    "51195": 4692000,
    "51197": 2231150,
    "51199": 754000,
    "51510": 7700566.666666667,
    "51515": 180500,
    "51520": 1172000,
    "51530": 1010900.0000000001,
    "51540": 5357700,
    "51550": 99488000,
    "51570": 3488000,
    "51580": 7197400,
    "51590": 20255760,
    "51595": 695000,
    "51600": 25386600,
    "51610": 7342566.666666667,
    "51620": 4623000,
    "51630": 7611200,
    "51640": 5308600,
    "51650": 13379000,
    "51660": 13970600,
    "51670": 5784666.666666667,
    "51678": 1226800,
    "51680": 37739950,
    "51683": 12644900,
    "51685": 10019400,
    "51690": 3624710,
    "51700": 2713000,
    "51710": 99184000,
    "51720": 1836000,
    "51730": 7239666.666666667,
    "51735": 59000,
    "51740": 72565000,
    "51750": 1128300,
    "51760": 20967000,
    "51770": 6696566.666666667,
    "51775": 4494526.666666667,
    "51790": 12602600,
    "51800": 104018000,
    "51810": 141081000,
    "51820": 11332600,
    "51830": 40660666.66666666,
    "51840": 4876100,
    "53001": 7870900,
    "53003": 2271250,
    "53005": 2163750,
    "53007": 142630730,
    "53009": 19666000,
    "53011": 9086500,
    "53013": 5760000,
    "53015": 13266100,
    "53017": 264157700,
    "53019": 24320500,
    "53021": 5367250,
    "53023": 705000,
    "53025": 11774400,
    "53027": 61845000,
    "53029": 12655000,
    "53031": 33577500,
    "53033": 134142500,
    "53035": 61308000,
    "53037": 22245666.666666664,
    "53039": 11762916.666666668,
    "53041": 80895000,
    "53043": 22252600,
    "53045": 27627000,
    "53047": 392974160,
    "53049": 30779500.000000004,
    "53051": 11104999.999999996,
    "53053": 86864800,
    "53055": 9457000,
    "53057": 18335000,
    "53059": 453000,
    "53061": 113853000.00000001,
    "53063": 47924510,
    "53065": 5495500,
    "53067": 38738000,
    "53069": 23380500,
    "53071": 9880250,
    "53073": 23954000,
    "53075": 3743900,
    "53077": 82939666.66666666,
    "54001": 8245000,
    "54003": 2037800,
    "54005": 14499000,
    "54007": 10701000,
    "54009": 47554000,
    "54011": 22708500,
    "54013": 6189500,
    "54015": 22898000,
    "54017": 3880500,
    "54019": 58029500,
    "54021": 7921000,
    "54023": 493000,
    "54025": 45625550,
    "54027": 5558200,
    "54029": 78295750,
    "54031": 24317200,
    "54033": 14713000,
    "54035": 19923200,
    "54037": 43743900,
    "54039": 151771500,
    "54041": 5420500,
    "54043": 25752000,
    "54045": 33614500,
    "54047": 152099000,
    "54049": 9005000,
    "54051": 21007550,
    "54053": 9825000,
    "54055": 16532600,
    "54057": 911500,
    "54059": 54190500,
    "54061": 4699500,
    "54063": 2931800,
    "54065": 2837700,
    "54067": 30311000,
    "54069": 98214850,
    "54071": 11448400,
    "54073": 4649000,
    "54075": 3269500,
    "54077": 7538950,
    "54079": 16484500,
    "54081": 54150500,
    "54083": 6104000,
    "54085": 6145500,
    "54087": 17960000,
    "54089": 3863700,
    "54091": 8314500,
    "54093": 877500,
    "54095": 6305500,
    "54097": 11566000,
    "54099": 19950000,
    "54101": 12535000,
    "54103": 33469000,
    "54105": 6080000,
    "54107": 23058500,
    "54109": 81338500,
    "55001": 16674450,
    "55003": 695000,
    "55005": 45312000,
    "55007": 5537000,
    "55009": 6416000,
    "55011": 12573350,
    "55013": 10209500,
    "55015": 41592500,
    "55017": 5647000,
    "55019": 9116000,
    "55021": 548884960,
    "55023": 62908150,
    "55025": 237694200,
    "55027": 40479700,
    "55029": 6559700,
    "55031": 25161000,
    "55033": 8358600,
    "55035": 14857200,
    "55037": 2060000,
    "55039": 77864350,
    "55041": 688050,
    "55043": 66346850,
    "55045": 16350800,
    "55047": 12690000,
    "55049": 33492830,
    "55051": 3774000,
    "55053": 7319150,
    "55055": 134761000,
    "55057": 44545300,
    "55059": 79338200,
    "55061": 1673000,
    "55063": 76381400,
    "55065": 17345360,
    "55067": 5431000,
    "55069": 12070600,
    "55071": 56620100,
    "55073": 28113200,
    "55075": 1716600,
    "55077": 16995900,
    "55078": 2758000,
    "55079": 272530100,
    "55081": 49665300,
    "55083": 13175200,
    "55085": 3416700,
    "55087": 46678750,
    "55089": 39249860,
    "55091": 28445200,
    "55093": 29645200,
    "55095": 7458000,
    "55097": 9039000,
    "55099": 566500,
    "55101": 46141000,
    "55103": 24219850,
    "55105": 31574060,
    "55107": 26720000,
    "55109": 50475200,
    "55111": 52514000,
    "55113": 521100,
    "55115": 972800,
    "55117": 50464500,
    "55119": 5857200,
    "55121": 23010090,
    "55123": 110087550,
    "55125": 2546000,
    "55127": 25269400,
    "55129": 82500,
    "55131": 45697100,
    "55133": 157346200,
    "55135": 4567500,
    "55137": 33534000,
    "55139": 54298500,
    "55141": 49086500,
    "56001": 766333.3333333334,
    "56003": 2939800,
    "56005": 82316500,
    "56007": 150000,
    "56009": 67000,
    "56011": 7493700,
    "56013": 25263800,
    "56015": 2807500,
    "56017": 1752000,
    "56019": 3504033.333333333,
    "56021": 41475233.333333336,
    "56023": 3193000,
    "56025": 34989133.333333336,
    "56027": 1597000,
    "56029": 4250600,
    "56031": 387633.3333333333,
    "56033": 552000,
    "56035": 20969200,
    "56037": 1795500,
    "56039": 1795100,
    "56041": 2026000,
    "56043": 972133.3333333333,
    "56045": 5494600
  },
  {
    "1001": 7,
    "1003": 29,
    "1005": 0,
    "1007": 1,
    "1009": 1,
    "1011": 2,
    "1013": 2,
    "1015": 11,
    "1017": 4,
    "1019": 3,
    "1021": 12,
    "1023": 2,
    "1025": 4,
    "1027": 1,
    "1029": 0,
    "1031": 17,
    "1033": 6,
    "1035": 1,
    "1037": 0,
    "1039": 5,
    "1041": 0,
    "1043": 5,
    "1045": 4,
    "1047": 4,
    "1049": 32,
    "1051": 16,
    "1053": 5,
    "1055": 1,
    "1057": 5,
    "1059": 29,
    "1061": 1,
    "1063": 4,
    "1065": 8,
    "1067": 1,
    "1069": 6,
    "1071": 13,
    "1073": 68,
    "1075": 3,
    "1077": 10,
    "1079": 23,
    "1081": 5,
    "1083": 10,
    "1085": 4,
    "1087": 0,
    "1089": 19,
    "1091": 3,
    "1093": 28,
    "1095": 16,
    "1097": 8,
    "1099": 1,
    "1101": 18,
    "1103": 7,
    "1105": 2,
    "1107": 2,
    "1109": 4,
    "1111": 0,
    "1113": 2,
    "1115": 18,
    "1117": 1,
    "1119": 2,
    "1121": 5,
    "1123": 2,
    "1125": 74,
    "1127": 21,
    "1129": 3,
    "1131": 1,
    "1133": 1,
    "2013": 0,
    "2016": 0,
    "2020": 18.333333333333332,
    "2050": 7.5,
    "2060": 0,
    "2068": 2.5,
    "2070": 0,
    "2090": 4,
    "2100": 0,
    "2110": 0,
    "2122": 5.5,
    "2130": 0,
    "2150": 0.6666666666666666,
    "2164": 0.6666666666666666,
    "2170": 12.833333333333334,
    "2180": 6,
    "2185": 4,
    "2188": 5,
    "2201": 0,
    "2220": 10,
    "2232": 0,
    "2240": 4.333333333333333,
    "2261": 9.666666666666666,
    "2270": 0,
    "2280": 0,
    "2282": 6,
    "2290": 5,
    "4001": 10.333333333333332,
    "4003": 18,
    "4005": 61.33333333333333,
    "4007": 13,
    "4009": 0,
    "4011": 0,
    "4012": 2,
    "4013": 13,
    "4015": 27,
    "4017": 22.333333333333332,
    "4019": 40,
    "4021": 20,
    "4023": 5,
    "4025": 58,
    "4027": 0,
    "5001": 1,
    "5003": 3,
    "5005": 6,
    "5007": 16,
    "5009": 4,
    "5011": 5,
    "5013": 0,
    "5015": 5,
    "5017": 1,
    "5019": 10,
    "5021": 5,
    "5023": 4,
    "5025": 0,
    "5027": 1,
    "5029": 7,
    "5031": 12,
    "5033": 1,
    "5035": 4,
    "5037": 2,
    "5039": 2,
    "5041": 0,
    "5043": 0,
    "5045": 26,
    "5047": 3,
    "5049": 2,
    "5051": 9,
    "5053": 3,
    "5055": 2,
    "5057": 0,
    "5059": 2,
    "5061": 2,
    "5063": 1,
    "5065": 9,
    "5067": 7,
    "5069": 9,
    "5071": 6,
    "5073": 1,
    "5075": 5,
    "5077": 1,
    "5079": 0,
    "5081": 3,
    "5083": 1,
    "5085": 11,
    "5087": 9,
    "5089": 5,
    "5091": 3,
    "5093": 22,
    "5095": 0,
    "5097": 20,
    "5099": 3,
    "5101": 2,
    "5103": 1,
    "5105": 1,
    "5107": 2,
    "5109": 0,
    "5111": 11,
    "5113": 3,
    "5115": 10,
    "5117": 3,
    "5119": 49,
    "5121": 3,
    "5123": 7,
    "5125": 14,
    "5127": 9,
    "5129": 0,
    "5131": 6,
    "5133": 4,
    "5135": 5,
    "5137": 7,
    "5139": 2,
    "5141": 7,
    "5143": 20,
    "5145": 12,
    "5147": 0,
    "5149": 3,
    "6001": 6.5,
    "6003": 10.611111111111112,
    "6005": 16.368253968253967,
    "6007": 63.06666666666667,
    "6009": 11.225396825396825,
    "6011": 7.066666666666666,
    "6013": 6.5,
    "6015": 1,
    "6017": 18.468253968253972,
    "6019": 1,
    "6021": 4.066666666666666,
    "6023": 7,
    "6025": 0,
    "6027": 24,
    "6029": 2,
    "6031": 0,
    "6033": 5.4,
    "6035": 0.4,
    "6037": 82,
    "6039": 0,
    "6041": 22.666666666666668,
    "6043": 6,
    "6045": 16,
    "6047": 0,
    "6049": 2,
    "6051": 12,
    "6053": 19,
    "6055": 5.666666666666667,
    "6057": 15.992063492063494,
    "6059": 24.333333333333332,
    "6061": 19.46825396825397,
    "6063": 1.4,
    "6065": 52.33333333333333,
    "6067": 7.476190476190476,
    "6069": 1,
    "6071": 118,
    "6073": 195.33333333333334,
    "6075": 16,
    "6077": 7.733333333333333,
    "6079": 9,
    "6081": 14.166666666666666,
    "6083": 52,
    "6085": 14.166666666666666,
    "6087": 34.666666666666664,
    "6089": 77.8,
    "6091": 3.1111111111111116,
    "6093": 8,
    "6095": 7.476190476190475,
    "6097": 25.66666666666667,
    "6099": 7.4,
    "6101": 7.809523809523809,
    "6103": 70.8,
    "6105": 0,
    "6107": 4,
    "6109": 13.225396825396825,
    "6111": 29,
    "6113": 5.142857142857142,
    "6115": 10.492063492063492,
    "8001": 10.600000000000001,
    "8003": 1,
    "8005": 9.266666666666667,
    "8007": 2.428571428571428,
    "8009": 1,
    "8011": 1,
    "8013": 14.523809523809524,
    "8014": 6.266666666666666,
    "8015": 8,
    "8017": 0,
    "8019": 4.057142857142857,
    "8021": 9.666666666666666,
    "8023": 6.666666666666667,
    "8025": 4,
    "8027": 3.5,
    "8029": 6.666666666666667,
    "8031": 7.6000000000000005,
    "8033": 2.4285714285714284,
    "8035": 7.466666666666666,
    "8037": 17.86666666666667,
    "8039": 6.666666666666666,
    "8041": 22,
    "8043": 5.5,
    "8045": 24.866666666666667,
    "8047": 4.057142857142857,
    "8049": 6.857142857142857,
    "8051": 8.066666666666666,
    "8053": 3.8285714285714283,
    "8055": 2.1666666666666665,
    "8057": 4,
    "8059": 11.723809523809523,
    "8061": 0,
    "8063": 4,
    "8065": 3.9999999999999996,
    "8067": 2.428571428571428,
    "8069": 23,
    "8071": 0.6666666666666666,
    "8073": 6,
    "8075": 4,
    "8077": 7,
    "8079": 5.666666666666667,
    "8081": 3.1999999999999997,
    "8083": 1.4285714285714284,
    "8085": 9.066666666666666,
    "8087": 2,
    "8089": 3,
    "8091": 3.4,
    "8093": 5.057142857142857,
    "8095": 2,
    "8097": 17.66666666666667,
    "8099": 3,
    "8101": 1.5,
    "8103": 2.1999999999999997,
    "8105": 4.666666666666666,
    "8107": 3.1999999999999997,
    "8109": 6,
    "8111": 1.4285714285714284,
    "8113": 3.8285714285714283,
    "8115": 0,
    "8117": 3.8571428571428568,
    "8119": 2,
    "8121": 2,
    "8123": 16,
    "8125": 6,
    "9001": 35,
    "9003": 7,
    "9005": 5,
    "9007": 4,
    "9009": 16,
    "9011": 4,
    "9013": 6,
    "9015": 2,
    "10001": 10,
    "10003": 30,
    "10005": 22,
    "11001": 24,
    "12001": 2,
    "12003": 0,
    "12005": 146,
    "12007": 0,
    "12009": 64,
    "12011": 134,
    "12013": 15,
    "12015": 5,
    "12017": 1,
    "12019": 0,
    "12021": 17,
    "12023": 5,
    "12027": 5,
    "12029": 0,
    "12031": 32,
    "12033": 39,
    "12035": 1,
    "12037": 6,
    "12039": 7,
    "12041": 0,
    "12043": 5,
    "12045": 16,
    "12047": 5,
    "12049": 0,
    "12051": 6,
    "12053": 1,
    "12055": 10,
    "12057": 23,
    "12059": 0,
    "12061": 17,
    "12063": 10,
    "12065": 2,
    "12067": 0,
    "12069": 35,
    "12071": 21,
    "12073": 15,
    "12075": 1,
    "12077": 11,
    "12079": 1,
    "12081": 10,
    "12083": 3,
    "12085": 8,
    "12086": 103,
    "12087": 33,
    "12089": 14,
    "12091": 14,
    "12093": 1,
    "12095": 30,
    "12097": 37,
    "12099": 85,
    "12101": 6,
    "12103": 38,
    "12105": 32,
    "12107": 8,
    "12109": 28,
    "12111": 14,
    "12113": 14,
    "12115": 7,
    "12117": 19,
    "12119": 2,
    "12121": 0,
    "12123": 6,
    "12125": 0,
    "12127": 104,
    "12129": 5,
    "12131": 42,
    "12133": 9,
    "13001": 0,
    "13003": 0,
    "13005": 0,
    "13007": 8,
    "13009": 0,
    "13011": 1,
    "13013": 2,
    "13015": 2,
    "13017": 0,
    "13019": 2,
    "13021": 4,
    "13023": 4,
    "13025": 1,
    "13027": 4,
    "13029": 2,
    "13031": 6,
    "13033": 2,
    "13035": 4,
    "13037": 0,
    "13039": 4,
    "13043": 0,
    "13045": 8,
    "13047": 8,
    "13049": 0,
    "13051": 13,
    "13053": 0,
    "13055": 1,
    "13057": 3,
    "13059": 0,
    "13061": 0,
    "13063": 0,
    "13065": 0,
    "13067": 5,
    "13069": 0,
    "13071": 3,
    "13073": 0,
    "13075": 7,
    "13077": 9,
    "13079": 0,
    "13081": 1,
    "13083": 2,
    "13085": 3,
    "13087": 1,
    "13089": 8,
    "13091": 2,
    "13093": 0,
    "13095": 5,
    "13097": 9,
    "13099": 2,
    "13101": 0,
    "13103": 1,
    "13105": 2,
    "13107": 0,
    "13109": 0,
    "13111": 0,
    "13113": 2,
    "13115": 5,
    "13117": 8,
    "13119": 1,
    "13121": 20,
    "13123": 1,
    "13125": 0,
    "13127": 4,
    "13129": 0,
    "13131": 9,
    "13133": 0,
    "13135": 8,
    "13137": 0,
    "13139": 12,
    "13141": 1,
    "13143": 0,
    "13145": 3,
    "13147": 2,
    "13149": 0,
    "13151": 1,
    "13153": 0,
    "13155": 2,
    "13157": 1,
    "13159": 0,
    "13161": 0,
    "13163": 0,
    "13165": 0,
    "13167": 0,
    "13169": 0,
    "13171": 2,
    "13173": 0,
    "13175": 10,
    "13177": 0,
    "13179": 2,
    "13181": 0,
    "13183": 3,
    "13185": 2,
    "13187": 4,
    "13189": 0,
    "13191": 0,
    "13193": 0,
    "13195": 0,
    "13197": 0,
    "13199": 2,
    "13201": 2,
    "13205": 16,
    "13207": 0,
    "13209": 0,
    "13211": 0,
    "13213": 0,
    "13215": 5,
    "13217": 1,
    "13219": 0,
    "13221": 0,
    "13223": 1,
    "13225": 0,
    "13227": 0,
    "13229": 0,
    "13231": 0,
    "13233": 2,
    "13235": 1,
    "13237": 0,
    "13239": 0,
    "13241": 1,
    "13243": 0,
    "13245": 5,
    "13247": 4,
    "13249": 0,
    "13251": 1,
    "13253": 3,
    "13255": 4,
    "13257": 0,
    "13259": 0,
    "13261": 4,
    "13263": 1,
    "13265": 0,
    "13267": 1,
    "13269": 2,
    "13271": 0,
    "13273": 0,
    "13275": 1,
    "13277": 1,
    "13279": 1,
    "13281": 0,
    "13283": 0,
    "13285": 4,
    "13287": 2,
    "13289": 2,
    "13291": 0,
    "13293": 0,
    "13295": 3,
    "13297": 0,
    "13299": 0,
    "13301": 0,
    "13303": 0,
    "13305": 0,
    "13307": 0,
    "13309": 0,
    "13311": 3,
    "13313": 1,
    "13315": 0,
    "13317": 0,
    "13319": 1,
    "13321": 4,
    "15001": 13,
    "15003": 26,
    "15005": 0,
    "15007": 58,
    "15009": 4,
    "16001": 0.6666666666666666,
    "16003": 1,
    "16005": 0,
    "16007": 4,
    "16009": 4.5,
    "16011": 0,
    "16013": 1,
    "16015": 2.333333333333333,
    "16017": 3.9999999999999996,
    "16019": 1,
    "16021": 3.9999999999999996,
    "16023": 1,
    "16025": 3.333333333333333,
    "16027": 2.4,
    "16029": 0,
    "16031": 2,
    "16033": 1,
    "16035": 1,
    "16037": 0,
    "16039": 4,
    "16041": 0,
    "16043": 0.4,
    "16045": 1.4,
    "16047": 2,
    "16049": 3,
    "16051": 0,
    "16053": 2,
    "16055": 7.5,
    "16057": 4.5,
    "16059": 3,
    "16061": 0,
    "16063": 0,
    "16065": 0,
    "16067": 0,
    "16069": 0,
    "16071": 1,
    "16073": 2.0666666666666664,
    "16075": 0.4,
    "16077": 0,
    "16079": 1.5,
    "16081": 0,
    "16083": 2,
    "16085": 1,
    "16087": 1.4,
    "17001": 2,
    "17003": 0,
    "17005": 2,
    "17007": 1,
    "17009": 1,
    "17011": 2,
    "17013": 0,
    "17015": 0,
    "17017": 3,
    "17019": 19,
    "17021": 12,
    "17023": 4,
    "17025": 4,
    "17027": 1,
    "17029": 9,
    "17031": 1037,
    "17033": 9,
    "17035": 2,
    "17037": 4,
    "17039": 0,
    "17041": 2,
    "17043": 17,
    "17045": 2,
    "17047": 2,
    "17049": 12,
    "17051": 0,
    "17053": 0,
    "17055": 6,
    "17057": 6,
    "17059": 2,
    "17061": 0,
    "17063": 10,
    "17065": 2,
    "17067": 0,
    "17069": 2,
    "17071": 0,
    "17073": 4,
    "17075": 6,
    "17077": 7,
    "17079": 0,
    "17081": 12,
    "17083": 2,
    "17085": 3,
    "17087": 1,
    "17089": 9,
    "17091": 6,
    "17093": 0,
    "17095": 2,
    "17097": 20,
    "17099": 15,
    "17101": 0,
    "17103": 0,
    "17105": 4,
    "17107": 15,
    "17109": 0,
    "17111": 10,
    "17113": 35,
    "17115": 2,
    "17117": 4,
    "17119": 30,
    "17121": 7,
    "17123": 2,
    "17125": 2,
    "17127": 6,
    "17129": 0,
    "17131": 3,
    "17133": 0,
    "17135": 1,
    "17137": 7,
    "17139": 2,
    "17141": 8,
    "17143": 23,
    "17145": 6,
    "17147": 3,
    "17149": 3,
    "17151": 0,
    "17153": 2,
    "17155": 0,
    "17157": 2,
    "17159": 2,
    "17161": 7,
    "17163": 37,
    "17165": 9,
    "17167": 16,
    "17169": 0,
    "17171": 1,
    "17173": 3,
    "17175": 2,
    "17177": 2,
    "17179": 11,
    "17181": 10,
    "17183": 14,
    "17185": 1,
    "17187": 0,
    "17189": 5,
    "17191": 6,
    "17193": 3,
    "17195": 0,
    "17197": 49,
    "17199": 5,
    "17201": 8,
    "17203": 2,
    "18001": 4,
    "18003": 5,
    "18005": 5,
    "18007": 2,
    "18009": 0,
    "18011": 0,
    "18013": 2,
    "18015": 4,
    "18017": 1,
    "18019": 10,
    "18021": 0,
    "18023": 2,
    "18025": 1,
    "18027": 0,
    "18029": 0,
    "18031": 2,
    "18033": 6,
    "18035": 2,
    "18037": 4,
    "18039": 7,
    "18041": 0,
    "18043": 2,
    "18045": 3,
    "18047": 3,
    "18049": 4,
    "18051": 2,
    "18053": 5,
    "18055": 4,
    "18057": 9,
    "18059": 0,
    "18061": 0,
    "18063": 1,
    "18065": 1,
    "18067": 0,
    "18069": 1,
    "18071": 9,
    "18073": 3,
    "18075": 4,
    "18077": 4,
    "18079": 0,
    "18081": 3,
    "18083": 1,
    "18085": 5,
    "18087": 5,
    "18089": 9,
    "18091": 36,
    "18093": 1,
    "18095": 1,
    "18097": 27,
    "18099": 4,
    "18101": 2,
    "18103": 0,
    "18105": 5,
    "18107": 1,
    "18109": 2,
    "18111": 7,
    "18113": 4,
    "18115": 2,
    "18117": 0,
    "18119": 1,
    "18121": 0,
    "18123": 5,
    "18125": 5,
    "18127": 24,
    "18129": 2,
    "18131": 0,
    "18133": 0,
    "18135": 0,
    "18137": 5,
    "18139": 1,
    "18141": 22,
    "18143": 1,
    "18145": 0,
    "18147": 0,
    "18149": 2,
    "18151": 12,
    "18153": 0,
    "18155": 1,
    "18157": 1,
    "18159": 0,
    "18161": 6,
    "18163": 29,
    "18165": 0,
    "18167": 0,
    "18169": 0,
    "18171": 2,
    "18173": 6,
    "18175": 6,
    "18177": 2,
    "18179": 6,
    "18181": 4,
    "18183": 0,
    "19001": 4,
    "19003": 0,
    "19005": 3,
    "19007": 0,
    "19009": 0,
    "19011": 2,
    "19013": 1,
    "19015": 0,
    "19017": 0,
    "19019": 1,
    "19021": 0,
    "19023": 13,
    "19025": 0,
    "19027": 0,
    "19029": 2,
    "19031": 0,
    "19033": 0,
    "19035": 0,
    "19037": 1,
    "19039": 2,
    "19041": 0,
    "19043": 3,
    "19045": 3,
    "19047": 0,
    "19049": 0,
    "19051": 2,
    "19053": 0,
    "19055": 2,
    "19057": 0,
    "19059": 0,
    "19061": 4,
    "19063": 2,
    "19065": 2,
    "19067": 3,
    "19069": 0,
    "19071": 0,
    "19073": 0,
    "19075": 2,
    "19077": 0,
    "19079": 4,
    "19081": 2,
    "19083": 0,
    "19085": 2,
    "19087": 5,
    "19089": 0,
    "19091": 0,
    "19093": 0,
    "19095": 2,
    "19097": 2,
    "19099": 0,
    "19101": 0,
    "19103": 1,
    "19105": 2,
    "19107": 2,
    "19109": 4,
    "19111": 0,
    "19113": 8,
    "19115": 8,
    "19117": 0,
    "19119": 0,
    "19121": 0,
    "19123": 2,
    "19125": 0,
    "19127": 0,
    "19129": 2,
    "19131": 0,
    "19133": 4,
    "19135": 0,
    "19137": 0,
    "19139": 5,
    "19141": 0,
    "19143": 0,
    "19145": 0,
    "19147": 1,
    "19149": 2,
    "19151": 0,
    "19153": 14,
    "19155": 4,
    "19157": 4,
    "19159": 1,
    "19161": 0,
    "19163": 1,
    "19165": 0,
    "19167": 5,
    "19169": 0,
    "19171": 0,
    "19173": 0,
    "19175": 0,
    "19177": 3,
    "19179": 2,
    "19181": 1,
    "19183": 0,
    "19185": 0,
    "19187": 4,
    "19189": 0,
    "19191": 4,
    "19193": 0,
    "19195": 0,
    "19197": 5,
    "20001": 6,
    "20003": 0,
    "20005": 0,
    "20007": 2,
    "20009": 1,
    "20011": 0,
    "20013": 8,
    "20015": 12,
    "20017": 8,
    "20019": 0,
    "20021": 5,
    "20023": 2,
    "20025": 0,
    "20027": 8,
    "20029": 0,
    "20031": 4,
    "20033": 0,
    "20035": 8,
    "20037": 3,
    "20039": 0,
    "20041": 14,
    "20043": 0,
    "20045": 2,
    "20047": 0,
    "20049": 0,
    "20051": 1,
    "20053": 2,
    "20055": 1,
    "20057": 4,
    "20059": 3,
    "20061": 8,
    "20063": 4,
    "20065": 0,
    "20067": 0,
    "20069": 0,
    "20071": 2,
    "20073": 1,
    "20075": 0,
    "20077": 0,
    "20079": 6,
    "20081": 0,
    "20083": 0,
    "20085": 2,
    "20087": 3,
    "20089": 0,
    "20091": 5,
    "20093": 0,
    "20095": 0,
    "20097": 11,
    "20099": 2,
    "20101": 0,
    "20103": 0,
    "20105": 0,
    "20107": 0,
    "20109": 2,
    "20111": 9,
    "20113": 7,
    "20115": 6,
    "20117": 4,
    "20119": 0,
    "20121": 6,
    "20123": 2,
    "20125": 12,
    "20127": 5,
    "20129": 0,
    "20131": 0,
    "20133": 2,
    "20135": 0,
    "20137": 1,
    "20139": 17,
    "20141": 0,
    "20143": 5,
    "20145": 0,
    "20147": 0,
    "20149": 14,
    "20151": 3,
    "20153": 0,
    "20155": 17,
    "20157": 0,
    "20159": 4,
    "20161": 3,
    "20163": 0,
    "20165": 0,
    "20167": 4,
    "20169": 2,
    "20171": 1,
    "20173": 38,
    "20175": 0,
    "20177": 15,
    "20179": 0,
    "20181": 6,
    "20183": 2,
    "20185": 3,
    "20187": 0,
    "20189": 0,
    "20191": 5,
    "20193": 16,
    "20195": 0,
    "20197": 2,
    "20199": 0,
    "20201": 4,
    "20203": 0,
    "20205": 1,
    "20207": 3,
    "20209": 4,
    "21001": 1,
    "21003": 5,
    "21005": 2,
    "21007": 1,
    "21009": 8,
    "21011": 1,
    "21013": 2,
    "21015": 2,
    "21017": 5,
    "21019": 4,
    "21021": 0,
    "21023": 3,
    "21025": 7,
    "21027": 4,
    "21029": 4,
    "21031": 0,
    "21033": 1,
    "21035": 2,
    "21037": 0,
    "21039": 1,
    "21041": 0,
    "21043": 6,
    "21045": 0,
    "21047": 10,
    "21049": 2,
    "21051": 2,
    "21053": 1,
    "21055": 1,
    "21057": 0,
    "21059": 5,
    "21061": 2,
    "21063": 0,
    "21065": 1,
    "21067": 12,
    "21069": 0,
    "21071": 0,
    "21073": 7,
    "21075": 3,
    "21077": 3,
    "21079": 0,
    "21081": 0,
    "21083": 5,
    "21085": 0,
    "21087": 0,
    "21089": 1,
    "21091": 0,
    "21093": 5,
    "21095": 2,
    "21097": 4,
    "21099": 1,
    "21101": 8,
    "21103": 0,
    "21105": 4,
    "21107": 4,
    "21109": 0,
    "21111": 33,
    "21113": 4,
    "21115": 6,
    "21117": 4,
    "21119": 0,
    "21121": 7,
    "21123": 1,
    "21125": 15,
    "21127": 4,
    "21129": 0,
    "21131": 0,
    "21133": 0,
    "21135": 4,
    "21137": 1,
    "21139": 0,
    "21141": 5,
    "21143": 6,
    "21145": 7,
    "21147": 2,
    "21149": 0,
    "21151": 11,
    "21153": 0,
    "21155": 0,
    "21157": 5,
    "21159": 0,
    "21161": 1,
    "21163": 4,
    "21165": 3,
    "21167": 1,
    "21169": 2,
    "21171": 1,
    "21173": 1,
    "21175": 6,
    "21177": 4,
    "21179": 8,
    "21181": 0,
    "21183": 2,
    "21185": 0,
    "21187": 3,
    "21189": 0,
    "21191": 11,
    "21193": 0,
    "21195": 11,
    "21197": 5,
    "21199": 6,
    "21201": 0,
    "21203": 0,
    "21205": 4,
    "21207": 0,
    "21209": 0,
    "21211": 7,
    "21213": 2,
    "21215": 0,
    "21217": 2,
    "21219": 2,
    "21221": 2,
    "21223": 0,
    "21225": 3,
    "21227": 1,
    "21229": 0,
    "21231": 2,
    "21233": 9,
    "21235": 5,
    "21237": 2,
    "21239": 0,
    "22001": 1,
    "22003": 0,
    "22005": 1,
    "22007": 0,
    "22009": 2,
    "22011": 4,
    "22013": 3,
    "22015": 51,
    "22017": 66,
    "22019": 16,
    "22021": 1,
    "22023": 3,
    "22025": 0,
    "22027": 3,
    "22029": 0,
    "22031": 5,
    "22033": 22,
    "22035": 0,
    "22037": 0,
    "22039": 6,
    "22041": 0,
    "22043": 7,
    "22045": 6,
    "22047": 3,
    "22049": 0,
    "22051": 65,
    "22053": 2,
    "22055": 7,
    "22057": 5,
    "22059": 1,
    "22061": 9,
    "22063": 4,
    "22065": 2,
    "22067": 2,
    "22069": 3,
    "22071": 1295,
    "22073": 11,
    "22075": 12,
    "22077": 2,
    "22079": 5,
    "22081": 1,
    "22083": 1,
    "22085": 2,
    "22087": 281,
    "22089": 0,
    "22091": 3,
    "22093": 3,
    "22095": 3,
    "22097": 7,
    "22099": 4,
    "22101": 0,
    "22103": 9,
    "22105": 9,
    "22107": 0,
    "22109": 6,
    "22111": 4,
    "22113": 0,
    "22115": 0,
    "22117": 6,
    "22119": 6,
    "22121": 0,
    "22123": 0,
    "22125": 3,
    "22127": 1,
    "23001": 2,
    "23003": 7,
    "23005": 5,
    "23007": 1,
    "23009": 7,
    "23011": 1,
    "23013": 2,
    "23015": 0,
    "23017": 3,
    "23019": 0,
    "23021": 2,
    "23023": 0,
    "23025": 0,
    "23027": 0,
    "23029": 0,
    "23031": 8,
    "24001": 0,
    "24003": 22,
    "24005": 125.66666666666666,
    "24009": 7,
    "24011": 4,
    "24013": 5,
    "24015": 6,
    "24017": 2,
    "24019": 2,
    "24021": 17,
    "24023": 0,
    "24025": 10,
    "24027": 4,
    "24029": 0,
    "24031": 8,
    "24033": 33,
    "24035": 4,
    "24037": 4,
    "24039": 0,
    "24041": 10,
    "24043": 0,
    "24045": 1,
    "24047": 12,
    "24510": 68.33333333333333,
    "25001": 7,
    "25003": 1,
    "25005": 5,
    "25007": 0,
    "25009": 8,
    "25011": 3,
    "25013": 5,
    "25015": 1,
    "25017": 11,
    "25019": 2,
    "25021": 16,
    "25023": 8,
    "25025": 10,
    "25027": 9,
    "26001": 0,
    "26003": 7,
    "26005": 2,
    "26007": 0,
    "26009": 0,
    "26011": 0,
    "26013": 2,
    "26015": 0,
    "26017": 8,
    "26019": 2,
    "26021": 34,
    "26023": 2,
    "26025": 1,
    "26027": 0,
    "26029": 0,
    "26031": 0,
    "26033": 0,
    "26035": 4,
    "26037": 2,
    "26039": 0,
    "26041": 8,
    "26043": 6,
    "26045": 1,
    "26047": 2,
    "26049": 6,
    "26051": 1,
    "26053": 4,
    "26055": 1,
    "26057": 0,
    "26059": 1,
    "26061": 5,
    "26063": 1,
    "26065": 2,
    "26067": 0,
    "26069": 0,
    "26071": 4,
    "26073": 0,
    "26075": 0,
    "26077": 0,
    "26079": 1,
    "26081": 3,
    "26083": 0,
    "26085": 0,
    "26087": 6,
    "26089": 4,
    "26091": 1,
    "26093": 2,
    "26095": 3,
    "26097": 0,
    "26099": 12,
    "26101": 3,
    "26103": 27,
    "26105": 0,
    "26107": 0,
    "26109": 6,
    "26111": 0,
    "26113": 0,
    "26115": 8,
    "26117": 0,
    "26119": 0,
    "26121": 2,
    "26123": 2,
    "26125": 33,
    "26127": 0,
    "26129": 1,
    "26131": 4,
    "26133": 0,
    "26135": 2,
    "26137": 0,
    "26139": 7,
    "26141": 1,
    "26143": 0,
    "26145": 0,
    "26147": 5,
    "26149": 5,
    "26151": 2,
    "26153": 4,
    "26155": 0,
    "26157": 0,
    "26159": 2,
    "26161": 6,
    "26163": 39,
    "26165": 0,
    "27001": 2,
    "27003": 8,
    "27005": 0,
    "27007": 2,
    "27009": 2,
    "27011": 4,
    "27013": 4,
    "27015": 5,
    "27017": 17,
    "27019": 2,
    "27021": 5,
    "27023": 2,
    "27025": 0,
    "27027": 3,
    "27029": 0,
    "27031": 2,
    "27033": 2,
    "27035": 2,
    "27037": 3,
    "27039": 0,
    "27041": 0,
    "27043": 2,
    "27045": 6,
    "27047": 4,
    "27049": 6,
    "27051": 0,
    "27053": 9,
    "27055": 2,
    "27057": 0,
    "27059": 0,
    "27061": 8,
    "27063": 2,
    "27065": 0,
    "27067": 2,
    "27069": 0,
    "27071": 0,
    "27073": 0,
    "27075": 4,
    "27077": 0,
    "27079": 1,
    "27081": 0,
    "27083": 2,
    "27085": 4,
    "27087": 0,
    "27089": 0,
    "27091": 0,
    "27093": 0,
    "27095": 0,
    "27097": 1,
    "27099": 14,
    "27101": 4,
    "27103": 2,
    "27105": 8,
    "27107": 0,
    "27109": 18,
    "27111": 1,
    "27113": 0,
    "27115": 3,
    "27117": 0,
    "27119": 5,
    "27121": 0,
    "27123": 16,
    "27125": 0,
    "27127": 0,
    "27129": 1,
    "27131": 2,
    "27133": 8,
    "27135": 0,
    "27137": 34,
    "27139": 0,
    "27141": 0,
    "27143": 1,
    "27145": 7,
    "27147": 0,
    "27149": 0,
    "27151": 2,
    "27153": 0,
    "27155": 0,
    "27157": 2,
    "27159": 0,
    "27161": 0,
    "27163": 5,
    "27165": 0,
    "27167": 0,
    "27169": 12,
    "27171": 2,
    "27173": 11,
    "28001": 2,
    "28003": 7,
    "28005": 2,
    "28007": 0,
    "28009": 8,
    "28011": 6,
    "28013": 2,
    "28015": 2,
    "28017": 3,
    "28019": 6,
    "28021": 1,
    "28023": 5,
    "28025": 0,
    "28027": 6,
    "28029": 7,
    "28031": 2,
    "28033": 13,
    "28035": 11,
    "28037": 0,
    "28039": 1,
    "28041": 1,
    "28043": 2,
    "28045": 114,
    "28047": 203,
    "28049": 12,
    "28051": 5,
    "28053": 1,
    "28055": 0,
    "28057": 5,
    "28059": 33,
    "28061": 4,
    "28063": 2,
    "28065": 4,
    "28067": 24,
    "28069": 4,
    "28071": 9,
    "28073": 2,
    "28075": 6,
    "28077": 0,
    "28079": 4,
    "28081": 8,
    "28083": 3,
    "28085": 4,
    "28087": 6,
    "28089": 4,
    "28091": 3,
    "28093": 7,
    "28095": 27,
    "28097": 0,
    "28099": 0,
    "28101": 0,
    "28103": 0,
    "28105": 0,
    "28107": 11,
    "28109": 2,
    "28111": 0,
    "28113": 2,
    "28115": 12,
    "28117": 0,
    "28119": 2,
    "28121": 3,
    "28123": 1,
    "28125": 0,
    "28127": 2,
    "28129": 1,
    "28131": 0,
    "28133": 4,
    "28135": 1,
    "28137": 2,
    "28139": 1,
    "28141": 5,
    "28143": 2,
    "28145": 2,
    "28147": 2,
    "28149": 5,
    "28151": 9,
    "28153": 0,
    "28155": 1,
    "28157": 1,
    "28159": 13,
    "28161": 3,
    "28163": 12,
    "29001": 2,
    "29003": 0,
    "29005": 0,
    "29007": 0,
    "29009": 3,
    "29011": 3,
    "29013": 2,
    "29015": 6,
    "29017": 3,
    "29019": 8,
    "29021": 5,
    "29023": 18,
    "29025": 0,
    "29027": 4,
    "29029": 5,
    "29031": 10,
    "29033": 0,
    "29035": 1,
    "29037": 7,
    "29039": 4,
    "29041": 2,
    "29043": 6,
    "29045": 1,
    "29047": 8,
    "29049": 0,
    "29051": 1,
    "29053": 1,
    "29055": 2,
    "29057": 2,
    "29059": 7,
    "29061": 0,
    "29063": 3,
    "29065": 3,
    "29067": 3,
    "29069": 1,
    "29071": 6,
    "29073": 0,
    "29075": 0,
    "29077": 13,
    "29079": 0,
    "29081": 2,
    "29083": 4,
    "29085": 0,
    "29087": 0,
    "29089": 0,
    "29091": 7,
    "29093": 1,
    "29095": 143,
    "29097": 184,
    "29099": 9,
    "29101": 4,
    "29103": 0,
    "29105": 9,
    "29107": 2,
    "29109": 16,
    "29111": 3,
    "29113": 4,
    "29115": 0,
    "29117": 2,
    "29119": 6,
    "29121": 2,
    "29123": 2,
    "29125": 0,
    "29127": 0,
    "29129": 0,
    "29131": 3,
    "29133": 0,
    "29135": 0,
    "29137": 5,
    "29139": 0,
    "29141": 1,
    "29143": 11,
    "29145": 22,
    "29147": 3,
    "29149": 0,
    "29151": 2,
    "29153": 5,
    "29155": 8,
    "29157": 6,
    "29159": 2,
    "29161": 4,
    "29163": 5,
    "29165": 8,
    "29167": 1,
    "29169": 11,
    "29171": 0,
    "29173": 0,
    "29175": 8,
    "29177": 1,
    "29179": 11,
    "29181": 5,
    "29183": 4,
    "29185": 2,
    "29186": 4,
    "29187": 4,
    "29189": 95,
    "29195": 2,
    "29197": 1,
    "29199": 0,
    "29201": 5,
    "29203": 3,
    "29205": 2,
    "29207": 7,
    "29209": 0,
    "29211": 1,
    "29213": 3,
    "29215": 1,
    "29217": 5,
    "29219": 2,
    "29221": 2,
    "29223": 0,
    "29225": 5,
    "29227": 14,
    "29229": 2,
    "29510": 213,
    "30001": 4,
    "30003": 8,
    "30005": 0,
    "30007": 1,
    "30009": 9.5,
    "30011": 0,
    "30013": 4,
    "30015": 0,
    "30017": 2,
    "30019": 0,
    "30021": 2,
    "30023": 2.5,
    "30025": 0,
    "30027": 2,
    "30029": 13.999999999999998,
    "30031": 7.4,
    "30033": 0,
    "30035": 0,
    "30037": 0,
    "30039": 6.166666666666666,
    "30041": 0,
    "30043": 0,
    "30045": 0,
    "30047": 12,
    "30049": 0,
    "30051": 0,
    "30053": 2,
    "30055": 0,
    "30057": 4,
    "30059": 0,
    "30061": 4.333333333333333,
    "30063": 16.999999999999996,
    "30065": 0,
    "30067": 3.9,
    "30069": 1,
    "30071": 0,
    "30073": 0,
    "30075": 0,
    "30077": 4.5,
    "30079": 0,
    "30081": 11.666666666666666,
    "30083": 0,
    "30085": 7,
    "30087": 6,
    "30089": 9.333333333333332,
    "30091": 4,
    "30093": 2.5,
    "30095": 13.5,
    "30097": 3.5,
    "30099": 0,
    "30101": 0,
    "30103": 0,
    "30105": 2,
    "30107": 0,
    "30109": 6,
    "30111": 8,
    "31001": 0,
    "31003": 1,
    "31005": 0,
    "31007": 0,
    "31009": 0,
    "31011": 0,
    "31013": 2,
    "31015": 2,
    "31017": 0,
    "31019": 12,
    "31021": 2,
    "31023": 2,
    "31025": 6,
    "31027": 1,
    "31029": 0,
    "31031": 0,
    "31033": 4,
    "31035": 0,
    "31037": 0,
    "31039": 1,
    "31041": 6,
    "31043": 2,
    "31045": 0,
    "31047": 4,
    "31049": 2,
    "31051": 0,
    "31053": 8,
    "31055": 23,
    "31057": 0,
    "31059": 0,
    "31061": 2,
    "31063": 0,
    "31065": 0,
    "31067": 1,
    "31069": 0,
    "31071": 0,
    "31073": 0,
    "31075": 0,
    "31077": 0,
    "31079": 10,
    "31081": 2,
    "31083": 0,
    "31085": 0,
    "31087": 1,
    "31089": 1,
    "31091": 0,
    "31093": 0,
    "31095": 1,
    "31097": 2,
    "31099": 0,
    "31101": 2,
    "31103": 0,
    "31105": 2,
    "31107": 0,
    "31109": 10,
    "31111": 16,
    "31113": 4,
    "31115": 0,
    "31117": 0,
    "31119": 3,
    "31121": 4,
    "31123": 0,
    "31125": 0,
    "31127": 1,
    "31129": 0,
    "31131": 2,
    "31133": 0,
    "31135": 2,
    "31137": 0,
    "31139": 0,
    "31141": 2,
    "31143": 0,
    "31145": 0,
    "31147": 0,
    "31149": 0,
    "31151": 0,
    "31153": 5,
    "31155": 2,
    "31157": 0,
    "31159": 6,
    "31161": 0,
    "31163": 0,
    "31165": 0,
    "31167": 1,
    "31169": 1,
    "31171": 0,
    "31173": 0,
    "31175": 0,
    "31177": 3,
    "31179": 4,
    "31181": 1,
    "31183": 0,
    "31185": 16,
    "32001": 3,
    "32003": 1056,
    "32005": 4.266666666666667,
    "32007": 0,
    "32009": 1,
    "32011": 0,
    "32013": 2,
    "32015": 0,
    "32017": 0,
    "32019": 8.600000000000001,
    "32021": 0,
    "32023": 3,
    "32027": 3,
    "32029": 3.5999999999999996,
    "32031": 7.266666666666668,
    "32033": 0,
    "32510": 4.266666666666667,
    "33001": 4,
    "33003": 0,
    "33005": 4,
    "33007": 12,
    "33009": 5,
    "33011": 13,
    "33013": 2,
    "33015": 6,
    "33017": 1,
    "33019": 5,
    "34001": 30,
    "34003": 15,
    "34005": 27,
    "34007": 12,
    "34009": 29,
    "34011": 3,
    "34013": 14,
    "34015": 16,
    "34017": 21,
    "34019": 16,
    "34021": 22,
    "34023": 38,
    "34025": 62,
    "34027": 19,
    "34029": 63,
    "34031": 27,
    "34033": 6,
    "34035": 6,
    "34037": 11,
    "34039": 15,
    "34041": 8,
    "35001": 11.566666666666666,
    "35003": 4.666666666666666,
    "35005": 13,
    "35006": 3.333333333333333,
    "35007": 2.6666666666666665,
    "35009": 14,
    "35011": 0,
    "35013": 0,
    "35015": 5,
    "35017": 3,
    "35019": 4,
    "35021": 0,
    "35023": 2,
    "35025": 2,
    "35027": 3,
    "35028": 0.6666666666666666,
    "35029": 0,
    "35031": 18.833333333333336,
    "35033": 0.6666666666666666,
    "35035": 0,
    "35037": 6,
    "35039": 6.166666666666667,
    "35041": 4,
    "35043": 11.733333333333334,
    "35045": 13.5,
    "35047": 10,
    "35049": 9.733333333333334,
    "35051": 2,
    "35053": 1.6666666666666665,
    "35055": 2,
    "35057": 5.233333333333333,
    "35059": 0,
    "35061": 4.566666666666666,
    "36001": 6,
    "36003": 0,
    "36005": 36,
    "36007": 7,
    "36009": 1,
    "36011": 9,
    "36013": 0,
    "36015": 0,
    "36017": 1,
    "36019": 6,
    "36021": 11,
    "36023": 0,
    "36025": 17,
    "36027": 5,
    "36029": 28,
    "36031": 3,
    "36033": 0,
    "36035": 0,
    "36037": 4,
    "36039": 4,
    "36041": 0,
    "36043": 0,
    "36045": 3,
    "36047": 123,
    "36049": 1,
    "36051": 0,
    "36053": 4,
    "36055": 9,
    "36057": 6,
    "36059": 44,
    "36061": 80,
    "36063": 2,
    "36065": 2,
    "36067": 10,
    "36069": 4,
    "36071": 13,
    "36073": 0,
    "36075": 2,
    "36077": 1,
    "36079": 3,
    "36081": 53,
    "36083": 2,
    "36085": 60,
    "36087": 10,
    "36089": 4,
    "36091": 1,
    "36093": 6,
    "36095": 4,
    "36097": 0,
    "36099": 0,
    "36101": 0,
    "36103": 95,
    "36105": 3,
    "36107": 2,
    "36109": 6,
    "36111": 7,
    "36113": 4,
    "36115": 0,
    "36117": 0,
    "36119": 31,
    "36121": 6,
    "36123": 0,
    "37001": 3,
    "37003": 1,
    "37005": 0,
    "37007": 2,
    "37009": 4,
    "37011": 2,
    "37013": 17,
    "37015": 13,
    "37017": 12,
    "37019": 19,
    "37021": 5,
    "37023": 0,
    "37025": 0,
    "37027": 1,
    "37029": 0,
    "37031": 4,
    "37033": 2,
    "37035": 2,
    "37037": 2,
    "37039": 0,
    "37041": 5,
    "37043": 0,
    "37045": 0,
    "37047": 17,
    "37049": 3,
    "37051": 13,
    "37053": 5,
    "37055": 7,
    "37057": 7,
    "37059": 0,
    "37061": 17,
    "37063": 6,
    "37065": 13,
    "37067": 9,
    "37069": 8,
    "37071": 6,
    "37073": 2,
    "37075": 0,
    "37077": 4,
    "37079": 3,
    "37081": 6,
    "37083": 2,
    "37085": 7,
    "37087": 6,
    "37089": 10,
    "37091": 0,
    "37093": 0,
    "37095": 3,
    "37097": 4,
    "37099": 1,
    "37101": 20,
    "37103": 2,
    "37105": 5,
    "37107": 13,
    "37109": 2,
    "37111": 1,
    "37113": 8,
    "37115": 2,
    "37117": 2,
    "37119": 27,
    "37121": 1,
    "37123": 0,
    "37125": 8,
    "37127": 10,
    "37129": 19,
    "37131": 0,
    "37133": 1,
    "37135": 3,
    "37137": 0,
    "37139": 0,
    "37141": 11,
    "37143": 1,
    "37145": 2,
    "37147": 26,
    "37149": 5,
    "37151": 2,
    "37153": 0,
    "37155": 7,
    "37157": 4,
    "37159": 10,
    "37161": 6,
    "37163": 9,
    "37165": 4,
    "37167": 5,
    "37169": 8,
    "37171": 12,
    "37173": 1,
    "37175": 2,
    "37177": 0,
    "37179": 3,
    "37181": 1,
    "37183": 23,
    "37185": 2,
    "37187": 7,
    "37189": 2,
    "37191": 18,
    "37193": 4,
    "37195": 3,
    "37197": 2,
    "37199": 1,
    "38001": 0,
    "38003": 0,
    "38005": 0,
    "38007": 0,
    "38009": 0,
    "38011": 0,
    "38013": 0,
    "38015": 4,
    "38017": 8,
    "38019": 1,
    "38021": 0,
    "38023": 0,
    "38025": 0,
    "38027": 0,
    "38029": 4,
    "38031": 2,
    "38033": 0,
    "38035": 4,
    "38037": 0,
    "38039": 0,
    "38041": 2,
    "38043": 0,
    "38045": 6,
    "38047": 4,
    "38049": 0,
    "38051": 2,
    "38053": 4,
    "38055": 7,
    "38057": 0,
    "38059": 3,
    "38061": 0,
    "38063": 0,
    "38065": 0,
    "38067": 4,
    "38069": 0,
    "38071": 0,
    "38073": 1,
    "38075": 5,
    "38077": 0,
    "38079": 3,
    "38081": 0,
    "38083": 0,
    "38085": 6,
    "38087": 0,
    "38089": 0,
    "38091": 0,
    "38093": 1,
    "38095": 0,
    "38097": 0,
    "38099": 3,
    "38101": 7,
    "38103": 4,
    "38105": 10,
    "39001": 29,
    "39003": 0,
    "39005": 0,
    "39007": 2,
    "39009": 5,
    "39011": 0,
    "39013": 5,
    "39015": 4,
    "39017": 9,
    "39019": 0,
    "39021": 1,
    "39023": 1,
    "39025": 9,
    "39027": 1,
    "39029": 6,
    "39031": 1,
    "39033": 0,
    "39035": 27,
    "39037": 0,
    "39039": 0,
    "39041": 2,
    "39043": 0,
    "39045": 4,
    "39047": 0,
    "39049": 3,
    "39051": 2,
    "39053": 3,
    "39055": 1,
    "39057": 7,
    "39059": 0,
    "39061": 19,
    "39063": 0,
    "39065": 3,
    "39067": 0,
    "39069": 0,
    "39071": 0,
    "39073": 0,
    "39075": 0,
    "39077": 3,
    "39079": 0,
    "39081": 1,
    "39083": 1,
    "39085": 1,
    "39087": 3,
    "39089": 8,
    "39091": 2,
    "39093": 7,
    "39095": 2,
    "39097": 4,
    "39099": 4,
    "39101": 1,
    "39103": 4,
    "39105": 3,
    "39107": 0,
    "39109": 7,
    "39111": 2,
    "39113": 7,
    "39115": 4,
    "39117": 0,
    "39119": 2,
    "39121": 6,
    "39123": 0,
    "39125": 4,
    "39127": 1,
    "39129": 0,
    "39131": 1,
    "39133": 0,
    "39135": 6,
    "39137": 4,
    "39139": 1,
    "39141": 4,
    "39143": 0,
    "39145": 7,
    "39147": 2,
    "39149": 1,
    "39151": 2,
    "39153": 9,
    "39155": 1,
    "39157": 2,
    "39159": 4,
    "39161": 6,
    "39163": 0,
    "39165": 4,
    "39167": 1,
    "39169": 0,
    "39171": 1,
    "39173": 7,
    "39175": 1,
    "40001": 3,
    "40003": 0,
    "40005": 2,
    "40007": 6,
    "40009": 9,
    "40011": 0,
    "40013": 4,
    "40015": 8,
    "40017": 26,
    "40019": 23,
    "40021": 8,
    "40023": 5,
    "40025": 1,
    "40027": 53,
    "40029": 2,
    "40031": 8,
    "40033": 2,
    "40035": 2,
    "40037": 1,
    "40039": 2,
    "40041": 3,
    "40043": 2,
    "40045": 0,
    "40047": 6,
    "40049": 11,
    "40051": 19,
    "40053": 2,
    "40055": 2,
    "40057": 0,
    "40059": 2,
    "40061": 0,
    "40063": 2,
    "40065": 6,
    "40067": 0,
    "40069": 6,
    "40071": 12,
    "40073": 3,
    "40075": 2,
    "40077": 1,
    "40079": 3,
    "40081": 9,
    "40083": 21,
    "40085": 2,
    "40087": 2,
    "40089": 3,
    "40091": 9,
    "40093": 1,
    "40095": 7,
    "40097": 4,
    "40099": 2,
    "40101": 3,
    "40103": 0,
    "40105": 3,
    "40107": 1,
    "40109": 124,
    "40111": 6,
    "40113": 4,
    "40115": 15,
    "40117": 2,
    "40119": 5,
    "40121": 3,
    "40123": 4,
    "40125": 9,
    "40127": 3,
    "40129": 4,
    "40131": 2,
    "40133": 6,
    "40135": 3,
    "40137": 5,
    "40139": 3,
    "40141": 0,
    "40143": 57,
    "40145": 1,
    "40147": 2,
    "40149": 16,
    "40151": 1,
    "40153": 12,
    "41001": 6,
    "41003": 8.333333333333332,
    "41005": 21.3,
    "41007": 14.6,
    "41009": 13.1,
    "41011": 9,
    "41013": 0,
    "41015": 31,
    "41017": 1.3333333333333333,
    "41019": 9,
    "41021": 1.3333333333333333,
    "41023": 0.6666666666666666,
    "41025": 0,
    "41027": 8.8,
    "41029": 14,
    "41031": 6.333333333333333,
    "41033": 1,
    "41035": 1,
    "41037": 5,
    "41039": 24.333333333333332,
    "41041": 18,
    "41043": 6.633333333333333,
    "41045": 0,
    "41047": 6.8,
    "41049": 2.6666666666666665,
    "41051": 15.8,
    "41053": 10.5,
    "41055": 1.6666666666666665,
    "41057": 15.6,
    "41059": 2.6666666666666665,
    "41061": 5.666666666666667,
    "41063": 1,
    "41065": 3,
    "41067": 13.1,
    "41069": 1.6666666666666665,
    "41071": 7.1,
    "42001": 2,
    "42003": 13,
    "42005": 1,
    "42007": 4,
    "42009": 2,
    "42011": 31,
    "42013": 7,
    "42015": 1,
    "42017": 18,
    "42019": 5,
    "42021": 2,
    "42023": 0,
    "42025": 21,
    "42027": 4,
    "42029": 7,
    "42031": 5,
    "42033": 0,
    "42035": 14,
    "42037": 0,
    "42039": 5,
    "42041": 9,
    "42043": 10,
    "42045": 45,
    "42047": 0,
    "42049": 3,
    "42051": 1,
    "42053": 1,
    "42055": 2,
    "42057": 0,
    "42059": 0,
    "42061": 1,
    "42063": 1,
    "42065": 0,
    "42067": 4,
    "42069": 1,
    "42071": 12,
    "42073": 0,
    "42075": 10,
    "42077": 46,
    "42079": 6,
    "42081": 10,
    "42083": 1,
    "42085": 1,
    "42087": 3,
    "42089": 19,
    "42091": 26,
    "42093": 0,
    "42095": 17,
    "42097": 0,
    "42099": 9,
    "42101": 772,
    "42103": 0,
    "42105": 1,
    "42107": 7,
    "42109": 1,
    "42111": 5,
    "42113": 1,
    "42115": 3,
    "42117": 0,
    "42119": 0,
    "42121": 8,
    "42123": 4,
    "42125": 1,
    "42127": 2,
    "42129": 3,
    "42131": 2,
    "42133": 11,
    "44001": 1,
    "44003": 1,
    "44005": 8,
    "44007": 10,
    "44009": 7,
    "45001": 4,
    "45003": 2,
    "45005": 1,
    "45007": 19,
    "45009": 0,
    "45011": 0,
    "45013": 26,
    "45015": 16,
    "45017": 0,
    "45019": 33,
    "45021": 1,
    "45023": 0,
    "45025": 1,
    "45027": 6,
    "45029": 2,
    "45031": 6,
    "45033": 2,
    "45035": 2,
    "45037": 1,
    "45039": 3,
    "45041": 7,
    "45043": 5,
    "45045": 16,
    "45047": 4,
    "45049": 4,
    "45051": 41,
    "45053": 2,
    "45055": 6,
    "45057": 1,
    "45059": 8,
    "45061": 0,
    "45063": 6,
    "45065": 0,
    "45067": 4,
    "45069": 3,
    "45071": 0,
    "45073": 8,
    "45075": 2,
    "45077": 4,
    "45079": 14,
    "45081": 0,
    "45083": 7,
    "45085": 1,
    "45087": 6,
    "45089": 2,
    "45091": 10,
    "46003": 4,
    "46005": 0,
    "46007": 0,
    "46009": 0,
    "46011": 2,
    "46013": 10,
    "46015": 4,
    "46017": 1,
    "46019": 1,
    "46021": 0,
    "46023": 0,
    "46025": 2,
    "46027": 0,
    "46029": 10,
    "46031": 2,
    "46033": 0,
    "46035": 0,
    "46037": 0,
    "46039": 0,
    "46041": 4,
    "46043": 3,
    "46045": 6,
    "46047": 1,
    "46049": 0,
    "46051": 3,
    "46053": 0,
    "46055": 2,
    "46057": 11,
    "46059": 0,
    "46061": 0,
    "46063": 0,
    "46065": 0,
    "46067": 8,
    "46069": 0,
    "46071": 4,
    "46073": 0,
    "46075": 0,
    "46077": 0,
    "46079": 1,
    "46081": 4,
    "46083": 0,
    "46085": 2,
    "46087": 10,
    "46089": 4,
    "46091": 0,
    "46093": 3,
    "46095": 0,
    "46097": 0,
    "46099": 10,
    "46101": 2,
    "46103": 6,
    "46105": 0,
    "46107": 0,
    "46109": 2,
    "46111": 0,
    "46113": 0,
    "46115": 2,
    "46117": 0,
    "46119": 0,
    "46121": 0,
    "46123": 0,
    "46125": 0,
    "46127": 0,
    "46129": 2,
    "46135": 1,
    "46137": 0,
    "47001": 1,
    "47003": 1,
    "47005": 5,
    "47007": 4,
    "47009": 1,
    "47011": 11,
    "47013": 0,
    "47015": 4,
    "47017": 15,
    "47019": 9,
    "47021": 1,
    "47023": 0,
    "47025": 1,
    "47027": 0,
    "47029": 2,
    "47031": 2,
    "47033": 2,
    "47035": 11,
    "47037": 24,
    "47039": 0,
    "47041": 1,
    "47043": 1,
    "47045": 22,
    "47047": 2,
    "47049": 2,
    "47051": 5,
    "47053": 13,
    "47055": 5,
    "47057": 1,
    "47059": 7,
    "47061": 0,
    "47063": 0,
    "47065": 18,
    "47067": 0,
    "47069": 3,
    "47071": 10,
    "47073": 0,
    "47075": 4,
    "47077": 3,
    "47079": 8,
    "47081": 4,
    "47083": 1,
    "47085": 0,
    "47087": 0,
    "47089": 0,
    "47091": 2,
    "47093": 7,
    "47095": 0,
    "47097": 0,
    "47099": 3,
    "47101": 0,
    "47103": 7,
    "47105": 3,
    "47107": 2,
    "47109": 2,
    "47111": 14,
    "47113": 30,
    "47115": 4,
    "47117": 2,
    "47119": 9,
    "47121": 0,
    "47123": 0,
    "47125": 4,
    "47127": 2,
    "47129": 7,
    "47131": 7,
    "47133": 2,
    "47135": 7,
    "47137": 0,
    "47139": 3,
    "47141": 1,
    "47143": 1,
    "47145": 3,
    "47147": 0,
    "47149": 11,
    "47151": 0,
    "47153": 3,
    "47155": 1,
    "47157": 161,
    "47159": 1,
    "47161": 3,
    "47163": 0,
    "47165": 19,
    "47167": 5,
    "47169": 2,
    "47171": 0,
    "47173": 0,
    "47175": 0,
    "47177": 3,
    "47179": 2,
    "47181": 4,
    "47183": 4,
    "47185": 0,
    "47187": 3,
    "47189": 3,
    "48001": 10,
    "48003": 2,
    "48005": 19,
    "48007": 8,
    "48009": 0,
    "48011": 2,
    "48013": 4,
    "48015": 4,
    "48017": 2,
    "48019": 6,
    "48021": 6,
    "48023": 0,
    "48025": 0,
    "48027": 20,
    "48029": 63,
    "48031": 4,
    "48033": 0,
    "48035": 3,
    "48037": 0,
    "48039": 12,
    "48041": 0,
    "48043": 1,
    "48045": 0,
    "48047": 2,
    "48049": 3,
    "48051": 0,
    "48053": 7,
    "48055": 11,
    "48057": 3,
    "48059": 4,
    "48061": 36,
    "48063": 0,
    "48065": 10,
    "48067": 0,
    "48069": 2,
    "48071": 4,
    "48073": 4,
    "48075": 4,
    "48077": 0,
    "48079": 3,
    "48081": 0,
    "48083": 1,
    "48085": 34,
    "48087": 0,
    "48089": 0,
    "48091": 12,
    "48093": 5,
    "48095": 0,
    "48097": 6,
    "48099": 16,
    "48101": 2,
    "48103": 0,
    "48105": 8,
    "48107": 1,
    "48109": 0,
    "48111": 2,
    "48113": 247,
    "48115": 0,
    "48117": 0,
    "48119": 0,
    "48121": 27,
    "48123": 0,
    "48125": 10,
    "48127": 6,
    "48129": 1,
    "48131": 2,
    "48133": 4,
    "48135": 1,
    "48137": 2,
    "48139": 4,
    "48141": 3,
    "48143": 4,
    "48145": 2,
    "48147": 8,
    "48149": 4,
    "48151": 0,
    "48153": 6,
    "48155": 0,
    "48157": 15,
    "48159": 0,
    "48161": 1,
    "48163": 0,
    "48165": 0,
    "48167": 77,
    "48169": 6,
    "48171": 3,
    "48173": 0,
    "48175": 1,
    "48177": 0,
    "48179": 33,
    "48181": 7,
    "48183": 11,
    "48185": 1,
    "48187": 12,
    "48189": 11,
    "48191": 0,
    "48193": 0,
    "48195": 0,
    "48197": 0,
    "48199": 2,
    "48201": 420,
    "48203": 2,
    "48205": 12,
    "48207": 1,
    "48209": 14,
    "48211": 5,
    "48213": 2,
    "48215": 4,
    "48217": 2,
    "48219": 4,
    "48221": 9,
    "48223": 3,
    "48225": 3,
    "48227": 2,
    "48229": 0,
    "48231": 5,
    "48233": 5,
    "48235": 4,
    "48237": 2,
    "48239": 2,
    "48241": 7,
    "48243": 0,
    "48245": 16,
    "48247": 0,
    "48249": 0,
    "48251": 11,
    "48253": 0,
    "48255": 0,
    "48257": 12,
    "48259": 6,
    "48261": 2,
    "48263": 0,
    "48265": 8,
    "48267": 4,
    "48269": 0,
    "48271": 0,
    "48273": 2,
    "48275": 0,
    "48277": 0,
    "48279": 6,
    "48281": 0,
    "48283": 0,
    "48285": 2,
    "48287": 2,
    "48289": 0,
    "48291": 5,
    "48293": 2,
    "48295": 0,
    "48297": 6,
    "48299": 6,
    "48301": 0,
    "48303": 21,
    "48305": 0,
    "48307": 0,
    "48309": 20,
    "48311": 0,
    "48313": 2,
    "48315": 1,
    "48317": 0,
    "48319": 2,
    "48321": 0,
    "48323": 17,
    "48325": 2,
    "48327": 0,
    "48329": 2,
    "48331": 5,
    "48333": 0,
    "48335": 0,
    "48337": 8,
    "48339": 41,
    "48341": 14,
    "48343": 0,
    "48345": 0,
    "48347": 2,
    "48349": 9,
    "48351": 2,
    "48353": 4,
    "48355": 41,
    "48357": 2,
    "48359": 16,
    "48361": 18,
    "48363": 6,
    "48365": 0,
    "48367": 10,
    "48369": 0,
    "48371": 0,
    "48373": 0,
    "48375": 24,
    "48377": 0,
    "48379": 0,
    "48381": 18,
    "48383": 0,
    "48385": 4,
    "48387": 0,
    "48389": 0,
    "48391": 0,
    "48393": 2,
    "48395": 0,
    "48397": 3,
    "48399": 2,
    "48401": 1,
    "48403": 2,
    "48405": 2,
    "48407": 5,
    "48409": 2,
    "48411": 0,
    "48413": 4,
    "48415": 1,
    "48417": 1,
    "48419": 1,
    "48421": 0,
    "48423": 6,
    "48425": 2,
    "48427": 0,
    "48429": 1,
    "48431": 0,
    "48433": 0,
    "48435": 0,
    "48437": 4,
    "48439": 109,
    "48441": 3,
    "48443": 0,
    "48445": 2,
    "48447": 0,
    "48449": 1,
    "48451": 9,
    "48453": 56,
    "48455": 2,
    "48457": 1,
    "48459": 1,
    "48461": 0,
    "48463": 9,
    "48465": 13,
    "48467": 9,
    "48469": 0,
    "48471": 3,
    "48473": 2,
    "48475": 0,
    "48477": 5,
    "48479": 7,
    "48481": 2,
    "48483": 4,
    "48485": 8,
    "48487": 4,
    "48489": 0,
    "48491": 38,
    "48493": 0,
    "48495": 0,
    "48497": 7,
    "48499": 1,
    "48501": 0,
    "48503": 2,
    "48505": 0,
    "48507": 0,
    "49001": 0.6666666666666666,
    "49003": 11.166666666666666,
    "49005": 3.5,
    "49007": 5.999999999999999,
    "49009": 1,
    "49011": 8.166666666666666,
    "49013": 12.666666666666664,
    "49015": 6.100000000000001,
    "49017": 7.833333333333332,
    "49019": 4,
    "49021": 0.6666666666666666,
    "49023": 21.06666666666667,
    "49025": 4.333333333333333,
    "49027": 4.3999999999999995,
    "49029": 4.5,
    "49031": 1,
    "49033": 3.5,
    "49035": 33.16666666666665,
    "49037": 2.6666666666666665,
    "49039": 15.066666666666668,
    "49041": 3.9,
    "49043": 30.833333333333332,
    "49045": 15,
    "49047": 12,
    "49049": 25.46666666666666,
    "49051": 24.333333333333336,
    "49053": 30.333333333333332,
    "49055": 0.5,
    "49057": 9.166666666666668,
    "50001": 8,
    "50003": 0,
    "50005": 6,
    "50007": 15,
    "50009": 4,
    "50011": 5,
    "50013": 2,
    "50015": 4,
    "50017": 3,
    "50019": 5,
    "50021": 17,
    "50023": 3,
    "50025": 1,
    "50027": 7,
    "51001": 9,
    "51003": 5,
    "51005": 2,
    "51007": 0,
    "51009": 4,
    "51011": 1,
    "51013": 2.333333333333333,
    "51015": 2,
    "51017": 0,
    "51019": 7,
    "51021": 0,
    "51023": 5,
    "51025": 2,
    "51027": 8,
    "51029": 2,
    "51031": 2,
    "51033": 0,
    "51035": 6,
    "51036": 0,
    "51037": 2,
    "51041": 2,
    "51043": 2,
    "51045": 0,
    "51047": 9,
    "51049": 0,
    "51051": 0,
    "51053": 1,
    "51057": 0,
    "51059": 10,
    "51061": 2,
    "51063": 0,
    "51065": 0,
    "51067": 1,
    "51069": 2,
    "51071": 2,
    "51073": 6,
    "51075": 2,
    "51077": 0,
    "51079": 0,
    "51081": 2,
    "51083": 5,
    "51085": 4,
    "51087": 3,
    "51089": 6,
    "51091": 1,
    "51093": 4,
    "51095": 3.666666666666666,
    "51097": 0,
    "51099": 0,
    "51101": 0,
    "51103": 0,
    "51105": 0,
    "51107": 2,
    "51109": 0,
    "51111": 0,
    "51113": 1,
    "51115": 0,
    "51117": 0,
    "51119": 0,
    "51121": 3,
    "51125": 0,
    "51127": 2,
    "51131": 3,
    "51133": 0,
    "51135": 1,
    "51137": 0,
    "51139": 0,
    "51141": 1,
    "51143": 4,
    "51145": 0,
    "51147": 0,
    "51149": 1.3333333333333333,
    "51153": 0.6666666666666666,
    "51155": 1,
    "51157": 0,
    "51159": 1,
    "51161": 0.6666666666666666,
    "51163": 0,
    "51165": 2,
    "51167": 0,
    "51169": 2,
    "51171": 1,
    "51173": 0,
    "51175": 1,
    "51177": 0,
    "51179": 4,
    "51181": 0,
    "51183": 5,
    "51185": 2,
    "51187": 2,
    "51191": 6,
    "51193": 0,
    "51195": 1,
    "51197": 9,
    "51199": 0,
    "51510": 1.3333333333333333,
    "51515": 0,
    "51520": 0,
    "51530": 0,
    "51540": 0,
    "51550": 3,
    "51570": 6,
    "51580": 1,
    "51590": 4,
    "51595": 1,
    "51600": 6,
    "51610": 2.333333333333333,
    "51620": 0,
    "51630": 1,
    "51640": 6,
    "51650": 0,
    "51660": 1,
    "51670": 1.3333333333333333,
    "51678": 0,
    "51680": 1,
    "51683": 0.6666666666666666,
    "51685": 0.6666666666666666,
    "51690": 3,
    "51700": 0,
    "51710": 2,
    "51720": 0,
    "51730": 1.3333333333333333,
    "51735": 0,
    "51740": 0,
    "51750": 1,
    "51760": 3,
    "51770": 2.6666666666666665,
    "51775": 1.6666666666666665,
    "51790": 0,
    "51800": 2,
    "51810": 11,
    "51820": 3,
    "51830": 1.3333333333333333,
    "51840": 1,
    "53001": 2.8,
    "53003": 0,
    "53005": 2,
    "53007": 12,
    "53009": 5,
    "53011": 8.666666666666668,
    "53013": 1,
    "53015": 2,
    "53017": 1.7999999999999998,
    "53019": 0,
    "53021": 2,
    "53023": 0,
    "53025": 2.8,
    "53027": 9,
    "53029": 1,
    "53031": 4.333333333333333,
    "53033": 10.999999999999998,
    "53035": 5.333333333333333,
    "53037": 0,
    "53039": 8,
    "53041": 6,
    "53043": 7.8,
    "53045": 4.333333333333333,
    "53047": 15.8,
    "53049": 7.333333333333333,
    "53051": 4.666666666666666,
    "53053": 18,
    "53055": 2,
    "53057": 1,
    "53059": 0.6666666666666666,
    "53061": 51,
    "53063": 14.666666666666666,
    "53065": 2.6666666666666665,
    "53067": 1,
    "53069": 7.333333333333333,
    "53071": 3,
    "53073": 5,
    "53075": 5,
    "53077": 12,
    "54001": 4,
    "54003": 0,
    "54005": 1,
    "54007": 0,
    "54009": 0,
    "54011": 7,
    "54013": 2,
    "54015": 0,
    "54017": 0,
    "54019": 2,
    "54021": 0,
    "54023": 1,
    "54025": 17,
    "54027": 0,
    "54029": 0,
    "54031": 0,
    "54033": 4,
    "54035": 7,
    "54037": 1,
    "54039": 22,
    "54041": 0,
    "54043": 5,
    "54045": 9,
    "54047": 6,
    "54049": 2,
    "54051": 2,
    "54053": 3,
    "54055": 4,
    "54057": 0,
    "54059": 1,
    "54061": 2,
    "54063": 2,
    "54065": 2,
    "54067": 0,
    "54069": 0,
    "54071": 1,
    "54073": 1,
    "54075": 1,
    "54077": 0,
    "54079": 3,
    "54081": 4,
    "54083": 3,
    "54085": 4,
    "54087": 3,
    "54089": 0,
    "54091": 1,
    "54093": 0,
    "54095": 0,
    "54097": 0,
    "54099": 7,
    "54101": 0,
    "54103": 0,
    "54105": 0,
    "54107": 4,
    "54109": 2,
    "55001": 2,
    "55003": 4,
    "55005": 10,
    "55007": 9,
    "55009": 10,
    "55011": 2,
    "55013": 3,
    "55015": 3,
    "55017": 4,
    "55019": 10,
    "55021": 22,
    "55023": 5,
    "55025": 44,
    "55027": 15,
    "55029": 3,
    "55031": 4,
    "55033": 5,
    "55035": 3,
    "55037": 4,
    "55039": 19,
    "55041": 0,
    "55043": 2,
    "55045": 2,
    "55047": 3,
    "55049": 4,
    "55051": 3,
    "55053": 4,
    "55055": 15,
    "55057": 10,
    "55059": 34,
    "55061": 2,
    "55063": 10,
    "55065": 4,
    "55067": 1,
    "55069": 0,
    "55071": 8,
    "55073": 4,
    "55075": 5,
    "55077": 4,
    "55078": 1,
    "55079": 141,
    "55081": 8,
    "55083": 2,
    "55085": 1,
    "55087": 2,
    "55089": 6,
    "55091": 0,
    "55093": 0,
    "55095": 0,
    "55097": 2,
    "55099": 0,
    "55101": 16,
    "55103": 3,
    "55105": 23,
    "55107": 0,
    "55109": 5,
    "55111": 11,
    "55113": 8,
    "55115": 0,
    "55117": 26,
    "55119": 3,
    "55121": 14,
    "55123": 15,
    "55125": 6,
    "55127": 8,
    "55129": 1,
    "55131": 19,
    "55133": 11,
    "55135": 0,
    "55137": 1,
    "55139": 7,
    "55141": 2,
    "56001": 10.666666666666668,
    "56003": 3,
    "56005": 4,
    "56007": 6,
    "56009": 0,
    "56011": 0,
    "56013": 17.166666666666664,
    "56015": 0,
    "56017": 1.6666666666666665,
    "56019": 6.666666666666667,
    "56021": 0.6666666666666666,
    "56023": 19.5,
    "56025": 1.6666666666666665,
    "56027": 0,
    "56029": 9.066666666666666,
    "56031": 2.6666666666666665,
    "56033": 5,
    "56035": 21.5,
    "56037": 2,
    "56039": 14.9,
    "56041": 0,
    "56043": 10.666666666666666,
    "56045": 0
  },
  {
    "1001": 96,
    "1003": 57,
    "1005": 17,
    "1007": 20,
    "1009": 59,
    "1011": 0,
    "1013": 7,
    "1015": 81,
    "1017": 6,
    "1019": 41,
    "1021": 6,
    "1023": 4,
    "1025": 17,
    "1027": 5,
    "1029": 1,
    "1031": 59,
    "1033": 45,
    "1035": 3,
    "1037": 8,
    "1039": 3,
    "1041": 0,
    "1043": 37,
    "1045": 40,
    "1047": 68,
    "1049": 67,
    "1051": 68,
    "1053": 5,
    "1055": 88,
    "1057": 31,
    "1059": 4,
    "1061": 16,
    "1063": 6,
    "1065": 86,
    "1067": 31,
    "1069": 22,
    "1071": 27,
    "1073": 1172,
    "1075": 21,
    "1077": 49,
    "1079": 30,
    "1081": 139,
    "1083": 142,
    "1085": 21,
    "1087": 5,
    "1089": 217,
    "1091": 15,
    "1093": 224,
    "1095": 111,
    "1097": 41,
    "1099": 6,
    "1101": 164,
    "1103": 15,
    "1105": 0,
    "1107": 52,
    "1109": 44,
    "1111": 1,
    "1113": 9,
    "1115": 56,
    "1117": 41,
    "1119": 10,
    "1121": 23,
    "1123": 67,
    "1125": 1103,
    "1127": 184,
    "1129": 11,
    "1131": 2,
    "1133": 71,
    "2013": 1,
    "2016": 0,
    "2020": 46.33333333333333,
    "2050": 2,
    "2060": 0,
    "2068": 6,
    "2070": 0,
    "2090": 6,
    "2100": 11,
    "2110": 15,
    "2122": 12,
    "2130": 0,
    "2150": 0.6666666666666666,
    "2164": 1.6666666666666665,
    "2170": 10.333333333333332,
    "2180": 7,
    "2185": 5,
    "2188": 3,
    "2201": 0,
    "2220": 0,
    "2232": 0,
    "2240": 1.3333333333333333,
    "2261": 4.666666666666666,
    "2270": 0,
    "2280": 0,
    "2282": 4,
    "2290": 7,
    "4001": 17.333333333333336,
    "4003": 56.5,
    "4005": 548.3333333333334,
    "4007": 20,
    "4009": 0.5,
    "4011": 0,
    "4012": 0,
    "4013": 84,
    "4015": 193,
    "4017": 20.333333333333336,
    "4019": 269.5,
    "4021": 160,
    "4023": 14.5,
    "4025": 32,
    "4027": 9,
    "5001": 12,
    "5003": 12,
    "5005": 51,
    "5007": 40,
    "5009": 29,
    "5011": 7,
    "5013": 0,
    "5015": 0,
    "5017": 4,
    "5019": 109,
    "5021": 4,
    "5023": 35,
    "5025": 1,
    "5027": 7,
    "5029": 31,
    "5031": 13,
    "5033": 64,
    "5035": 18,
    "5037": 24,
    "5039": 4,
    "5041": 28,
    "5043": 8,
    "5045": 229,
    "5047": 22,
    "5049": 6,
    "5051": 48,
    "5053": 9,
    "5055": 58,
    "5057": 9,
    "5059": 37,
    "5061": 15,
    "5063": 9,
    "5065": 55,
    "5067": 72,
    "5069": 21,
    "5071": 19,
    "5073": 6,
    "5075": 35,
    "5077": 1,
    "5079": 3,
    "5081": 5,
    "5083": 4,
    "5085": 24,
    "5087": 8,
    "5089": 14,
    "5091": 18,
    "5093": 18,
    "5095": 3,
    "5097": 32,
    "5099": 4,
    "5101": 8,
    "5103": 0,
    "5105": 0,
    "5107": 5,
    "5109": 1,
    "5111": 2,
    "5113": 39,
    "5115": 19,
    "5117": 11,
    "5119": 336,
    "5121": 7,
    "5123": 18,
    "5125": 86,
    "5127": 1,
    "5129": 0,
    "5131": 51,
    "5133": 12,
    "5135": 25,
    "5137": 14,
    "5139": 23,
    "5141": 112,
    "5143": 1566,
    "5145": 88,
    "5147": 4,
    "5149": 6,
    "6001": 24.666666666666664,
    "6003": 22.055555555555554,
    "6005": 45.612698412698414,
    "6007": 72.06666666666666,
    "6009": 27.8984126984127,
    "6011": 30.000000000000004,
    "6013": 20.666666666666664,
    "6015": 0,
    "6017": 40.91269841269841,
    "6019": 26,
    "6021": 14,
    "6023": 21,
    "6025": 5,
    "6027": 43,
    "6029": 10,
    "6031": 0,
    "6033": 20,
    "6035": 3.066666666666667,
    "6037": 211,
    "6039": 4,
    "6041": 18.666666666666668,
    "6043": 6,
    "6045": 4,
    "6047": 7,
    "6049": 0,
    "6051": 23,
    "6053": 21,
    "6055": 2.6666666666666665,
    "6057": 28.1984126984127,
    "6059": 74.66666666666667,
    "6061": 40.91269841269841,
    "6063": 1.0666666666666667,
    "6065": 420.6666666666667,
    "6067": 27.380952380952383,
    "6069": 0,
    "6071": 778,
    "6073": 1996.6666666666665,
    "6075": 68,
    "6077": 25.86666666666667,
    "6079": 14,
    "6081": 43,
    "6083": 370,
    "6085": 19.666666666666664,
    "6087": 39,
    "6089": 141.0666666666667,
    "6091": 14.222222222222221,
    "6093": 23,
    "6095": 28.380952380952383,
    "6097": 25.666666666666668,
    "6099": 14.2,
    "6101": 21.71428571428572,
    "6103": 119.06666666666669,
    "6105": 0,
    "6107": 10,
    "6109": 27.8984126984127,
    "6111": 81,
    "6113": 23.714285714285715,
    "6115": 25.6984126984127,
    "8001": 37.4,
    "8003": 3,
    "8005": 66.39999999999999,
    "8007": 6.142857142857142,
    "8009": 2,
    "8011": 11,
    "8013": 36.30952380952381,
    "8014": 33.06666666666667,
    "8015": 8.666666666666666,
    "8017": 2,
    "8019": 27.142857142857146,
    "8021": 2.6666666666666665,
    "8023": 6.666666666666667,
    "8025": 5,
    "8027": 3,
    "8029": 5.4,
    "8031": 41.4,
    "8033": 2.8095238095238093,
    "8035": 56.400000000000006,
    "8037": 33.33333333333333,
    "8039": 37,
    "8041": 94,
    "8043": 4,
    "8045": 570,
    "8047": 9.142857142857142,
    "8049": 31.64285714285714,
    "8051": 16.733333333333334,
    "8053": 7.542857142857143,
    "8055": 9.666666666666666,
    "8057": 4.5,
    "8059": 31.80952380952381,
    "8061": 4,
    "8063": 27,
    "8065": 5.666666666666666,
    "8067": 5.142857142857142,
    "8069": 118.5,
    "8071": 9.666666666666666,
    "8073": 22,
    "8075": 18,
    "8077": 543.0666666666667,
    "8079": 0.6666666666666666,
    "8081": 1.3333333333333333,
    "8083": 8.80952380952381,
    "8085": 11.133333333333333,
    "8087": 15,
    "8089": 0,
    "8091": 4.800000000000001,
    "8093": 18.142857142857142,
    "8095": 7,
    "8097": 36.33333333333333,
    "8099": 19,
    "8101": 20,
    "8103": 11.333333333333334,
    "8105": 0.6666666666666666,
    "8107": 1.3333333333333333,
    "8109": 5.666666666666666,
    "8111": 5.142857142857142,
    "8113": 6.60952380952381,
    "8115": 5,
    "8117": 12.142857142857142,
    "8119": 8,
    "8121": 4,
    "8123": 115,
    "8125": 10,
    "9001": 161,
    "9003": 42,
    "9005": 9,
    "9007": 6,
    "9009": 36,
    "9011": 23,
    "9013": 10,
    "9015": 4,
    "10001": 328,
    "10003": 649,
    "10005": 543,
    "11001": 701,
    "12001": 14,
    "12003": 5,
    "12005": 70,
    "12007": 6,
    "12009": 161,
    "12011": 354,
    "12013": 20,
    "12015": 18,
    "12017": 12,
    "12019": 10,
    "12021": 46,
    "12023": 15,
    "12027": 104,
    "12029": 0,
    "12031": 103,
    "12033": 88,
    "12035": 74,
    "12037": 2,
    "12039": 4,
    "12041": 2,
    "12043": 3,
    "12045": 4,
    "12047": 5,
    "12049": 15,
    "12051": 63,
    "12053": 5,
    "12055": 6,
    "12057": 104,
    "12059": 3,
    "12061": 13,
    "12063": 18,
    "12065": 0,
    "12067": 0,
    "12069": 58,
    "12071": 26,
    "12073": 8,
    "12075": 5,
    "12077": 0,
    "12079": 8,
    "12081": 31,
    "12083": 22,
    "12085": 19,
    "12086": 197,
    "12087": 125,
    "12089": 11,
    "12091": 93,
    "12093": 12,
    "12095": 127,
    "12097": 152,
    "12099": 311,
    "12101": 20,
    "12103": 182,
    "12105": 186,
    "12107": 31,
    "12109": 11,
    "12111": 13,
    "12113": 73,
    "12115": 74,
    "12117": 53,
    "12119": 20,
    "12121": 7,
    "12123": 9,
    "12125": 0,
    "12127": 153,
    "12129": 4,
    "12131": 12,
    "12133": 24,
    "13001": 14,
    "13003": 1,
    "13005": 7,
    "13007": 3,
    "13009": 3,
    "13011": 1,
    "13013": 9,
    "13015": 39,
    "13017": 1,
    "13019": 0,
    "13021": 2,
    "13023": 0,
    "13025": 2,
    "13027": 0,
    "13029": 17,
    "13031": 21,
    "13033": 8,
    "13035": 1,
    "13037": 5,
    "13039": 6,
    "13043": 4,
    "13045": 5,
    "13047": 38,
    "13049": 2,
    "13051": 58,
    "13053": 28,
    "13055": 3,
    "13057": 61,
    "13059": 4,
    "13061": 1,
    "13063": 22,
    "13065": 2,
    "13067": 28,
    "13069": 10,
    "13071": 2,
    "13073": 17,
    "13075": 49,
    "13077": 9,
    "13079": 17,
    "13081": 4,
    "13083": 29,
    "13085": 12,
    "13087": 8,
    "13089": 12,
    "13091": 10,
    "13093": 29,
    "13095": 34,
    "13097": 14,
    "13099": 14,
    "13101": 0,
    "13103": 8,
    "13105": 14,
    "13107": 2,
    "13109": 1,
    "13111": 8,
    "13113": 21,
    "13115": 30,
    "13117": 47,
    "13119": 2,
    "13121": 87,
    "13123": 23,
    "13125": 2,
    "13127": 4,
    "13129": 24,
    "13131": 25,
    "13133": 0,
    "13135": 44,
    "13137": 2,
    "13139": 101,
    "13141": 4,
    "13143": 8,
    "13145": 7,
    "13147": 6,
    "13149": 5,
    "13151": 4,
    "13153": 16,
    "13155": 1,
    "13157": 4,
    "13159": 0,
    "13161": 0,
    "13163": 9,
    "13165": 2,
    "13167": 12,
    "13169": 0,
    "13171": 13,
    "13173": 0,
    "13175": 10,
    "13177": 0,
    "13179": 20,
    "13181": 13,
    "13183": 26,
    "13185": 13,
    "13187": 65,
    "13189": 16,
    "13191": 9,
    "13193": 0,
    "13195": 5,
    "13197": 0,
    "13199": 9,
    "13201": 15,
    "13205": 381,
    "13207": 12,
    "13209": 1,
    "13211": 7,
    "13213": 25,
    "13215": 8,
    "13217": 2,
    "13219": 0,
    "13221": 0,
    "13223": 6,
    "13225": 3,
    "13227": 11,
    "13229": 2,
    "13231": 3,
    "13233": 16,
    "13235": 0,
    "13237": 8,
    "13239": 1,
    "13241": 3,
    "13243": 8,
    "13245": 56,
    "13247": 2,
    "13249": 0,
    "13251": 12,
    "13253": 9,
    "13255": 6,
    "13257": 0,
    "13259": 0,
    "13261": 30,
    "13263": 1,
    "13265": 0,
    "13267": 2,
    "13269": 7,
    "13271": 0,
    "13273": 0,
    "13275": 5,
    "13277": 13,
    "13279": 3,
    "13281": 0,
    "13283": 0,
    "13285": 14,
    "13287": 28,
    "13289": 0,
    "13291": 1,
    "13293": 7,
    "13295": 31,
    "13297": 0,
    "13299": 2,
    "13301": 3,
    "13303": 0,
    "13305": 1,
    "13307": 3,
    "13309": 0,
    "13311": 77,
    "13313": 4,
    "13315": 0,
    "13317": 2,
    "13319": 0,
    "13321": 35,
    "15001": 16,
    "15003": 122,
    "15005": 0,
    "15007": 60,
    "15009": 16,
    "16001": 74.66666666666667,
    "16003": 1.5,
    "16005": 3,
    "16007": 3,
    "16009": 8,
    "16011": 3,
    "16013": 0,
    "16015": 0,
    "16017": 21.666666666666668,
    "16019": 0,
    "16021": 14.666666666666666,
    "16023": 1,
    "16025": 2,
    "16027": 8.6,
    "16029": 0,
    "16031": 2,
    "16033": 1,
    "16035": 4,
    "16037": 3,
    "16039": 2.6666666666666665,
    "16041": 1,
    "16043": 1.2,
    "16045": 2.1,
    "16047": 1.3333333333333333,
    "16049": 7,
    "16051": 0,
    "16053": 1.3333333333333333,
    "16055": 37.666666666666664,
    "16057": 8,
    "16059": 5,
    "16061": 3,
    "16063": 0,
    "16065": 0,
    "16067": 0,
    "16069": 12,
    "16071": 0,
    "16073": 3.2666666666666666,
    "16075": 1.6,
    "16077": 0,
    "16079": 1,
    "16081": 0,
    "16083": 1.3333333333333333,
    "16085": 2.5,
    "16087": 5.1,
    "17001": 22,
    "17003": 4,
    "17005": 7,
    "17007": 4,
    "17009": 1,
    "17011": 0,
    "17013": 0,
    "17015": 3,
    "17017": 6,
    "17019": 54,
    "17021": 32,
    "17023": 6,
    "17025": 22,
    "17027": 14,
    "17029": 29,
    "17031": 140,
    "17033": 7,
    "17035": 10,
    "17037": 48,
    "17039": 12,
    "17041": 23,
    "17043": 93,
    "17045": 0,
    "17047": 5,
    "17049": 17,
    "17051": 0,
    "17053": 2,
    "17055": 47,
    "17057": 13,
    "17059": 13,
    "17061": 2,
    "17063": 40,
    "17065": 0,
    "17067": 1,
    "17069": 2,
    "17071": 1,
    "17073": 16,
    "17075": 12,
    "17077": 98,
    "17079": 8,
    "17081": 36,
    "17083": 0,
    "17085": 5,
    "17087": 16,
    "17089": 34,
    "17091": 7,
    "17093": 3,
    "17095": 41,
    "17097": 35,
    "17099": 58,
    "17101": 3,
    "17103": 8,
    "17105": 18,
    "17107": 35,
    "17109": 3,
    "17111": 9,
    "17113": 66,
    "17115": 60,
    "17117": 12,
    "17119": 239,
    "17121": 19,
    "17123": 6,
    "17125": 3,
    "17127": 85,
    "17129": 11,
    "17131": 0,
    "17133": 13,
    "17135": 6,
    "17137": 22,
    "17139": 6,
    "17141": 14,
    "17143": 29,
    "17145": 10,
    "17147": 15,
    "17149": 4,
    "17151": 8,
    "17153": 13,
    "17155": 5,
    "17157": 9,
    "17159": 4,
    "17161": 62,
    "17163": 313,
    "17165": 127,
    "17167": 110,
    "17169": 7,
    "17171": 6,
    "17173": 19,
    "17175": 1,
    "17177": 3,
    "17179": 180,
    "17181": 44,
    "17183": 41,
    "17185": 10,
    "17187": 1,
    "17189": 25,
    "17191": 90,
    "17193": 18,
    "17195": 9,
    "17197": 52,
    "17199": 89,
    "17201": 8,
    "17203": 17,
    "18001": 3,
    "18003": 14,
    "18005": 3,
    "18007": 4,
    "18009": 4,
    "18011": 72,
    "18013": 2,
    "18015": 26,
    "18017": 9,
    "18019": 6,
    "18021": 0,
    "18023": 7,
    "18025": 21,
    "18027": 33,
    "18029": 12,
    "18031": 3,
    "18033": 11,
    "18035": 7,
    "18037": 2,
    "18039": 28,
    "18041": 0,
    "18043": 2,
    "18045": 1,
    "18047": 1,
    "18049": 4,
    "18051": 23,
    "18053": 2,
    "18055": 4,
    "18057": 33,
    "18059": 3,
    "18061": 1,
    "18063": 24,
    "18065": 3,
    "18067": 41,
    "18069": 2,
    "18071": 17,
    "18073": 10,
    "18075": 2,
    "18077": 0,
    "18079": 4,
    "18081": 8,
    "18083": 49,
    "18085": 24,
    "18087": 4,
    "18089": 25,
    "18091": 29,
    "18093": 11,
    "18095": 20,
    "18097": 219,
    "18099": 11,
    "18101": 1,
    "18103": 3,
    "18105": 6,
    "18107": 4,
    "18109": 36,
    "18111": 1,
    "18113": 4,
    "18115": 0,
    "18117": 1,
    "18119": 6,
    "18121": 3,
    "18123": 12,
    "18125": 5,
    "18127": 6,
    "18129": 4,
    "18131": 3,
    "18133": 24,
    "18135": 0,
    "18137": 9,
    "18139": 8,
    "18141": 16,
    "18143": 21,
    "18145": 4,
    "18147": 1,
    "18149": 2,
    "18151": 8,
    "18153": 1,
    "18155": 0,
    "18157": 5,
    "18159": 3,
    "18161": 6,
    "18163": 264,
    "18165": 1,
    "18167": 0,
    "18169": 5,
    "18171": 0,
    "18173": 38,
    "18175": 0,
    "18177": 8,
    "18179": 0,
    "18181": 1,
    "18183": 5,
    "19001": 3,
    "19003": 4,
    "19005": 33,
    "19007": 3,
    "19009": 0,
    "19011": 8,
    "19013": 46,
    "19015": 6,
    "19017": 0,
    "19019": 8,
    "19021": 25,
    "19023": 51,
    "19025": 7,
    "19027": 89,
    "19029": 1,
    "19031": 4,
    "19033": 12,
    "19035": 0,
    "19037": 2,
    "19039": 5,
    "19041": 3,
    "19043": 16,
    "19045": 3,
    "19047": 1,
    "19049": 6,
    "19051": 0,
    "19053": 5,
    "19055": 2,
    "19057": 12,
    "19059": 2,
    "19061": 25,
    "19063": 0,
    "19065": 12,
    "19067": 7,
    "19069": 2,
    "19071": 6,
    "19073": 0,
    "19075": 1,
    "19077": 0,
    "19079": 7,
    "19081": 7,
    "19083": 22,
    "19085": 18,
    "19087": 5,
    "19089": 8,
    "19091": 38,
    "19093": 2,
    "19095": 14,
    "19097": 2,
    "19099": 3,
    "19101": 0,
    "19103": 70,
    "19105": 1,
    "19107": 3,
    "19109": 0,
    "19111": 4,
    "19113": 48,
    "19115": 7,
    "19117": 4,
    "19119": 0,
    "19121": 0,
    "19123": 1,
    "19125": 24,
    "19127": 23,
    "19129": 5,
    "19131": 0,
    "19133": 74,
    "19135": 2,
    "19137": 0,
    "19139": 25,
    "19141": 2,
    "19143": 13,
    "19145": 1,
    "19147": 0,
    "19149": 7,
    "19151": 0,
    "19153": 149,
    "19155": 11,
    "19157": 7,
    "19159": 0,
    "19161": 3,
    "19163": 102,
    "19165": 2,
    "19167": 12,
    "19169": 24,
    "19171": 0,
    "19173": 1,
    "19175": 5,
    "19177": 3,
    "19179": 63,
    "19181": 7,
    "19183": 28,
    "19185": 50,
    "19187": 2,
    "19189": 4,
    "19191": 26,
    "19193": 46,
    "19195": 2,
    "19197": 15,
    "20001": 11,
    "20003": 23,
    "20005": 4,
    "20007": 4,
    "20009": 76,
    "20011": 0,
    "20013": 8,
    "20015": 54,
    "20017": 9,
    "20019": 0,
    "20021": 48,
    "20023": 2,
    "20025": 0,
    "20027": 0,
    "20029": 8,
    "20031": 20,
    "20033": 2,
    "20035": 79,
    "20037": 40,
    "20039": 2,
    "20041": 15,
    "20043": 0,
    "20045": 70,
    "20047": 3,
    "20049": 0,
    "20051": 10,
    "20053": 17,
    "20055": 5,
    "20057": 14,
    "20059": 41,
    "20061": 20,
    "20063": 13,
    "20065": 0,
    "20067": 2,
    "20069": 0,
    "20071": 0,
    "20073": 12,
    "20075": 0,
    "20077": 25,
    "20079": 60,
    "20081": 0,
    "20083": 0,
    "20085": 3,
    "20087": 15,
    "20089": 2,
    "20091": 0,
    "20093": 2,
    "20095": 11,
    "20097": 66,
    "20099": 47,
    "20101": 0,
    "20103": 3,
    "20105": 0,
    "20107": 2,
    "20109": 2,
    "20111": 19,
    "20113": 14,
    "20115": 30,
    "20117": 0,
    "20119": 0,
    "20121": 2,
    "20123": 9,
    "20125": 29,
    "20127": 0,
    "20129": 2,
    "20131": 3,
    "20133": 13,
    "20135": 0,
    "20137": 3,
    "20139": 34,
    "20141": 12,
    "20143": 16,
    "20145": 1,
    "20147": 1,
    "20149": 1,
    "20151": 3,
    "20153": 19,
    "20155": 54,
    "20157": 32,
    "20159": 16,
    "20161": 18,
    "20163": 4,
    "20165": 0,
    "20167": 27,
    "20169": 58,
    "20171": 1,
    "20173": 432,
    "20175": 2,
    "20177": 117,
    "20179": 0,
    "20181": 72,
    "20183": 1,
    "20185": 3,
    "20187": 3,
    "20189": 0,
    "20191": 36,
    "20193": 60,
    "20195": 0,
    "20197": 20,
    "20199": 4,
    "20201": 20,
    "20203": 0,
    "20205": 5,
    "20207": 7,
    "20209": 92,
    "21001": 7,
    "21003": 12,
    "21005": 1,
    "21007": 14,
    "21009": 21,
    "21011": 9,
    "21013": 0,
    "21015": 1,
    "21017": 4,
    "21019": 136,
    "21021": 0,
    "21023": 3,
    "21025": 9,
    "21027": 9,
    "21029": 12,
    "21031": 1,
    "21033": 16,
    "21035": 28,
    "21037": 0,
    "21039": 3,
    "21041": 1,
    "21043": 2,
    "21045": 1,
    "21047": 123,
    "21049": 0,
    "21051": 1,
    "21053": 2,
    "21055": 10,
    "21057": 0,
    "21059": 160,
    "21061": 0,
    "21063": 12,
    "21065": 2,
    "21067": 16,
    "21069": 8,
    "21071": 8,
    "21073": 1,
    "21075": 18,
    "21077": 20,
    "21079": 3,
    "21081": 0,
    "21083": 39,
    "21085": 20,
    "21087": 0,
    "21089": 3,
    "21091": 0,
    "21093": 9,
    "21095": 3,
    "21097": 4,
    "21099": 22,
    "21101": 48,
    "21103": 6,
    "21105": 6,
    "21107": 106,
    "21109": 5,
    "21111": 28,
    "21113": 0,
    "21115": 23,
    "21117": 21,
    "21119": 2,
    "21121": 10,
    "21123": 3,
    "21125": 60,
    "21127": 13,
    "21129": 0,
    "21131": 0,
    "21133": 0,
    "21135": 23,
    "21137": 10,
    "21139": 5,
    "21141": 6,
    "21143": 14,
    "21145": 212,
    "21147": 2,
    "21149": 2,
    "21151": 36,
    "21153": 36,
    "21155": 4,
    "21157": 45,
    "21159": 4,
    "21161": 6,
    "21163": 25,
    "21165": 31,
    "21167": 10,
    "21169": 8,
    "21171": 0,
    "21173": 1,
    "21175": 80,
    "21177": 59,
    "21179": 5,
    "21181": 1,
    "21183": 2,
    "21185": 5,
    "21187": 6,
    "21189": 0,
    "21191": 6,
    "21193": 1,
    "21195": 12,
    "21197": 43,
    "21199": 21,
    "21201": 0,
    "21203": 6,
    "21205": 5,
    "21207": 0,
    "21209": 0,
    "21211": 4,
    "21213": 11,
    "21215": 1,
    "21217": 11,
    "21219": 9,
    "21221": 0,
    "21223": 10,
    "21225": 4,
    "21227": 6,
    "21229": 9,
    "21231": 2,
    "21233": 35,
    "21235": 12,
    "21237": 0,
    "21239": 0,
    "22001": 38,
    "22003": 0,
    "22005": 1,
    "22007": 0,
    "22009": 22,
    "22011": 15,
    "22013": 6,
    "22015": 110,
    "22017": 93,
    "22019": 53,
    "22021": 0,
    "22023": 10,
    "22025": 5,
    "22027": 13,
    "22029": 2,
    "22031": 11,
    "22033": 5,
    "22035": 2,
    "22037": 1,
    "22039": 18,
    "22041": 3,
    "22043": 19,
    "22045": 24,
    "22047": 1,
    "22049": 5,
    "22051": 21,
    "22053": 10,
    "22055": 52,
    "22057": 17,
    "22059": 21,
    "22061": 14,
    "22063": 10,
    "22065": 18,
    "22067": 5,
    "22069": 21,
    "22071": 188,
    "22073": 5,
    "22075": 0,
    "22077": 2,
    "22079": 25,
    "22081": 1,
    "22083": 4,
    "22085": 9,
    "22087": 1,
    "22089": 101,
    "22091": 0,
    "22093": 75,
    "22095": 21,
    "22097": 41,
    "22099": 11,
    "22101": 3,
    "22103": 78,
    "22105": 15,
    "22107": 3,
    "22109": 44,
    "22111": 5,
    "22113": 3,
    "22115": 3,
    "22117": 2,
    "22119": 5,
    "22121": 0,
    "22123": 4,
    "22125": 0,
    "22127": 14,
    "23001": 3,
    "23003": 24,
    "23005": 22,
    "23007": 14,
    "23009": 34,
    "23011": 4,
    "23013": 3,
    "23015": 2,
    "23017": 8,
    "23019": 134,
    "23021": 9,
    "23023": 0,
    "23025": 1,
    "23027": 0,
    "23029": 0,
    "23031": 23,
    "24001": 6,
    "24003": 160,
    "24005": 455.6666666666667,
    "24009": 320,
    "24011": 21,
    "24013": 35,
    "24015": 47,
    "24017": 206,
    "24019": 3,
    "24021": 27,
    "24023": 1,
    "24025": 38,
    "24027": 0,
    "24029": 14,
    "24031": 23,
    "24033": 189,
    "24035": 28,
    "24037": 310,
    "24039": 0,
    "24041": 92,
    "24043": 11,
    "24045": 1,
    "24047": 2,
    "24510": 211.33333333333334,
    "25001": 11,
    "25003": 23,
    "25005": 12,
    "25007": 0,
    "25009": 40,
    "25011": 57,
    "25013": 210,
    "25015": 23,
    "25017": 70,
    "25019": 2,
    "25021": 53,
    "25023": 91,
    "25025": 49,
    "25027": 132,
    "26001": 1,
    "26003": 4,
    "26005": 7,
    "26007": 1,
    "26009": 1,
    "26011": 5,
    "26013": 12,
    "26015": 1,
    "26017": 24,
    "26019": 2,
    "26021": 29,
    "26023": 16,
    "26025": 10,
    "26027": 20,
    "26029": 0,
    "26031": 3,
    "26033": 0,
    "26035": 3,
    "26037": 0,
    "26039": 1,
    "26041": 14,
    "26043": 16,
    "26045": 6,
    "26047": 1,
    "26049": 90,
    "26051": 6,
    "26053": 5,
    "26055": 1,
    "26057": 1,
    "26059": 2,
    "26061": 10,
    "26063": 23,
    "26065": 2,
    "26067": 8,
    "26069": 6,
    "26071": 0,
    "26073": 1,
    "26075": 4,
    "26077": 11,
    "26079": 2,
    "26081": 68,
    "26083": 0,
    "26085": 0,
    "26087": 29,
    "26089": 0,
    "26091": 30,
    "26093": 39,
    "26095": 0,
    "26097": 0,
    "26099": 157,
    "26101": 0,
    "26103": 68,
    "26105": 5,
    "26107": 16,
    "26109": 3,
    "26111": 26,
    "26113": 2,
    "26115": 65,
    "26117": 28,
    "26119": 1,
    "26121": 5,
    "26123": 0,
    "26125": 445,
    "26127": 37,
    "26129": 8,
    "26131": 6,
    "26133": 2,
    "26135": 4,
    "26137": 1,
    "26139": 65,
    "26141": 1,
    "26143": 1,
    "26145": 67,
    "26147": 39,
    "26149": 8,
    "26151": 23,
    "26153": 6,
    "26155": 32,
    "26157": 23,
    "26159": 3,
    "26161": 64,
    "26163": 1294,
    "26165": 0,
    "27001": 4,
    "27003": 16,
    "27005": 1,
    "27007": 0,
    "27009": 1,
    "27011": 12,
    "27013": 1,
    "27015": 18,
    "27017": 7,
    "27019": 4,
    "27021": 10,
    "27023": 0,
    "27025": 0,
    "27027": 2,
    "27029": 0,
    "27031": 5,
    "27033": 19,
    "27035": 5,
    "27037": 20,
    "27039": 1,
    "27041": 7,
    "27043": 3,
    "27045": 9,
    "27047": 23,
    "27049": 5,
    "27051": 1,
    "27053": 125,
    "27055": 34,
    "27057": 5,
    "27059": 1,
    "27061": 4,
    "27063": 6,
    "27065": 3,
    "27067": 5,
    "27069": 2,
    "27071": 0,
    "27073": 1,
    "27075": 8,
    "27077": 4,
    "27079": 35,
    "27081": 0,
    "27083": 8,
    "27085": 25,
    "27087": 0,
    "27089": 0,
    "27091": 0,
    "27093": 7,
    "27095": 0,
    "27097": 26,
    "27099": 15,
    "27101": 3,
    "27103": 7,
    "27105": 20,
    "27107": 6,
    "27109": 92,
    "27111": 11,
    "27113": 0,
    "27115": 10,
    "27117": 0,
    "27119": 3,
    "27121": 2,
    "27123": 441,
    "27125": 1,
    "27127": 1,
    "27129": 6,
    "27131": 1,
    "27133": 4,
    "27135": 1,
    "27137": 83,
    "27139": 1,
    "27141": 1,
    "27143": 0,
    "27145": 56,
    "27147": 1,
    "27149": 0,
    "27151": 8,
    "27153": 1,
    "27155": 0,
    "27157": 8,
    "27159": 28,
    "27161": 1,
    "27163": 27,
    "27165": 0,
    "27167": 0,
    "27169": 17,
    "27171": 8,
    "27173": 15,
    "28001": 14,
    "28003": 37,
    "28005": 2,
    "28007": 11,
    "28009": 8,
    "28011": 39,
    "28013": 2,
    "28015": 0,
    "28017": 29,
    "28019": 60,
    "28021": 2,
    "28023": 18,
    "28025": 2,
    "28027": 25,
    "28029": 47,
    "28031": 29,
    "28033": 123,
    "28035": 193,
    "28037": 0,
    "28039": 14,
    "28041": 31,
    "28043": 19,
    "28045": 0,
    "28047": 1,
    "28049": 41,
    "28051": 46,
    "28053": 12,
    "28055": 0,
    "28057": 5,
    "28059": 7,
    "28061": 12,
    "28063": 1,
    "28065": 3,
    "28067": 76,
    "28069": 35,
    "28071": 27,
    "28073": 46,
    "28075": 54,
    "28077": 9,
    "28079": 6,
    "28081": 40,
    "28083": 0,
    "28085": 14,
    "28087": 74,
    "28089": 22,
    "28091": 55,
    "28093": 38,
    "28095": 64,
    "28097": 3,
    "28099": 3,
    "28101": 8,
    "28103": 9,
    "28105": 22,
    "28107": 26,
    "28109": 27,
    "28111": 1,
    "28113": 4,
    "28115": 51,
    "28117": 34,
    "28119": 26,
    "28121": 111,
    "28123": 6,
    "28125": 4,
    "28127": 28,
    "28129": 10,
    "28131": 8,
    "28133": 3,
    "28135": 7,
    "28137": 15,
    "28139": 7,
    "28141": 3,
    "28143": 1,
    "28145": 24,
    "28147": 8,
    "28149": 15,
    "28151": 14,
    "28153": 2,
    "28155": 23,
    "28157": 0,
    "28159": 86,
    "28161": 2,
    "28163": 61,
    "29001": 15,
    "29003": 14,
    "29005": 0,
    "29007": 5,
    "29009": 12,
    "29011": 18,
    "29013": 0,
    "29015": 48,
    "29017": 44,
    "29019": 264,
    "29021": 20,
    "29023": 106,
    "29025": 12,
    "29027": 41,
    "29029": 34,
    "29031": 72,
    "29033": 0,
    "29035": 11,
    "29037": 12,
    "29039": 42,
    "29041": 0,
    "29043": 16,
    "29045": 1,
    "29047": 19,
    "29049": 2,
    "29051": 10,
    "29053": 0,
    "29055": 59,
    "29057": 0,
    "29059": 43,
    "29061": 8,
    "29063": 10,
    "29065": 0,
    "29067": 0,
    "29069": 5,
    "29071": 165,
    "29073": 5,
    "29075": 1,
    "29077": 690,
    "29079": 4,
    "29081": 4,
    "29083": 21,
    "29085": 20,
    "29087": 0,
    "29089": 0,
    "29091": 6,
    "29093": 24,
    "29095": 28,
    "29097": 1213,
    "29099": 27,
    "29101": 8,
    "29103": 0,
    "29105": 45,
    "29107": 0,
    "29109": 52,
    "29111": 14,
    "29113": 50,
    "29115": 0,
    "29117": 0,
    "29119": 23,
    "29121": 2,
    "29123": 13,
    "29125": 2,
    "29127": 7,
    "29129": 0,
    "29131": 1,
    "29133": 11,
    "29135": 0,
    "29137": 2,
    "29139": 13,
    "29141": 5,
    "29143": 19,
    "29145": 217,
    "29147": 0,
    "29149": 0,
    "29151": 0,
    "29153": 0,
    "29155": 149,
    "29157": 63,
    "29159": 32,
    "29161": 9,
    "29163": 2,
    "29165": 9,
    "29167": 9,
    "29169": 9,
    "29171": 2,
    "29173": 1,
    "29175": 28,
    "29177": 0,
    "29179": 4,
    "29181": 12,
    "29183": 162,
    "29185": 2,
    "29186": 146,
    "29187": 136,
    "29189": 5777,
    "29195": 8,
    "29197": 0,
    "29199": 3,
    "29201": 88,
    "29203": 0,
    "29205": 6,
    "29207": 50,
    "29209": 14,
    "29211": 0,
    "29213": 45,
    "29215": 14,
    "29217": 6,
    "29219": 96,
    "29221": 141,
    "29223": 43,
    "29225": 52,
    "29227": 0,
    "29229": 4,
    "29510": 5120,
    "30001": 23,
    "30003": 3,
    "30005": 0,
    "30007": 0,
    "30009": 0,
    "30011": 0,
    "30013": 10,
    "30015": 0,
    "30017": 3,
    "30019": 0,
    "30021": 10,
    "30023": 7,
    "30025": 7,
    "30027": 3,
    "30029": 20.333333333333332,
    "30031": 15.2,
    "30033": 1,
    "30035": 5,
    "30037": 0,
    "30039": 9.666666666666668,
    "30041": 1,
    "30043": 2,
    "30045": 0,
    "30047": 22.33333333333333,
    "30049": 11,
    "30051": 0,
    "30053": 8.999999999999998,
    "30055": 8,
    "30057": 1,
    "30059": 0,
    "30061": 10.666666666666666,
    "30063": 69.33333333333333,
    "30065": 0,
    "30067": 7.2,
    "30069": 1,
    "30071": 10,
    "30073": 2,
    "30075": 0,
    "30077": 9,
    "30079": 0,
    "30081": 50.666666666666664,
    "30083": 8,
    "30085": 10,
    "30087": 5,
    "30089": 20.999999999999996,
    "30091": 3,
    "30093": 2,
    "30095": 0,
    "30097": 0,
    "30099": 0,
    "30101": 8,
    "30103": 0,
    "30105": 16,
    "30107": 0,
    "30109": 2,
    "30111": 7,
    "31001": 24,
    "31003": 0,
    "31005": 4,
    "31007": 4,
    "31009": 0,
    "31011": 4,
    "31013": 3,
    "31015": 0,
    "31017": 2,
    "31019": 30,
    "31021": 2,
    "31023": 8,
    "31025": 15,
    "31027": 3,
    "31029": 4,
    "31031": 1,
    "31033": 38,
    "31035": 0,
    "31037": 0,
    "31039": 4,
    "31041": 8,
    "31043": 3,
    "31045": 1,
    "31047": 24,
    "31049": 5,
    "31051": 1,
    "31053": 6,
    "31055": 123,
    "31057": 0,
    "31059": 4,
    "31061": 0,
    "31063": 2,
    "31065": 0,
    "31067": 32,
    "31069": 0,
    "31071": 1,
    "31073": 4,
    "31075": 0,
    "31077": 0,
    "31079": 32,
    "31081": 6,
    "31083": 0,
    "31085": 0,
    "31087": 0,
    "31089": 6,
    "31091": 0,
    "31093": 0,
    "31095": 3,
    "31097": 0,
    "31099": 2,
    "31101": 13,
    "31103": 7,
    "31105": 8,
    "31107": 5,
    "31109": 47,
    "31111": 30,
    "31113": 2,
    "31115": 0,
    "31117": 2,
    "31119": 2,
    "31121": 0,
    "31123": 6,
    "31125": 0,
    "31127": 0,
    "31129": 0,
    "31131": 3,
    "31133": 0,
    "31135": 7,
    "31137": 14,
    "31139": 1,
    "31141": 17,
    "31143": 19,
    "31145": 46,
    "31147": 0,
    "31149": 0,
    "31151": 8,
    "31153": 14,
    "31155": 13,
    "31157": 39,
    "31159": 40,
    "31161": 19,
    "31163": 0,
    "31165": 1,
    "31167": 37,
    "31169": 10,
    "31171": 0,
    "31173": 2,
    "31175": 0,
    "31177": 4,
    "31179": 23,
    "31181": 0,
    "31183": 2,
    "31185": 1,
    "32001": 16,
    "32003": 1421,
    "32005": 25.133333333333333,
    "32007": 9,
    "32009": 7,
    "32011": 3,
    "32013": 78,
    "32015": 4,
    "32017": 14,
    "32019": 93.80000000000001,
    "32021": 57,
    "32023": 17,
    "32027": 16,
    "32029": 18.8,
    "32031": 49.13333333333333,
    "32033": 1,
    "32510": 26.133333333333333,
    "33001": 49,
    "33003": 8,
    "33005": 25,
    "33007": 41,
    "33009": 8,
    "33011": 23,
    "33013": 13,
    "33015": 64,
    "33017": 30,
    "33019": 5,
    "34001": 130,
    "34003": 30,
    "34005": 547,
    "34007": 579,
    "34009": 103,
    "34011": 19,
    "34013": 21,
    "34015": 65,
    "34017": 3,
    "34019": 75,
    "34021": 245,
    "34023": 301,
    "34025": 1023,
    "34027": 94,
    "34029": 574,
    "34031": 21,
    "34033": 62,
    "34035": 137,
    "34037": 68,
    "34039": 39,
    "34041": 56,
    "35001": 27.5,
    "35003": 20,
    "35005": 15,
    "35006": 3,
    "35007": 18,
    "35009": 48,
    "35011": 0,
    "35013": 9,
    "35015": 41,
    "35017": 3,
    "35019": 0,
    "35021": 0,
    "35023": 4,
    "35025": 8,
    "35027": 16,
    "35028": 0.6666666666666666,
    "35029": 0,
    "35031": 7,
    "35033": 3,
    "35035": 4,
    "35037": 45,
    "35039": 4.666666666666666,
    "35041": 4,
    "35043": 30.166666666666668,
    "35045": 17,
    "35047": 40.666666666666664,
    "35049": 23.666666666666668,
    "35051": 0,
    "35053": 31,
    "35055": 1,
    "35057": 28.166666666666668,
    "35059": 5,
    "35061": 17.5,
    "36001": 31,
    "36003": 38,
    "36005": 28,
    "36007": 21,
    "36009": 3,
    "36011": 6,
    "36013": 4,
    "36015": 6,
    "36017": 2,
    "36019": 13,
    "36021": 8,
    "36023": 19,
    "36025": 13,
    "36027": 22,
    "36029": 91,
    "36031": 23,
    "36033": 1,
    "36035": 14,
    "36037": 6,
    "36039": 13,
    "36041": 0,
    "36043": 1,
    "36045": 1,
    "36047": 43,
    "36049": 0,
    "36051": 4,
    "36053": 1,
    "36055": 81,
    "36057": 2,
    "36059": 312,
    "36061": 86,
    "36063": 27,
    "36065": 22,
    "36067": 30,
    "36069": 11,
    "36071": 47,
    "36073": 0,
    "36075": 4,
    "36077": 20,
    "36079": 11,
    "36081": 67,
    "36083": 116,
    "36085": 4,
    "36087": 14,
    "36089": 3,
    "36091": 154,
    "36093": 13,
    "36095": 5,
    "36097": 3,
    "36099": 1,
    "36101": 11,
    "36103": 572,
    "36105": 8,
    "36107": 8,
    "36109": 6,
    "36111": 8,
    "36113": 41,
    "36115": 2,
    "36117": 2,
    "36119": 34,
    "36121": 5,
    "36123": 1,
    "37001": 5,
    "37003": 2,
    "37005": 14,
    "37007": 0,
    "37009": 2,
    "37011": 0,
    "37013": 91,
    "37015": 65,
    "37017": 23,
    "37019": 15,
    "37021": 14,
    "37023": 26,
    "37025": 5,
    "37027": 49,
    "37029": 0,
    "37031": 8,
    "37033": 6,
    "37035": 5,
    "37037": 6,
    "37039": 0,
    "37041": 1,
    "37043": 0,
    "37045": 18,
    "37047": 77,
    "37049": 12,
    "37051": 117,
    "37053": 2,
    "37055": 20,
    "37057": 28,
    "37059": 2,
    "37061": 32,
    "37063": 5,
    "37065": 0,
    "37067": 13,
    "37069": 9,
    "37071": 16,
    "37073": 2,
    "37075": 3,
    "37077": 7,
    "37079": 71,
    "37081": 7,
    "37083": 4,
    "37085": 29,
    "37087": 10,
    "37089": 31,
    "37091": 7,
    "37093": 2,
    "37095": 1,
    "37097": 9,
    "37099": 11,
    "37101": 79,
    "37103": 8,
    "37105": 42,
    "37107": 27,
    "37109": 17,
    "37111": 5,
    "37113": 22,
    "37115": 3,
    "37117": 28,
    "37119": 32,
    "37121": 5,
    "37123": 0,
    "37125": 3,
    "37127": 6,
    "37129": 37,
    "37131": 0,
    "37133": 134,
    "37135": 8,
    "37137": 4,
    "37139": 5,
    "37141": 60,
    "37143": 0,
    "37145": 2,
    "37147": 196,
    "37149": 8,
    "37151": 31,
    "37153": 1,
    "37155": 35,
    "37157": 41,
    "37159": 12,
    "37161": 22,
    "37163": 27,
    "37165": 1,
    "37167": 7,
    "37169": 4,
    "37171": 16,
    "37173": 1,
    "37175": 16,
    "37177": 2,
    "37179": 4,
    "37181": 1,
    "37183": 119,
    "37185": 3,
    "37187": 4,
    "37189": 8,
    "37191": 13,
    "37193": 5,
    "37195": 20,
    "37197": 2,
    "37199": 1,
    "38001": 3,
    "38003": 6,
    "38005": 0,
    "38007": 7,
    "38009": 12,
    "38011": 14,
    "38013": 2,
    "38015": 65,
    "38017": 27,
    "38019": 0,
    "38021": 8,
    "38023": 0,
    "38025": 9,
    "38027": 4,
    "38029": 5,
    "38031": 2,
    "38033": 3,
    "38035": 33,
    "38037": 10,
    "38039": 1,
    "38041": 6,
    "38043": 18,
    "38045": 10,
    "38047": 5,
    "38049": 0,
    "38051": 0,
    "38053": 53,
    "38055": 24,
    "38057": 8,
    "38059": 20,
    "38061": 2,
    "38063": 2,
    "38065": 4,
    "38067": 6,
    "38069": 0,
    "38071": 4,
    "38073": 0,
    "38075": 8,
    "38077": 2,
    "38079": 3,
    "38081": 0,
    "38083": 4,
    "38085": 29,
    "38087": 0,
    "38089": 14,
    "38091": 0,
    "38093": 26,
    "38095": 0,
    "38097": 1,
    "38099": 1,
    "38101": 33,
    "38103": 2,
    "38105": 19,
    "39001": 2,
    "39003": 3,
    "39005": 10,
    "39007": 10,
    "39009": 21,
    "39011": 2,
    "39013": 5,
    "39015": 3,
    "39017": 20,
    "39019": 6,
    "39021": 4,
    "39023": 4,
    "39025": 21,
    "39027": 0,
    "39029": 3,
    "39031": 0,
    "39033": 7,
    "39035": 108,
    "39037": 1,
    "39039": 0,
    "39041": 16,
    "39043": 14,
    "39045": 4,
    "39047": 4,
    "39049": 40,
    "39051": 0,
    "39053": 4,
    "39055": 24,
    "39057": 104,
    "39059": 3,
    "39061": 137,
    "39063": 22,
    "39065": 0,
    "39067": 0,
    "39069": 5,
    "39071": 1,
    "39073": 10,
    "39075": 9,
    "39077": 21,
    "39079": 1,
    "39081": 2,
    "39083": 10,
    "39085": 49,
    "39087": 4,
    "39089": 7,
    "39091": 9,
    "39093": 12,
    "39095": 19,
    "39097": 34,
    "39099": 16,
    "39101": 12,
    "39103": 11,
    "39105": 6,
    "39107": 28,
    "39109": 5,
    "39111": 0,
    "39113": 28,
    "39115": 0,
    "39117": 5,
    "39119": 3,
    "39121": 1,
    "39123": 60,
    "39125": 19,
    "39127": 1,
    "39129": 7,
    "39131": 5,
    "39133": 14,
    "39135": 30,
    "39137": 3,
    "39139": 12,
    "39141": 8,
    "39143": 18,
    "39145": 9,
    "39147": 11,
    "39149": 1,
    "39151": 12,
    "39153": 21,
    "39155": 47,
    "39157": 6,
    "39159": 6,
    "39161": 17,
    "39163": 0,
    "39165": 30,
    "39167": 11,
    "39169": 24,
    "39171": 3,
    "39173": 45,
    "39175": 4,
    "40001": 0,
    "40003": 1,
    "40005": 43,
    "40007": 4,
    "40009": 56,
    "40011": 9,
    "40013": 8,
    "40015": 23,
    "40017": 152,
    "40019": 49,
    "40021": 19,
    "40023": 6,
    "40025": 7,
    "40027": 637,
    "40029": 1,
    "40031": 22,
    "40033": 21,
    "40035": 16,
    "40037": 6,
    "40039": 15,
    "40041": 27,
    "40043": 6,
    "40045": 4,
    "40047": 2,
    "40049": 9,
    "40051": 151,
    "40053": 1,
    "40055": 0,
    "40057": 0,
    "40059": 16,
    "40061": 3,
    "40063": 0,
    "40065": 11,
    "40067": 1,
    "40069": 5,
    "40071": 30,
    "40073": 78,
    "40075": 2,
    "40077": 4,
    "40079": 19,
    "40081": 39,
    "40083": 60,
    "40085": 20,
    "40087": 86,
    "40089": 7,
    "40091": 8,
    "40093": 10,
    "40095": 13,
    "40097": 14,
    "40099": 4,
    "40101": 6,
    "40103": 12,
    "40105": 2,
    "40107": 5,
    "40109": 2018,
    "40111": 0,
    "40113": 33,
    "40115": 178,
    "40117": 0,
    "40119": 26,
    "40121": 17,
    "40123": 12,
    "40125": 66,
    "40127": 0,
    "40129": 4,
    "40131": 9,
    "40133": 26,
    "40135": 13,
    "40137": 14,
    "40139": 25,
    "40141": 3,
    "40143": 1906,
    "40145": 4,
    "40147": 4,
    "40149": 21,
    "40151": 7,
    "40153": 73,
    "41001": 29,
    "41003": 7.333333333333333,
    "41005": 24,
    "41007": 13.600000000000001,
    "41009": 14.6,
    "41011": 2.333333333333333,
    "41013": 0,
    "41015": 3.333333333333333,
    "41017": 5,
    "41019": 1.3333333333333333,
    "41021": 0,
    "41023": 0,
    "41025": 0,
    "41027": 14,
    "41029": 2.6666666666666665,
    "41031": 138,
    "41033": 0.6666666666666666,
    "41035": 22.666666666666668,
    "41037": 2,
    "41039": 35.33333333333333,
    "41041": 12,
    "41043": 12.833333333333332,
    "41045": 0,
    "41047": 10,
    "41049": 10,
    "41051": 20.5,
    "41053": 3.5,
    "41055": 1,
    "41057": 11.600000000000001,
    "41059": 10,
    "41061": 13,
    "41063": 2,
    "41065": 2,
    "41067": 12.6,
    "41069": 1,
    "41071": 5.1000000000000005,
    "42001": 0,
    "42003": 392,
    "42005": 5,
    "42007": 6,
    "42009": 3,
    "42011": 353,
    "42013": 2,
    "42015": 4,
    "42017": 163,
    "42019": 11,
    "42021": 15,
    "42023": 0,
    "42025": 90,
    "42027": 6,
    "42029": 110,
    "42031": 21,
    "42033": 24,
    "42035": 33,
    "42037": 6,
    "42039": 27,
    "42041": 10,
    "42043": 6,
    "42045": 172,
    "42047": 15,
    "42049": 68,
    "42051": 0,
    "42053": 8,
    "42055": 0,
    "42057": 0,
    "42059": 0,
    "42061": 0,
    "42063": 6,
    "42065": 40,
    "42067": 0,
    "42069": 8,
    "42071": 28,
    "42073": 1,
    "42075": 162,
    "42077": 142,
    "42079": 115,
    "42081": 2,
    "42083": 1,
    "42085": 260,
    "42087": 4,
    "42089": 129,
    "42091": 102,
    "42093": 0,
    "42095": 117,
    "42097": 6,
    "42099": 0,
    "42101": 836,
    "42103": 4,
    "42105": 4,
    "42107": 1,
    "42109": 0,
    "42111": 18,
    "42113": 2,
    "42115": 2,
    "42117": 12,
    "42119": 1,
    "42121": 28,
    "42123": 10,
    "42125": 19,
    "42127": 3,
    "42129": 24,
    "42131": 15,
    "42133": 12,
    "44001": 0,
    "44003": 13,
    "44005": 0,
    "44007": 23,
    "44009": 6,
    "45001": 2,
    "45003": 27,
    "45005": 9,
    "45007": 18,
    "45009": 33,
    "45011": 5,
    "45013": 25,
    "45015": 46,
    "45017": 4,
    "45019": 41,
    "45021": 5,
    "45023": 1,
    "45025": 16,
    "45027": 24,
    "45029": 12,
    "45031": 18,
    "45033": 7,
    "45035": 11,
    "45037": 16,
    "45039": 27,
    "45041": 29,
    "45043": 19,
    "45045": 27,
    "45047": 2,
    "45049": 5,
    "45051": 74,
    "45053": 5,
    "45055": 24,
    "45057": 2,
    "45059": 4,
    "45061": 1,
    "45063": 21,
    "45065": 5,
    "45067": 4,
    "45069": 11,
    "45071": 10,
    "45073": 4,
    "45075": 12,
    "45077": 26,
    "45079": 54,
    "45081": 3,
    "45083": 19,
    "45085": 19,
    "45087": 2,
    "45089": 13,
    "45091": 13,
    "46003": 2,
    "46005": 6,
    "46007": 2,
    "46009": 0,
    "46011": 3,
    "46013": 21,
    "46015": 4,
    "46017": 0,
    "46019": 13,
    "46021": 5,
    "46023": 2,
    "46025": 5,
    "46027": 4,
    "46029": 18,
    "46031": 6,
    "46033": 5,
    "46035": 45,
    "46037": 16,
    "46039": 0,
    "46041": 2,
    "46043": 13,
    "46045": 4,
    "46047": 2,
    "46049": 0,
    "46051": 2,
    "46053": 1,
    "46055": 0,
    "46057": 14,
    "46059": 2,
    "46061": 29,
    "46063": 0,
    "46065": 4,
    "46067": 6,
    "46069": 0,
    "46071": 5,
    "46073": 3,
    "46075": 2,
    "46077": 6,
    "46079": 2,
    "46081": 10,
    "46083": 23,
    "46085": 5,
    "46087": 151,
    "46089": 5,
    "46091": 0,
    "46093": 13,
    "46095": 1,
    "46097": 1,
    "46099": 189,
    "46101": 4,
    "46103": 37,
    "46105": 0,
    "46107": 0,
    "46109": 2,
    "46111": 0,
    "46113": 3,
    "46115": 4,
    "46117": 1,
    "46119": 2,
    "46121": 1,
    "46123": 2,
    "46125": 2,
    "46127": 1,
    "46129": 6,
    "46135": 4,
    "46137": 7,
    "47001": 0,
    "47003": 9,
    "47005": 7,
    "47007": 10,
    "47009": 13,
    "47011": 259,
    "47013": 0,
    "47015": 6,
    "47017": 30,
    "47019": 0,
    "47021": 1,
    "47023": 7,
    "47025": 18,
    "47027": 3,
    "47029": 1,
    "47031": 28,
    "47033": 7,
    "47035": 63,
    "47037": 235,
    "47039": 2,
    "47041": 1,
    "47043": 11,
    "47045": 102,
    "47047": 8,
    "47049": 16,
    "47051": 3,
    "47053": 55,
    "47055": 9,
    "47057": 0,
    "47059": 109,
    "47061": 0,
    "47063": 1,
    "47065": 184,
    "47067": 0,
    "47069": 7,
    "47071": 34,
    "47073": 0,
    "47075": 7,
    "47077": 43,
    "47079": 38,
    "47081": 9,
    "47083": 0,
    "47085": 3,
    "47087": 21,
    "47089": 2,
    "47091": 3,
    "47093": 2,
    "47095": 0,
    "47097": 12,
    "47099": 84,
    "47101": 3,
    "47103": 11,
    "47105": 0,
    "47107": 36,
    "47109": 10,
    "47111": 44,
    "47113": 245,
    "47115": 10,
    "47117": 9,
    "47119": 16,
    "47121": 0,
    "47123": 5,
    "47125": 68,
    "47127": 4,
    "47129": 37,
    "47131": 10,
    "47133": 19,
    "47135": 0,
    "47137": 5,
    "47139": 1,
    "47141": 8,
    "47143": 6,
    "47145": 3,
    "47147": 10,
    "47149": 160,
    "47151": 1,
    "47153": 3,
    "47155": 6,
    "47157": 430,
    "47159": 17,
    "47161": 5,
    "47163": 10,
    "47165": 204,
    "47167": 4,
    "47169": 5,
    "47171": 1,
    "47173": 1,
    "47175": 0,
    "47177": 9,
    "47179": 1,
    "47181": 14,
    "47183": 16,
    "47185": 4,
    "47187": 9,
    "47189": 13,
    "48001": 22,
    "48003": 9,
    "48005": 16,
    "48007": 132,
    "48009": 4,
    "48011": 0,
    "48013": 1,
    "48015": 0,
    "48017": 14,
    "48019": 28,
    "48021": 127,
    "48023": 0,
    "48025": 4,
    "48027": 37,
    "48029": 1171,
    "48031": 10,
    "48033": 0,
    "48035": 6,
    "48037": 32,
    "48039": 24,
    "48041": 6,
    "48043": 3,
    "48045": 0,
    "48047": 2,
    "48049": 7,
    "48051": 2,
    "48053": 5,
    "48055": 729,
    "48057": 1,
    "48059": 33,
    "48061": 23,
    "48063": 2,
    "48065": 17,
    "48067": 3,
    "48069": 6,
    "48071": 6,
    "48073": 11,
    "48075": 14,
    "48077": 4,
    "48079": 0,
    "48081": 0,
    "48083": 4,
    "48085": 243,
    "48087": 1,
    "48089": 13,
    "48091": 1028,
    "48093": 1,
    "48095": 0,
    "48097": 52,
    "48099": 5,
    "48101": 24,
    "48103": 0,
    "48105": 20,
    "48107": 17,
    "48109": 1,
    "48111": 0,
    "48113": 2293,
    "48115": 1,
    "48117": 20,
    "48119": 0,
    "48121": 123,
    "48123": 1670,
    "48125": 2,
    "48127": 0,
    "48129": 10,
    "48131": 2,
    "48133": 21,
    "48135": 3,
    "48137": 15,
    "48139": 50,
    "48141": 13,
    "48143": 4,
    "48145": 0,
    "48147": 11,
    "48149": 22,
    "48151": 0,
    "48153": 2,
    "48155": 0,
    "48157": 91,
    "48159": 2,
    "48161": 5,
    "48163": 15,
    "48165": 4,
    "48167": 25,
    "48169": 26,
    "48171": 14,
    "48173": 1,
    "48175": 0,
    "48177": 936,
    "48179": 51,
    "48181": 163,
    "48183": 11,
    "48185": 0,
    "48187": 1131,
    "48189": 15,
    "48191": 13,
    "48193": 1,
    "48195": 2,
    "48197": 1,
    "48199": 2,
    "48201": 4910,
    "48203": 3,
    "48205": 12,
    "48207": 6,
    "48209": 235,
    "48211": 16,
    "48213": 20,
    "48215": 32,
    "48217": 24,
    "48219": 42,
    "48221": 216,
    "48223": 15,
    "48225": 41,
    "48227": 49,
    "48229": 2,
    "48231": 35,
    "48233": 32,
    "48235": 5,
    "48237": 0,
    "48239": 4,
    "48241": 20,
    "48243": 0,
    "48245": 192,
    "48247": 0,
    "48249": 2,
    "48251": 69,
    "48253": 2,
    "48255": 220,
    "48257": 34,
    "48259": 23,
    "48261": 4,
    "48263": 0,
    "48265": 42,
    "48267": 9,
    "48269": 0,
    "48271": 2,
    "48273": 2,
    "48275": 0,
    "48277": 41,
    "48279": 2,
    "48281": 1,
    "48283": 3,
    "48285": 364,
    "48287": 11,
    "48289": 1,
    "48291": 3,
    "48293": 31,
    "48295": 3,
    "48297": 4,
    "48299": 20,
    "48301": 3,
    "48303": 325,
    "48305": 57,
    "48307": 0,
    "48309": 40,
    "48311": 0,
    "48313": 8,
    "48315": 8,
    "48317": 0,
    "48319": 7,
    "48321": 13,
    "48323": 3,
    "48325": 99,
    "48327": 0,
    "48329": 3,
    "48331": 12,
    "48333": 1,
    "48335": 5,
    "48337": 38,
    "48339": 5,
    "48341": 47,
    "48343": 0,
    "48345": 4,
    "48347": 6,
    "48349": 25,
    "48351": 3,
    "48353": 29,
    "48355": 54,
    "48357": 7,
    "48359": 15,
    "48361": 24,
    "48363": 17,
    "48365": 3,
    "48367": 16,
    "48369": 6,
    "48371": 2,
    "48373": 2,
    "48375": 318,
    "48377": 0,
    "48379": 2,
    "48381": 35,
    "48383": 7,
    "48385": 89,
    "48387": 7,
    "48389": 2,
    "48391": 0,
    "48393": 0,
    "48395": 0,
    "48397": 13,
    "48399": 0,
    "48401": 7,
    "48403": 6,
    "48405": 1,
    "48407": 7,
    "48409": 7,
    "48411": 0,
    "48413": 0,
    "48415": 1,
    "48417": 0,
    "48419": 1,
    "48421": 14,
    "48423": 15,
    "48425": 23,
    "48427": 0,
    "48429": 6,
    "48431": 4,
    "48433": 1,
    "48435": 12,
    "48437": 8,
    "48439": 1459,
    "48441": 52,
    "48443": 9,
    "48445": 2,
    "48447": 8,
    "48449": 3,
    "48451": 26,
    "48453": 269,
    "48455": 10,
    "48457": 0,
    "48459": 4,
    "48461": 0,
    "48463": 111,
    "48465": 160,
    "48467": 130,
    "48469": 0,
    "48471": 10,
    "48473": 1,
    "48475": 1,
    "48477": 0,
    "48479": 0,
    "48481": 16,
    "48483": 36,
    "48485": 10,
    "48487": 9,
    "48489": 5,
    "48491": 39,
    "48493": 417,
    "48495": 2,
    "48497": 43,
    "48499": 8,
    "48501": 1,
    "48503": 15,
    "48505": 0,
    "48507": 47,
    "49001": 30.142857142857146,
    "49003": 168.75,
    "49005": 254.75,
    "49007": 3.333333333333333,
    "49009": 1,
    "49011": 138.75000000000003,
    "49013": 13.999999999999998,
    "49015": 4.733333333333333,
    "49017": 6.142857142857142,
    "49019": 9,
    "49021": 25.142857142857146,
    "49023": 169.13333333333333,
    "49025": 7.142857142857142,
    "49027": 20.8,
    "49029": 17.25,
    "49031": 1.1428571428571428,
    "49033": 8.75,
    "49035": 980.0833333333333,
    "49037": 1,
    "49039": 24.46666666666667,
    "49041": 4.800000000000001,
    "49043": 51.25000000000001,
    "49045": 856,
    "49047": 1,
    "49049": 178.06666666666666,
    "49051": 38.833333333333336,
    "49053": 66.14285714285714,
    "49055": 2.142857142857143,
    "49057": 161.25,
    "50001": 3,
    "50003": 4,
    "50005": 18,
    "50007": 9,
    "50009": 3,
    "50011": 5,
    "50013": 0,
    "50015": 0,
    "50017": 1,
    "50019": 2,
    "50021": 2,
    "50023": 10,
    "50025": 7,
    "50027": 5,
    "51001": 1,
    "51003": 15,
    "51005": 54,
    "51007": 4,
    "51009": 18,
    "51011": 7,
    "51013": 52.333333333333336,
    "51015": 2,
    "51017": 0,
    "51019": 1,
    "51021": 0,
    "51023": 16,
    "51025": 4,
    "51027": 0,
    "51029": 7,
    "51031": 16,
    "51033": 4,
    "51035": 33,
    "51036": 0,
    "51037": 1,
    "51041": 2,
    "51043": 6,
    "51045": 0,
    "51047": 7,
    "51049": 0,
    "51051": 0,
    "51053": 22,
    "51057": 25,
    "51059": 61,
    "51061": 2,
    "51063": 0,
    "51065": 0,
    "51067": 19,
    "51069": 6,
    "51071": 3,
    "51073": 26,
    "51075": 0,
    "51077": 4,
    "51079": 5,
    "51081": 3,
    "51083": 27,
    "51085": 2,
    "51087": 8,
    "51089": 19,
    "51091": 0,
    "51093": 6,
    "51095": 10.333333333333334,
    "51097": 0,
    "51099": 7,
    "51101": 0,
    "51103": 0,
    "51105": 1,
    "51107": 9,
    "51109": 0,
    "51111": 0,
    "51113": 0,
    "51115": 0,
    "51117": 0,
    "51119": 0,
    "51121": 2,
    "51125": 15,
    "51127": 0,
    "51131": 37,
    "51133": 9,
    "51135": 2,
    "51137": 3,
    "51139": 0,
    "51141": 2,
    "51143": 7,
    "51145": 0,
    "51147": 2,
    "51149": 4,
    "51153": 8.333333333333332,
    "51155": 9,
    "51157": 0,
    "51159": 6,
    "51161": 0,
    "51163": 1,
    "51165": 9,
    "51167": 0,
    "51169": 0,
    "51171": 8,
    "51173": 2,
    "51175": 1,
    "51177": 15,
    "51179": 6,
    "51181": 0,
    "51183": 8,
    "51185": 9,
    "51187": 15,
    "51191": 52,
    "51193": 0,
    "51195": 2,
    "51197": 12,
    "51199": 3,
    "51510": 45.33333333333333,
    "51515": 1,
    "51520": 0,
    "51530": 0,
    "51540": 161,
    "51550": 8,
    "51570": 21,
    "51580": 50,
    "51590": 4,
    "51595": 0,
    "51600": 45,
    "51610": 45.33333333333333,
    "51620": 0,
    "51630": 6,
    "51640": 29,
    "51650": 6,
    "51660": 7,
    "51670": 5,
    "51678": 0,
    "51680": 2,
    "51683": 5.333333333333333,
    "51685": 10.333333333333332,
    "51690": 9,
    "51700": 0,
    "51710": 10,
    "51720": 0,
    "51730": 9,
    "51735": 1,
    "51740": 2,
    "51750": 0,
    "51760": 2,
    "51770": 5,
    "51775": 0,
    "51790": 1,
    "51800": 216,
    "51810": 25,
    "51820": 1,
    "51830": 1.6666666666666665,
    "51840": 1,
    "53001": 68.4,
    "53003": 0,
    "53005": 23,
    "53007": 52,
    "53009": 4,
    "53011": 9,
    "53013": 1,
    "53015": 6,
    "53017": 35.4,
    "53019": 0,
    "53021": 23,
    "53023": 0,
    "53025": 68.4,
    "53027": 25,
    "53029": 1,
    "53031": 3.6666666666666665,
    "53033": 30.333333333333336,
    "53035": 10.666666666666668,
    "53037": 1,
    "53039": 26,
    "53041": 4,
    "53043": 31.4,
    "53045": 2.6666666666666665,
    "53047": 26.400000000000002,
    "53049": 2,
    "53051": 13.666666666666666,
    "53053": 47.33333333333333,
    "53055": 8,
    "53057": 10,
    "53059": 0,
    "53061": 15.333333333333334,
    "53063": 80.66666666666667,
    "53065": 10.666666666666668,
    "53067": 2,
    "53069": 3,
    "53071": 24,
    "53073": 36,
    "53075": 21,
    "53077": 29,
    "54001": 8,
    "54003": 12,
    "54005": 0,
    "54007": 1,
    "54009": 0,
    "54011": 2,
    "54013": 0,
    "54015": 0,
    "54017": 0,
    "54019": 11,
    "54021": 1,
    "54023": 0,
    "54025": 25,
    "54027": 5,
    "54029": 0,
    "54031": 2,
    "54033": 4,
    "54035": 6,
    "54037": 10,
    "54039": 15,
    "54041": 1,
    "54043": 1,
    "54045": 3,
    "54047": 2,
    "54049": 1,
    "54051": 3,
    "54053": 1,
    "54055": 12,
    "54057": 0,
    "54059": 4,
    "54061": 0,
    "54063": 3,
    "54065": 0,
    "54067": 0,
    "54069": 2,
    "54071": 2,
    "54073": 0,
    "54075": 0,
    "54077": 5,
    "54079": 13,
    "54081": 15,
    "54083": 14,
    "54085": 0,
    "54087": 4,
    "54089": 0,
    "54091": 0,
    "54093": 0,
    "54095": 0,
    "54097": 1,
    "54099": 1,
    "54101": 1,
    "54103": 0,
    "54105": 0,
    "54107": 23,
    "54109": 0,
    "55001": 47,
    "55003": 3,
    "55005": 36,
    "55007": 4,
    "55009": 33,
    "55011": 7,
    "55013": 16,
    "55015": 1,
    "55017": 4,
    "55019": 35,
    "55021": 49,
    "55023": 4,
    "55025": 478,
    "55027": 53,
    "55029": 10,
    "55031": 0,
    "55033": 15,
    "55035": 5,
    "55037": 0,
    "55039": 135,
    "55041": 0,
    "55043": 13,
    "55045": 19,
    "55047": 5,
    "55049": 8,
    "55051": 12,
    "55053": 10,
    "55055": 46,
    "55057": 58,
    "55059": 85,
    "55061": 2,
    "55063": 134,
    "55065": 25,
    "55067": 3,
    "55069": 5,
    "55071": 30,
    "55073": 14,
    "55075": 18,
    "55077": 2,
    "55078": 8,
    "55079": 537,
    "55081": 94,
    "55083": 3,
    "55085": 4,
    "55087": 34,
    "55089": 10,
    "55091": 6,
    "55093": 0,
    "55095": 1,
    "55097": 1,
    "55099": 2,
    "55101": 30,
    "55103": 3,
    "55105": 68,
    "55107": 31,
    "55109": 10,
    "55111": 36,
    "55113": 3,
    "55115": 17,
    "55117": 47,
    "55119": 2,
    "55121": 37,
    "55123": 15,
    "55125": 1,
    "55127": 38,
    "55129": 4,
    "55131": 40,
    "55133": 34,
    "55135": 5,
    "55137": 2,
    "55139": 13,
    "55141": 2,
    "56001": 53,
    "56003": 7,
    "56005": 29,
    "56007": 8,
    "56009": 0,
    "56011": 9,
    "56013": 43.66666666666667,
    "56015": 3,
    "56017": 1.6666666666666665,
    "56019": 14,
    "56021": 15,
    "56023": 22,
    "56025": 14,
    "56027": 0,
    "56029": 20.866666666666667,
    "56031": 1,
    "56033": 0,
    "56035": 28,
    "56037": 18,
    "56039": 68.2,
    "56041": 4,
    "56043": 0,
    "56045": 2
  }
];  
export { totalDamage };